import React, { useEffect, useMemo, useRef } from 'react';
import FormControl from '@mui/material/FormControl';
import { Label } from 'reactstrap';
import {
  CardContent,
  Card,
  FormControlLabel,
  InputAdornment,
  Paper,
  TextField,
  Box,
  createFilterOptions,
  Grid,
  Chip,
  CardActions,
  CircularProgress,
  styled,
  Slider,
  Stack,
  Button,
  Typography,
  Alert,
  Snackbar
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Switch from '@mui/material/Switch';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import MergeTypeIcon from '@mui/icons-material/LocalShippingSharp';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PaymentIcon from '@mui/icons-material/PaymentSharp';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useStyles } from './styles';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { MetaTags } from 'react-meta-tags';
import {
  AddLocation,
  CalculateDistance,
  GetAagencyUserDetails,
  GetLocationsJSON
} from '../../apis/Agency';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setClassDimensionsButton } from '../../Redux/ClassDimensionsBtnSlice';
import {
  setQuickQuoteRateValues,
  setQuickQuoteTLRateValues
} from '../../Redux/QuickQuoteRateSlice';
import {
  setQuickQuoteDeliveryCheckedRedux,
  setQuickQuotePickUpCheckedRedux
} from '../../Redux/QuickQuoteSwevicesSlice';
import { setClassRows } from '../../Redux/QuickQuoteAddedRows';
import { setDimensionRows } from '../../Redux/QuickQuoteDimenionsAddedRows';
import {
  setClassWeight,
  setDimensionsWeight
} from '../../Redux/QuickQuoteTotalWeightSlice';
import { base_url } from '../../apis/constants';
import ReactQuill from 'react-quill';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import { setQuickQuoteRateLoc } from '../../Redux/QuickQuoteRateSlice';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import 'react-datepicker/dist/react-datepicker.css';
import { DateRangeFilter } from '../CustomDatePicker/CustomDatePicker';
import {
  cleanHtmlString,
  formatNumberWithCommas
} from '../../apis/Utils';
import { getCoordinatesByAddress } from '../../apis/Utils';
import { ToastContainer } from 'react-toastify';
import dayjs from 'dayjs';
import AddressAutocomplete from '../Carriers/AddressAutocomplete';

function QuickQuote(props) {
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );
  const weightRefs = useRef([]);
  // For GrossWeight refs
  const grossWeightRefs = useRef([]);
  const [result, setResult] = useState([]);
  const [DBJson, setDBJson] = useState([]);
  const [ratesDisable, setRatesDisable] = useState(false);
  const [, setAddType] = useState('');
  const [, setZip] = useState('');
  const [, setState] = useState('');
  const [, setCountry] = useState('');
  const [totalNmbofUnits, setTotalNmbofUnits] = useState('');

  const [originOpenTimeValue] = useState(
    dayjs('2024-02-17T08:00').format('HH:mm') // Extract time part
  );
  const [originCloseTimeValue] = useState(
    dayjs('2024-02-17T16:00').format('HH:mm') // Extract time part
  );

  const handleSearch = async (query, apiRes, type) => {
    setGoogleQuery(query);
    const coordinates = await getCoordinatesByAddress(query);
    // const isMatch = coordinates.includes(apiRes[0]);
    setDBJson(apiRes);
    setAddType(type);

    if (coordinates) {
      setResult(coordinates);
      const uniqueResults = [...new Set(coordinates)];
      const updatedApiRes = [...new Set([...apiRes, ...uniqueResults])];
      setShipCity(updatedApiRes);
    } else {
      setResult([]);
    }
  };

  const today = new Date().toISOString().split('T')[0];
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const [shipCity, setShipCity] = useState([]);

  function parseTLFlowAddress(addressString) {
    if (!addressString) return {};

    const parts = addressString.trim().split(/\s+/);

    const countryCode = parts.pop(); // last = country
    const postalCodeParts = [];

    // Handle Canadian postal code with space (2 parts)
    if (
      parts.length >= 2 &&
      /^[A-Za-z]\d[A-Za-z]$/.test(parts[parts.length - 2]) &&
      /^\d[A-Za-z]\d$/.test(parts[parts.length - 1])
    ) {
      postalCodeParts.unshift(parts.pop());
      postalCodeParts.unshift(parts.pop());
    } else {
      postalCodeParts.unshift(parts.pop()); // normal ZIP or single block postal code
    }

    const postalCode = postalCodeParts.join(' ');
    const stateOrProvinceCode = parts.pop(); // now last = state
    const city = parts.join(' '); // rest = city

    return {
      city,
      stateOrProvinceCode,
      postalCode,
      countryCode
    };
  }

  const parseAddress = address => {
    if (typeof address !== 'string' || !address.trim()) {
      return { city: '', state: '', zip: '', countryCode: '' };
    }

    const addressParts = address.trim().split(/\s+/); // split by spaces safely

    if (addressParts.length < 4) {
      return { city: '', state: '', zip: '', countryCode: '' };
    }

    const countryCode = addressParts.pop();
    const zipCode = addressParts.pop();
    const state = addressParts.pop();
    const city = addressParts.join(' ');

    return { city, state, zip: zipCode, countryCode };
  };

  function isQueryZip(str) {
    // return str.length > 4;
    return (
      /^\d{5}(-\d{4})?$/.test(str) || // US ZIP (5-digit or ZIP+4)
      /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/.test(str) || // Canada (A1A1A1 format)
      /^\d{5}$/.test(str) // Mexico (5-digit only)
    );
  }

  const handleUSAddresses = (apiRes, type, squery) => {
    if (apiRes) {
      isQueryZip(squery) && handleSearch(squery, apiRes, type);
      // setGoogleQuery(squery);
      // setGoogleModal(true);
      // }
      setShipFromloading(false);
      setShipToloading(false);
      if (type === 'shipFrom') {
        setShipFromHoveredValue(apiRes[0]);
      } else {
        setShipToHoveredValue(apiRes[0]);
      }

      const uniqueResults = [...new Set(result)];

      const updatedApiRes = [...new Set([...apiRes, ...uniqueResults])];

      setShipCity(updatedApiRes);
    }
    // if (
    //   // apiRes.length === 0 &&
    //   isQueryZip(squery)
    // ) {
  };

  var layoutMode = document.body.getAttribute('data-layout-mode');
  const selectShipType = useRef(null);
  const selectLocations = useRef(null);
  const selectShipFrom = useRef([]);
  const selectShipTo = useRef([]);
  const enterWeight = useRef([]);
  const grossWeightRefsDelivery = useRef([]);

  const viewShipmentsData = useSelector(state => state.getShipments);
  const SelectedRates = useSelector(state => state.quickQuoteRate);
  const quickQuoteTLRates = useSelector(state => state.quickQuoteTLRate);
  const SelectedLoc = useSelector(
    state => state.quickQuoteLoc.QuickQuoteRateLoc
  );
  const AddedClassRows = useSelector(state => state.newAddedPersistedRows);
  const AddedDimensionsRows = useSelector(
    state => state.newAddedPersistedDimensionsRows
  );
  const getPickupOption = option =>
    SelectedRates?.pickupOptions?.[option] ?? false;

  const getDeliveryOption = option =>
    SelectedRates?.deliveryOptions?.[option] ?? false;

  const ServicesSwitchChecks = useSelector(
    state => state.quickQuoteServicesSlice
  );
  let PersistedPaymentType = SelectedRates?.paymentType;
  const ClassDimBtn = useSelector(state => state.classDimensionsBtn);
  const TotalClassPersistedWeight = useSelector(
    state => state.totalPersistedWeightLBS.ClassWeight
  );
  const TotalDimensionsPersistedWeight = useSelector(
    state => state.totalPersistedWeightLBS.DimensionsWeight
  );
  const selectedTableRowID = props?.location.state;
  const dispatch = useDispatch();

  const classes = useStyles();
  const [shipLocationValue, setShipLocationValue] = useState(
    SelectedRates?.location
      ? SelectedRates?.location
      : quickQuoteTLRates?.location
        ? quickQuoteTLRates?.location
        : ''
  );
  const [city, setCity] = useState(
    quickQuoteTLRates?.defaultLocation ? quickQuoteTLRates?.defaultLocation : ''
  );

  const [insidePickupSwitch, setInsidePickupSwitch] = useState(
    getPickupOption('inside')
  );
  const [liftgatePickupSwitch, setLiftgatePickupSwitch] = useState(
    getPickupOption('liftGateServices')
  );
  const [residentialPickupSwitch, setResidentialPickupSwitch] = useState(
    getPickupOption('residential')
  );
  const [limitedPickupAccessSwitch, setLimitedPickupAccessSwitch] = useState(
    getPickupOption('limitedAccess')
  );
  const [secureAccesPickupSwitch, setSecureAccesPickupSwitch] = useState(
    getPickupOption('secureAccess')
  );
  const [freezeProtectionPickupSwitch, setFreezeProtectionPickupSwitch] =
    useState(getPickupOption('freezeProtection'));
  const [overlengthPickupSwitch, setOverlengthPickupSwitch] = useState(
    getPickupOption('overLength')
  );

  const [insideDeliverySwitch, setInsideDeliverySwitch] = useState(
    getDeliveryOption('inside')
  );
  const [liftgateDeliverySwitch, setLiftgateDeliverySwitch] = useState(
    getDeliveryOption('liftGateServices')
  );
  const [residentialDeliverySwitch, setResidentialDeliverySwitch] = useState(
    getDeliveryOption('residential')
  );
  const [limitedDeliverySwitch, setLimitedDeliverySwitch] = useState(
    getDeliveryOption('limitedAccess')
  );
  const [secureAccesDeliverySwitch, setSecureAccesDeliverySwitch] = useState(
    getDeliveryOption('secureAccess')
  );

  const [
    callBeforeDeliveryServicesSwitch,
    setCallBeforeDeliveryServicesSwitch
  ] = useState(getDeliveryOption('callBeforeDelivery'));

  const LTLPaymentTypeArr = [
    'Outbound Prepaid',
    'Inbound Collect',
    'Third Party'
  ];
  const parcelPaymentTypeArr = ['Sender', 'Receiver', 'Third Party'];
  const [hazmatSwitch] = useState(
    SelectedRates?.isHazmat ? SelectedRates?.isHazmat : false
  );
  const [quotePermissionArr, setQuotePermissionArr] = useState([]);

  const [pickUpChecked, setPickUpChecked] = useState(false);
  const [overLengthValue, setOverLengthValue] = useState('');
  const [deliveryChecked, setDeliveryChecked] = useState(false);
  const [shipmentDate, setShipmentDate] = useState(new Date());
  const [deliveryDate, setDeliveryDate] = useState('');
  const [deliveryDateError, setDeliveryDateError] = useState(false);
  const DataToShow = viewShipmentsData.ShipmentDetails[selectedTableRowID];
  const [shipFromloading, setShipFromloading] = useState(false);
  const [shipToloading, setShipToloading] = useState(false);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);

  const ShipTypeArr = useMemo(() => {
    if (UserIsAdmin) {
      return ['LTL', 'TL', 'Parcel', 'LTL/Parcel'];
    } else {
      const arr = [];

      if (quotePermissionArr?.some(p => p.level1)) {
        arr.push('LTL');
      }

      if (quotePermissionArr?.some(p => p.level2)) {
        arr.push('TL');
      }
      if (quotePermissionArr?.some(p => p.level3)) {
        arr.push('Parcel');
      }

      if (quotePermissionArr?.some(p => p.level4)) {
        arr.push('LTL/Parcel');
      }

      return arr;
    }
  }, [quotePermissionArr]);

  const [, setGoogleQuery] = useState('');

  const LTLUnitTypeArr = ['Pallet', 'Tote', 'Box', 'Drum', 'Pail', 'Other'];
  const ParcelUnitTypeArr = ['Box', 'Envelope'];

  const [shipTypeValue, setShipTypeValue] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [TLValidationErrors, setTLValidationErrors] = useState([]);
  const [tempError, setTempError] = useState('');
  const [shipLocation, setShipLocation] = useState([]);
  const [userLocationsArr, setUserLocationsArr] = useState([]);
  const [shipLocationLoader, setShipLocationLoader] = useState(false);
  const [, setIsClearing] = useState(false);
  const [shipLocationID, setShipLocationID] = useState(
    SelectedRates?.locationId ? SelectedRates.locationId : 0
  );
  const [paymentTypeValue, setPaymentTypeValue] = useState(
    PersistedPaymentType === '0'
      ? 'Outbound Prepaid'
      : PersistedPaymentType === '1'
        ? 'Inbound Collect'
        : PersistedPaymentType === '2'
          ? 'Third Party'
          : 'Outbound Prepaid'
  );
  const [finalCommodityInfoApi, setFinalCommodityInfoApi] = useState(
    SelectedRates?.commodityInfo ? SelectedRates?.commodityInfo : []
  );
  const ClassArray = [
    '50',
    '55',
    '60',
    '65',
    '70',
    '77.5',
    '85',
    '92.5',
    '100',
    '110',
    '125',
    '150',
    '175',
    '200',
    '250',
    '300',
    '400',
    '500'
  ];

  const [classArrayValue] = useState(ClassArray[0]);
  const [dimensionsWeightLBS] = useState('');
  const [, setDimensionsWeightLBSErr] = useState(false);
  const [, setNmbOfunitsErr] = useState(false);
  const [nmbOfunits] = useState('');
  const [dimensions] = useState({
    Lenght: '',
    Width: '',
    Height: ''
  });
  const [dimensionsValueErr, setDimensionsValueErr] = useState({
    Lenght: false,
    Width: false,
    Height: false
  });
  const [CODAmount] = useState(
    SelectedRates?.codAmount ? SelectedRates.codAmount : ''
  );
  const [DeclaredValue] = useState(
    SelectedRates?.declaredValue ? SelectedRates.declaredValue : ''
  );
  const [getRateLoading] = useState(false);
  const [, setSelectClassErr] = useState(false);
  const [dimensionsErr] = useState(false);
  const history = useHistory();

  const [, setUnitTypeName] = useState('Pallet');
  const [newAddedDimensionsRow, setNewAddedDimensionsRow] = useState([]);
  const [multiPickupRows, setMultiPickupRows] = useState([]);
  const [multiDropsRows, setMultiDropsRows] = useState([]);
  const [grossWeightError, setGrossWeightError] = useState('');
  const [showWeightError, setShowWeightError] = useState(false);

  const [pickupRemarks, setPickupRemarks] = useState(
    quickQuoteTLRates?.pickupInstructions
      ? quickQuoteTLRates?.pickupInstructions
      : ''
  );
  const [deliveryRemarks, setDeliveryRemarks] = useState(
    quickQuoteTLRates?.deliveryInstructions
      ? quickQuoteTLRates?.deliveryInstructions
      : ''
  );

  const [multiDropsErrors, setMultiDropsErrors] = useState([]);
  const [newAddedClassRow, setNewAddedClassRow] = useState([]);
  const [totalLBSWeightClass, setTotalLBSWeightClass] = useState('');

  const [, setTotalLBSWeightDimensions] = useState('');
  const [totalDeliveryGrossWeight, setTotalDeliveryGrossWeight] = useState('');
  const [totalDimensionsWeightSum, setTotalDimensionsWeightSum] = useState(
    TotalDimensionsPersistedWeight
  );
  const [, setTotalClassWeightSum] = useState(
    TotalClassPersistedWeight
  );

  const [alignment] = useState(
    ClassDimBtn ? ClassDimBtn : 'Class'
  );
  const [, setIsOverLength] = useState(false);
  const TLequipmentArr = [
    'Reefer',
    'Bulk Tanker',
    'Dry Van 53ft',
    'Box Truck',
    'Sprinter',
    'Intermodal'
  ];
  const ShipFrom = [
    SelectedRates?.shipFrom?.city ?? '',
    SelectedRates?.shipFrom?.stateOrProvinceCode ?? '',
    SelectedRates?.shipFrom?.postalCode ?? '',
    SelectedRates?.shipFrom?.countryCode ?? ''
  ]
    .join(' ')
    .trim();

  const ShipTo = [
    SelectedRates?.shipTo?.city ?? '',
    SelectedRates?.shipTo?.stateOrProvinceCode ?? '',
    SelectedRates?.shipTo?.postalCode ?? '',
    SelectedRates?.shipTo?.countryCode ?? ''
  ]
    .join(' ')
    .trim();
  const UserLoggedInEmail = useSelector(state => state.userDetails.email);
  const [locationHoveredValue, setLocationHoveredValue] = useState(null);
  const [locationInputChange, setLocationInputChange] = useState(false);
  const [paymentTypeHoveredValue, setPaymentTypeHoveredValue] = useState(null);
  const [, setPaymentTypeInputChange] = useState(false);
  const [shipFromHoveredValue, setShipFromHoveredValue] = useState(null);
  const [shipToHoveredValue, setShipToHoveredValue] = useState(null);
  const [TLPickupMode, setTLPickupMode] = useState(
    quickQuoteTLRates?.TLPickupMode
      ? quickQuoteTLRates?.TLPickupMode
      : '1 Pickup - 1 Drop'
  );
  const [TLequipmentType, setTLequipmentType] = useState(
    quickQuoteTLRates?.equipmentType
      ? quickQuoteTLRates?.equipmentType
      : TLequipmentArr[2]
  );
  const [TLDriverType, setTLDriverType] = useState(
    quickQuoteTLRates?.serviceType ? quickQuoteTLRates?.serviceType : 'Solo'
  );
  const [temperature, setTemperature] = useState(
    quickQuoteTLRates?.temperature ? quickQuoteTLRates?.temperature : ''
  );
  const [unit, setUnit] = useState(
    quickQuoteTLRates?.unit ? quickQuoteTLRates?.unit : '°C'
  ); // default unit
  const [selectedLocation, setSelectedLocation] = useState(SelectedLoc || '');
  const [freightClassHoveredValue, setFreightClassHoveredValue] =
    useState(null);
  const [unitTypeHoveredValue, setUnitTypeHoveredValue] = useState(null);
  const [openShipFrom, setOpenShipFrom] = useState(false);
  const [openShipTo, setOpenShipTo] = useState(false);
  const [totalGrossWeight, setTotalGrossWeight] = useState();
  const [selectedOptions, setSelectedOptions] = useState('');
  const selectedLocDetails = userLocationsArr?.filter(
    items => items.id === shipLocationID
  );

  useEffect(() => {
    // Only set initial value if not already set
    if (!shipTypeValue) {
      const initialValue =
        quickQuoteTLRates?.shipmentType ||
        SelectedRates?.shipmentType ||
        (ShipTypeArr.length > 0 ? ShipTypeArr[0] : '');

      setShipTypeValue(initialValue);
      setSelectedOptions(initialValue);
    }
  }, [ShipTypeArr]); // Only depend on ShipTypeArr for initial setup

  // Separate effect for quickQuoteTLRates changes
  useEffect(() => {
    if (quickQuoteTLRates?.shipmentType) {
      setShipTypeValue(quickQuoteTLRates.shipmentType);
      setSelectedOptions(quickQuoteTLRates.shipmentType);
    }
  }, [quickQuoteTLRates]);

  // Separate effect for SelectedRates changes
  useEffect(() => {
    if (SelectedRates?.shipmentType && !quickQuoteTLRates?.shipmentType) {
      setShipTypeValue(SelectedRates.shipmentType);
      setSelectedOptions(SelectedRates.shipmentType);
    }
  }, [SelectedRates]);

  const isReefer = TLequipmentType === 'Reefer' ? true : false;

  const isFormDirty = () => {
    const excludedPickupKeys = [
      'pickupDate',
      // 'expPickDeliveryDate',
      'pickupOpenHours',
      'pickupCloseHours'
    ];
    const excludedPickupLineItemKeys = [
      'UnitTypeValue',
      'Class',
      'NmbOfUnits',
      'Pieces'
    ];

    const excludedDropKeys = [
      'deliveryOpenHours',
      'deliveryCloseHours',
      'expDropDeliveryDate'
    ];
    const excludedDropLineItemKeys = [
      'UnitTypeValue',
      'Class',
      'NmbOfUnits',
      'Pieces'
    ];

    const isPickupDirty = multiPickupRows.some(pickup =>
      Object.entries(pickup).some(([key, value]) => {
        if (excludedPickupKeys.includes(key)) return false;
        if (Array.isArray(value)) {
          return value.some(item =>
            Object.entries(item).some(
              ([innerKey, innerVal]) =>
                !excludedPickupLineItemKeys.includes(innerKey) &&
                innerVal !== '' &&
                innerVal !== 0 &&
                innerVal !== false
            )
          );
        }
        return value !== '' && value !== 0 && value !== false;
      })
    );

    const isDropDirty = multiDropsRows.some(drop =>
      Object.entries(drop).some(([key, value]) => {
        if (excludedDropKeys.includes(key)) return false;
        if (Array.isArray(value)) {
          return value.some(item =>
            Object.entries(item).some(
              ([innerKey, innerVal]) =>
                !excludedDropLineItemKeys.includes(innerKey) &&
                innerVal !== '' &&
                innerVal !== 0 &&
                innerVal !== false
            )
          );
        }
        return value !== '' && value !== 0 && value !== false;
      })
    );

    return isPickupDirty || isDropDirty;
  };
  useEffect(() => {
    if (props?.location?.state?.locationType === 'quickQuote') {
      setShipLocationValue(shipLocation[0]?.location?.split(': ')[1] || '');
      setSelectedLocation(shipLocation[0] || '');
      setShipLocationID(shipLocation[0]?.id);
    }
  }, [props?.location?.state?.locationType, shipLocation]);

  useEffect(() => {
    if (!shipLocationValue) return;
    const parsedAddress = parseAddress(shipLocationValue);
    const City = parsedAddress.city;
    const State = parsedAddress.state;
    const ZipCode = parsedAddress.zip;
    const CountryCode = parsedAddress.countryCode;
    if (paymentTypeValue === 'Outbound Prepaid') {
      setMultiPickupRows(prev =>
        prev.map((row, i) =>
          i === 0
            ? {
                ...row,
                pickupAddress: shipLocationValue ?? '',
                city: City ?? '',
                state: State ?? '',
                zip: ZipCode ?? '',
                country: CountryCode ?? '',
                address: selectedLocDetails[0]?.streetLines,
                company: selectedLocDetails[0]?.companyName ?? '',
                email:
                  selectedLocDetails[0]?.contactEmail?.split(',')[0].trim() ??
                  '',
                contactName: selectedLocDetails[0]?.contactName ?? '',
                phone: selectedLocDetails[0]?.contactPhone ?? ''
              }
            : row
        )
      );
    }
    if (paymentTypeValue === 'Inbound Collect') {
      setMultiDropsRows(prev =>
        prev.map((row, i) =>
          i === 0
            ? {
                ...row,
                dropAddress: shipLocationValue ?? '',
                city: City ?? '',
                state: State ?? '',
                zip: ZipCode ?? '',
                country: CountryCode ?? '',
                address: selectedLocDetails[0]?.streetLines,
                company: selectedLocDetails[0]?.companyName ?? '',
                email:
                  selectedLocDetails[0]?.contactEmail?.split(',')[0].trim() ??
                  '',
                contactName: selectedLocDetails[0]?.contactName ?? '',
                phone: selectedLocDetails[0]?.contactPhone ?? ''
              }
            : row
        )
      );
    }
  }, [shipLocationValue, paymentTypeValue, TLPickupMode]);

  const convertFlatToMultiDropRows = (
    apiDeliveryLineItems = [],
    LTLUnitTypeArr,
    shipTypeValue
  ) => {
    if (!Array.isArray(apiDeliveryLineItems))
      return { grouped: [], flatMapped: [] };

    const groupedByAddress = {};

    apiDeliveryLineItems.forEach(item => {
      const key = `${item.address}_${item.city}_${item.zip}`;
      if (!groupedByAddress[key]) {
        groupedByAddress[key] = [];
      }
      groupedByAddress[key].push(item);
    });

    const grouped = Object.values(groupedByAddress).map(group => {
      const firstItem = group[0];
      return {
        dropAddress: firstItem?.dropAddress || '',
        expDropDeliveryDate: new Date(firstItem?.expectedDeliveryDate) || '',
        deliveryOpenHours: firstItem?.openTime || '',
        deliveryCloseHours: firstItem?.closeTime || '',
        deliveryInstructions: firstItem?.deliveryInstructions,
        company: firstItem.company || '',
        address: firstItem.address || '',
        city: firstItem.city || '',
        state: firstItem.state || '',
        zip: firstItem.zip || '',
        country: firstItem.country || '',
        email: firstItem?.email ?? '',
        phone: firstItem?.phone ?? '',
        contactName: firstItem?.contactName ?? '',
        deliveryLineItems: group.map(item => {
          return {
            itemText: item?.itemText || '',
            Class: item.freightClass || '50',
            WeightLBS: item.netWeight?.toString() || '',
            GrossWeight: item.grossWeight?.toString() || '',
            UnitTypeValue: item.packagingType || LTLUnitTypeArr?.[0] || '',
            nmfc: item.nmfcClass || '',
            NmbOfUnits: item.pallets?.toString() || '1',
            Pieces: item.requestedQuantity?.toString() || '1',
            StackAble: item.isStackable ?? false,
            isHazmat: item.isHazmat ?? false,
            Length: item.length || 0,
            Width: item.width || 0,
            Height: item.height || 0
          };
        })
      };
    });

    return Object.values(grouped);
  };

  const convertFlatToMultiPickupRows = (apiFlatPickupLineItems = []) => {
    const grouped = {};

    apiFlatPickupLineItems.forEach(item => {
      const key = `${item.address}_${item.city}_${item.zip}`;
      if (!grouped[key]) {
        grouped[key] = {
          pickupAddress: item.pickupAddress || '',
          pickupDate: new Date(item.pickupDate) || '',
          expPickDeliveryDate: new Date(item.expectedDeliveryDate) || '',
          pickupOpenHours: item.openTime || '',
          pickupCloseHours: item.closeTime || '',
          isHazmat: item.isHazmat,
          pickupInstructions: item.pickupInstructions ?? '',
          company: item.company || '',
          address: item.address || '',
          city: item.city || '',
          state: item.state || '',
          zip: item.zip || '',
          country: item.country || '',
          email: item?.email ?? '',
          phone: item?.phone ?? '',
          contactName: item?.contactName ?? '',
          pickupLineItems: []
        };
      }

      grouped[key].pickupLineItems.push({
        itemText: item.itemText || '',
        Class: item.freightClass || '50',
        WeightLBS: item.netWeight?.toString() || '',
        GrossWeight: item.grossWeight?.toString() || '',
        UnitTypeValue: item.packagingType || '',
        nmfc: item.nmfcClass || '',
        NmbOfUnits: item.pallets?.toString() || '1',
        Pieces: item.requestedQuantity?.toString() || '1',
        StackAble: item.isStackable ?? false,
        Length: item.length || 0,
        Width: item.width || 0,
        Height: item.height || 0
      });
    });
    return Object.values(grouped);
  };
  useEffect(() => {
    const hasPickupData = quickQuoteTLRates?.pickupLineItems?.length > 0;
    const hasDropData = quickQuoteTLRates?.deliveryLineItems?.length > 0;

    if (hasPickupData || hasDropData) {
      if (hasPickupData) {
        const multiPickupRows = convertFlatToMultiPickupRows(
          quickQuoteTLRates.pickupLineItems
        );
        setMultiPickupRows(multiPickupRows);
      }

      if (hasDropData) {
        const multiDropsRows = convertFlatToMultiDropRows(
          quickQuoteTLRates.deliveryLineItems
        );
        setMultiDropsRows(multiDropsRows);
      }
    } else {
      // Set default values only when there's no API data
      setMultiDropsRows([
        {
          dropAddress: '',
          itemText: '',
          expDropDeliveryDate: deliveryDate,
          deliveryOpenHours: originOpenTimeValue,
          deliveryCloseHours: originCloseTimeValue,
          deliveryInstructions: '',
          company: '',
          address: '',
          city: '',
          state: '',
          zip: '',
          country: '',

          deliveryLineItems: [
            {
              itemText: '',
              Class: '50',
              WeightLBS: '',
              GrossWeight: '',
              UnitTypeValue: 'Pallet',
              nmfc: '',
              NmbOfUnits: '1',
              Pieces: '1',
              StackAble: false,
              Length: 0,
              Width: 0,
              Height: 0
            }
          ]
        }
      ]);

      setMultiPickupRows([
        {
          pickupAddress: '',
          pickupDate: shipmentDate,
          expPickDeliveryDate: '',
          pickupOpenHours: originOpenTimeValue,
          pickupCloseHours: originCloseTimeValue,
          pickupInstructions: '',
          isHazmat: false,
          company: '',
          address: '',
          city: '',
          state: '',
          zip: '',
          country: '',
          pickupLineItems: [
            {
              itemText: '',
              Class: '50',
              WeightLBS: '',
              GrossWeight: '',
              UnitTypeValue: 'Pallet',
              nmfc: '',
              NmbOfUnits: '1',
              Pieces: '1',
              StackAble: false,
              Length: 0,
              Width: 0,
              Height: 0
            }
          ]
        }
      ]);
    }
  }, [
    quickQuoteTLRates?.pickupLineItems,
    quickQuoteTLRates?.deliveryLineItems
  ]);

  const handleClearForm = () => {
    setIsClearing(true);
    setPaymentTypeValue('Outbound Prepaid');
    setPickupRemarks('');
    setDeliveryRemarks('');
    setShipLocationID('');
    setLocationHoveredValue('');
    setSelectedLocation('');
    setMultiPickupRows([
      {
        pickupAddress: '',
        pickupDate: shipmentDate,
        expPickDeliveryDate: '',
        pickupOpenHours: originOpenTimeValue,
        pickupCloseHours: originCloseTimeValue,
        isHazmat: false,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        pickupLineItems: [
          {
            itemText: '',
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: 'Pallet',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
    setTLequipmentType(TLequipmentArr[2]);
    setTLPickupMode('1 Pickup - 1 Drop');
    setTemperature('');
    setUnit('°C');
    setShipLocationValue('');
    setMultiDropsRows([
      {
        dropAddress: '',
        itemText: '',
        expDropDeliveryDate: '',
        deliveryOpenHours: originOpenTimeValue,
        deliveryCloseHours: originCloseTimeValue,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        deliveryLineItems: [
          {
            itemText: '',
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: LTLUnitTypeArr?.[0] ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
    dispatch(setQuickQuoteTLRateValues({}));
    dispatch(setQuickQuoteRateLoc(''));
    dispatch(setQuickQuoteRateValues({}));
    setIsClearing(false);
  };

  useEffect(() => {
    setNewAddedDimensionsRow([
      {
        Class: '50',
        itemText: '',
        WeightLBS: '',
        GrossWeight: '',
        UnitTypeValue: LTLUnitTypeArr?.[0] ?? '',
        nmfc: '',
        NmbOfUnits: '1',
        Pieces: '1',
        StackAble: false,
        Length: 0,
        Width: 0,
        Height: 0
      }
    ]);
    setNewAddedClassRow([
      {
        WeightLBS: '',
        Class: ClassArray?.[0] ?? '',
        NMFCnumber: ''
      }
    ]);
  }, []);

  // Add another useEffect for handling page refresh
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Clear the values when the page is being refreshed
      dispatch(setQuickQuoteRateValues(''));
      dispatch(setQuickQuoteRateLoc(''));
      dispatch(setQuickQuotePickUpCheckedRedux(false));
      dispatch(setQuickQuoteDeliveryCheckedRedux(false));
      // dispatch(setClassDimensionsButton(alignment));
      // dispatch(setClassRows(newAddedClassRow));
      // dispatch(setDimensionRows(newAddedDimensionsRow));
      dispatch(setClassWeight(''));
      dispatch(setDimensionsWeight(''));
    };

    // Attach the beforeunload event listener
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup function for removing the event listener
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const didInit = useRef(false);

  useEffect(() => {
    if (
      didInit.current ||
      !SelectedRates ||
      !Array.isArray(SelectedRates?.commodityInfo) ||
      SelectedRates?.commodityInfo.length === 0 ||
      !LTLUnitTypeArr?.length ||
      !ClassArray?.length
    ) {
      return;
    }

    didInit.current = true; // ✅ Prevent rerun

    const commodity = SelectedRates.commodityInfo[0];
    const dimensions = commodity?.dimensions || {};
    const pickupOptions = SelectedRates?.pickupOptions || {};
    const selectedLocationVal = SelectedRates?.location || '';

    setNewAddedDimensionsRow([
      {
        Class: commodity?.freightClass ?? '50',
        itemText: commodity?.itemText ?? '',
        WeightLBS: commodity?.weight?.value ?? '',
        GrossWeight: commodity?.grossWeight ?? '',
        UnitTypeValue: commodity?.packaging ?? LTLUnitTypeArr[0],
        nmfc: '',
        NmbOfUnits: commodity?.pallets ?? '1',
        Pieces: commodity?.pieces ?? '1',
        StackAble: dimensions?.isStackable ?? false,
        Length: dimensions?.length ?? 0,
        Width: dimensions?.width ?? 0,
        Height: dimensions?.height ?? 0
      }
    ]);

    setNewAddedClassRow([
      {
        WeightLBS: commodity?.weight?.value ?? '',
        Class: ClassArray[0],
        NMFCnumber: ''
      }
    ]);

    setIsOverLength(pickupOptions.overLength ?? false);
    setOverLengthValue(pickupOptions.overLengthValue ?? '');
    setTotalGrossWeight(TotalClassPersistedWeight);
    setSelectedOptions(
      quickQuoteTLRates?.shipmentType
        ? quickQuoteTLRates?.shipmentType
        : SelectedRates?.shipmentType
          ? SelectedRates?.shipmentType
          : 'LTL'
    );
    setShipLocationValue(selectedLocationVal);
    setShipFromFinalAddress(
      paymentTypeValue === 'Outbound Prepaid' ? selectedLocationVal : ''
    );

    setShipFromFinalValue(ShipFrom.includes('undefined') ? '' : ShipFrom);
    setShipToFinalValue(ShipTo.includes('undefined') ? '' : ShipTo);

    setShipToFinalAddress(
      ['Inbound Collect', 'Receiver'].includes(paymentTypeValue)
        ? selectedLocationVal
        : ''
    );

    setDeliveryDate(
      SelectedRates.deliveryDate ? new Date(SelectedRates.deliveryDate) : ''
    );

    setShipmentDate(
      SelectedRates.shipmentDate
        ? new Date(SelectedRates.shipmentDate)
        : new Date()
    );

    setPickUpChecked(ServicesSwitchChecks?.QuickQuotePickUpCheckedRedux ?? '');
    setDeliveryChecked(
      ServicesSwitchChecks?.QuickQuoteDeliveryCheckedRedux ?? false
    );
  }, [
    ClassArray,
    quickQuoteTLRates,
    LTLUnitTypeArr,
    SelectedLoc,
    TotalClassPersistedWeight,
    ServicesSwitchChecks,
    SelectedRates,
    paymentTypeValue,
    ShipTo,
    shipLocationValue,
    ShipFrom
  ]);

  useEffect(() => {
    setOpenShipFrom(false);
    setOpenShipTo(false);

    let ToalWeightLBS = 0;
    if (AddedClassRows) {
      for (let i = 0; i < AddedClassRows.length; i++) {
        ToalWeightLBS += parseInt(AddedClassRows[i].WeightLBS);
      }
      setTotalLBSWeightClass(ToalWeightLBS);
    }
  }, []);

  useEffect(() => {
    let ToalWeightLBS = 0;
    if (AddedDimensionsRows) {
      for (let i = 0; i < AddedDimensionsRows.length; i++) {
        ToalWeightLBS += parseInt(AddedDimensionsRows[i].WeightLBS);
      }
      setTotalLBSWeightDimensions(ToalWeightLBS);
    }
  }, []);

  const [carrierApiNames] = useState([]);
  const [ParcelCarrierApiNames] = useState([]);
  const [userPermissionsArr, setUserPermissionsArr] = useState([]);

  useEffect(() => {
    if (SelectedRates?.commodityInfo?.[0]?.weight?.value) {
      const copy1 = JSON.parse(JSON.stringify(AddedClassRows));
      setNewAddedClassRow(copy1);
      const copy2 = JSON.parse(JSON.stringify(AddedDimensionsRows));

      setNewAddedDimensionsRow(copy2);

      if (alignment === 'Dimensions') {
        setTotalDimensionsWeightSum(
          parseInt(SelectedRates.commodityInfo[0]?.weight?.value)
        );
      }

      if (alignment === 'Class') {
        setTotalClassWeightSum(
          parseInt(SelectedRates.commodityInfo[0]?.weight?.value)
        );
      }
    }
    let FinalObj = {};
    if (
      !ShipFrom.includes('undefined') &&
      (paymentTypeValue === 'Third Party' ||
        paymentTypeValue === 'Inbound Collect')
    ) {
      const tempData = ShipFrom;
      const parsedAddress = parseAddress(tempData);
      const City = parsedAddress.city;
      const State = parsedAddress.state;
      const ZipCode = parsedAddress.zip;
      const CountryCode = parsedAddress.countryCode;
      FinalObj = {
        City,
        State,
        ZipCode,
        CountryCode
      };
      setShipFromFinalAddress(FinalObj);
    }

    if (
      !ShipTo.includes('undefined') &&
      paymentTypeValue !== 'Inbound Collect'
    ) {
      const tempData = ShipTo;
      const parsedAddress = parseAddress(tempData);
      const City = parsedAddress.city;
      const State = parsedAddress.state;
      const ZipCode = parsedAddress.zip;
      const CountryCode = parsedAddress.countryCode;
      FinalObj = {
        City,
        State,
        ZipCode,
        CountryCode
      };

      setShipToFinalAddress(FinalObj);
    }
  }, []);

  useEffect(() => {
    const filteredCarrierPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Locations'
    );

    const filteredQuotePermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Quick Quote'
    );

    setUserPermissionsArr(filteredCarrierPermissions);
    setQuotePermissionArr(filteredQuotePermissions);
  }, [userRolePermissions]);

  const handleGetRates = e => {
    e.preventDefault();
    setDeliveryDateError(true);
    setOpenShipFrom(false);
    if (dimensionsErr) {
      if (!dimensionsWeightLBS) {
        setDimensionsWeightLBSErr(true);
      }
      if (!nmbOfunits) {
        setNmbOfunitsErr(true);
      }
      if (!dimensions.Lenght) {
        setDimensionsValueErr({ ...dimensionsValueErr, Lenght: true });
      }
      if (!dimensions.Width) {
        setDimensionsValueErr({ ...dimensionsValueErr, Width: true });
      }
      if (!dimensions.Height) {
        setDimensionsValueErr({ ...dimensionsValueErr, Height: true });
      }
    }
    if (!classArrayValue) {
      setSelectClassErr(true);
    } else if (classArrayValue) {
      setSelectClassErr(false);
      // setGetRateLoading(true);
      let OutbondShipper;
      let OutbondReciever;

      let ApiCityFrom = '';
      let ApiStateFrom = '';
      let ApiZipFrom = '';
      let ApiZipFromCountryCode = '';

      if (
        paymentTypeValue === 'Outbound Prepaid' &&
        // ||
        // paymentTypeValue === 'Sender') &&
        !shipFromFinalAddress.City
      ) {
        OutbondShipper = parseAddress(shipFromFinalAddress);
        ApiCityFrom =
          paymentTypeValue === 'Outbound Prepaid'
            ? // ||
              // paymentTypeValue === 'Sender'
              OutbondShipper.city
            : shipFromFinalAddress.City;
        ApiStateFrom =
          paymentTypeValue === 'Outbound Prepaid'
            ? // ||
              // paymentTypeValue === 'Sender'
              OutbondShipper.state
            : shipFromFinalAddress.State;
        ApiZipFrom =
          paymentTypeValue === 'Outbound Prepaid'
            ? // ||
              // paymentTypeValue === 'Sender'
              OutbondShipper.zip
            : shipFromFinalAddress.ZipCode;
        ApiZipFromCountryCode =
          paymentTypeValue === 'Outbound Prepaid'
            ? // ||
              // paymentTypeValue === 'Sender'
              OutbondShipper.countryCode
            : shipFromFinalAddress.CountryCode;
      } else {
        ApiCityFrom = shipFromFinalAddress.City;
        ApiStateFrom = shipFromFinalAddress.State;
        ApiZipFrom = shipFromFinalAddress.ZipCode;
        ApiZipFromCountryCode = shipFromFinalAddress.CountryCode;
      }

      let ApiCityTo = '';
      let ApiStateTo = '';
      let ApiZipTo = '';
      let ApiZipToCountryCode = '';
      if (
        paymentTypeValue === 'Inbound Collect' &&
        // || paymentTypeValue === 'Receiver'
        !shipToFinalAddress.City
      ) {
        OutbondReciever = parseAddress(shipToFinalAddress);

        ApiCityTo =
          paymentTypeValue === 'Inbound Collect'
            ? // || paymentTypeValue === 'Receiver'
              OutbondReciever.city
            : shipToFinalAddress.City;
        ApiStateTo =
          paymentTypeValue === 'Inbound Collect'
            ? // || paymentTypeValue === 'Receiver'
              OutbondReciever.state
            : shipToFinalAddress.State;
        ApiZipTo =
          paymentTypeValue === 'Inbound Collect'
            ? // ||paymentTypeValue === 'Receiver'
              OutbondReciever.zip
            : shipToFinalAddress.ZipCode;
        ApiZipToCountryCode =
          paymentTypeValue === 'Inbound Collect'
            ? // || paymentTypeValue === 'Receiver'
              OutbondReciever.countryCode
            : shipToFinalAddress.CountryCode;
      } else {
        ApiCityTo = shipToFinalAddress.City;
        ApiStateTo = shipToFinalAddress.State;
        ApiZipTo = shipToFinalAddress.ZipCode;
        ApiZipToCountryCode = shipToFinalAddress.CountryCode;
      }
      const selectedLocDetails = userLocationsArr?.filter(
        items => items.id === shipLocationID
      );

      const apiPickupLineItems = multiPickupRows.flatMap((row, index) =>
        row.pickupLineItems.map(item => ({
          itemText: item.itemText ?? '',
          pallets: Number(item.NmbOfUnits) || 0,
          requestedQuantity: Number(item.Pieces) || 0,
          netWeight: Number(item.WeightLBS) || 0,
          grossWeight: Number(item.GrossWeight) || 0,
          packagingType: item.UnitTypeValue ?? '',
          nmfcClass: item.nmfc ?? '',
          freightClass: item.Class ?? '',
          length: Number(item.Length) || 0,
          width: Number(item.Width) || 0,
          height: Number(item.Height) || 0,
          grossCharge: 0,
          isStackable: item.StackAble ?? false,
          isHazmat: row.isHazmat ?? false,
          company: row?.company ?? '',
          pickupAddress: row?.pickupAddress || '',
          email: row?.email ?? '',
          contactName: row?.contactName ?? '',
          phone: row?.phone ?? '',
          address: row.address ?? '',
          city: row.city ?? '',
          state: row.state ?? '',
          zip: row.zip ?? '',
          country: row.country ?? '',
          pickupDate: row.pickupDate
            ? new Date(row.pickupDate).toISOString()
            : new Date(),
          expectedDeliveryDate: row.expPickDeliveryDate
            ? row.expPickDeliveryDate
            : new Date(),
          openTime: row.pickupOpenHours ?? '',
          closeTime: row.pickupCloseHours ?? ''
        }))
      );

      const apiDeliveryLineItems = multiDropsRows.flatMap((row, index) => {
        const safeNumber = val => {
          if (typeof val === 'string') {
            val = val.replace(/,/g, ''); // Remove commas
          }
          const num = Number(val);
          return isNaN(num) ? 0 : num;
        };
        const itemDescrptions =
          multiPickupRows[0].pickupLineItems
            .map(items => items.itemDescription || items.itemText)
            .filter(Boolean)
            .join(', ') || '';
        return row.deliveryLineItems.map(item => ({
          itemText: itemDescrptions,
          pallets: TLPickupMode.includes('1 Drop')
            ? Number(totalNmbofUnits)
            : Number(item.NmbOfUnits) || 0,
          requestedQuantity: TLPickupMode.includes('1 Drop')
            ? Number(totalNmbofUnits)
            : Number(item.NmbOfUnits) || 0,
          netWeight: TLPickupMode.includes('1 Drop')
            ? Number(totalNetWeightLBS)
            : Number(item.WeightLBS),
          grossWeight: TLPickupMode.includes('1 Drop')
            ? safeNumber(totalGrossWeightLBS)
            : safeNumber(item.GrossWeight),
          packagingType: TLPickupMode.includes('1 Drop')
            ? multiPickupRows[0]?.pickupLineItems[0]?.UnitTypeValue
            : item.UnitTypeValue || '',
          nmfcClass: item.nmfc || '',
          freightClass: item.Class || '',
          length: Number(item.Length) || 0,
          width: Number(item.Width) || 0,
          height: Number(item.Height) || 0,
          grossCharge: 0,
          isStackable: item.StackAble ?? false,
          isHazmat: item.isHazmat ?? false,
          dropAddress: row?.dropAddress || '',
          company: row?.company ?? '',
          email: row?.email ?? '',
          contactName: row?.contactName ?? '',
          phone: row?.phone ?? '',
          address: row.address ?? '',
          city: row.city || '',
          state: row.state || '',
          zip: row.zip || '',
          country: row.country || '',
          pickupDate: row.expDropDeliveryDate || new Date().toISOString(),
          expectedDeliveryDate: row.expDropDeliveryDate,
          openTime: row.deliveryOpenHours || '',
          closeTime: row.deliveryCloseHours || ''
        }));
      });

      let TLquoteObj = {
        id: 0,
        defaultLocation: city,
        carrierId: 0,
        carrierName: '',
        carrierLogo: '',
        invoiceType: '',
        shipmentId: '',
        proNumber: '',
        TLPickupMode: TLPickupMode,
        temperature: temperature,
        pickupInstructions: cleanHtmlString(pickupRemarks) ?? '',
        deliveryInstructions: cleanHtmlString(deliveryRemarks) ?? '',
        unit: unit,
        orderDate: multiPickupRows[0]?.pickupDate,
        pickupDate: multiPickupRows[0]?.pickupDate,
        invoiceNumber: '',
        deliveryDate: multiDropsRows[0]?.expDropDeliveryDate,
        ExpectedDeliveryDate: multiDropsRows[0]?.expDropDeliveryDate,
        invoiceDate: multiDropsRows[0]?.expDropDeliveryDate,
        originCompany:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.companyName || ''
            : multiPickupRows[0]?.company || '',
        originAddress:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.streetLines || ''
            : multiPickupRows[0]?.address || '',
        originCity:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.city || ''
            : multiPickupRows[0]?.city || '',
        originState:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.stateOrProvinceCode || ''
            : multiPickupRows[0]?.state || '',
        originZip:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.postalCode || ''
            : multiPickupRows[0]?.zip || '',
        originCountry:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.countryCode || ''
            : multiPickupRows[0]?.country || '',
        originContactPerson:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.contactName || ''
            : multiPickupRows[0]?.contactName || '',
        originContactEmail:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.contactEmail?.split(',')[0] || ''
            : multiPickupRows[0]?.email || '',
        originContactPhone:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.contactPhone || ''
            : multiPickupRows[0]?.phone || '',

        destinationCompany:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.companyName || ''
            : multiDropsRows[multiDropsRows.length - 1]?.company || '',
        destinationAddress:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.streetLines || ''
            : multiDropsRows[multiDropsRows.length - 1]?.address || '',
        destinationCity:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.city || ''
            : multiDropsRows[multiDropsRows.length - 1]?.city || '',
        destinationState:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.stateOrProvinceCode || ''
            : multiDropsRows[multiDropsRows.length - 1]?.state || '',
        destinationZip:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.postalCode || ''
            : multiDropsRows[multiDropsRows.length - 1]?.zip || '',
        destinationCountry:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.countryCode || ''
            : multiDropsRows[multiDropsRows.length - 1]?.country || '',
        destinationContactPerson:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.contactName || ''
            : '',
        destinationContactEmail:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.contactEmail?.split(',')[0] || ''
            : '',
        destinationContactPhone:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.contactPhone || ''
            : '',
        billToCompany: '',
        billToAddress: '',
        billToCity: '',
        billToState: '',
        billToZip: '',
        billToCountry: '',
        shipmentType: 'TL',
        equipmentType: TLequipmentType,
        soNumber: '',
        clientPONumber: '',
        isHazmat: multiPickupRows[0]?.isHazmat || false,
        pickupLineItems: apiPickupLineItems,
        deliveryLineItems: apiDeliveryLineItems,
        pickupNumber: '',
        shipmentStatus: 'Saved',
        cargoValue: '',
        freightTerms: paymentTypeValue.replace(/\s+/g, ''),
        paymentTerms: paymentTypeValue,
        bolNumber: '',
        customerId: '',
        shippingNotes: pickupRemarks,
        billToContactPerson: '',
        billToContactEmail: '',
        billToContactPhone: '',
        locationName: selectedLocation?.location,
        location: shipLocationValue,
        locationId: shipLocationID,
        pickupStartTime: multiPickupRows[0]?.pickupOpenHours || '',
        pickupEndTime: multiPickupRows[0]?.pickupCloseHours || '',
        deliverStartTime:
          multiDropsRows[multiDropsRows.length - 1]?.deliveryOpenHours || '',
        deliverEndTime:
          multiDropsRows[multiDropsRows.length - 1]?.deliveryCloseHours || '',
        quoteId: 0,
        shipmentCharges: 0,
        actualPickupDate: '',
        actualDeliveryDate: '',
        sessionId: '',
        quoteNumber: '',
        dispatchInput1: '',
        lastUpdatedOn: '',
        serviceType: TLDriverType,
        totalNetWeight: totalNetWeightLBS ? totalNetWeightLBS : 0,
        totalGrossWeight: totalGrossWeightLBS ? totalGrossWeightLBS : 0,
        originTerminalAddress: '',
        originTerminalCity: '',
        originTerminalState: '',
        originTerminalPostalCode: '',
        originTerminalCountry: '',
        originTerminalContact: '',
        originTerminalContantEmail: '',
        originTerminalContactPhone: '',
        destinationTerminalAddress: '',
        destinationTerminalCity: '',
        destinationTerminalState: '',
        destinationTerminalPostalCode: '',
        destinationTerminalCountry: '',
        destinationTerminalContact: '',
        destinationTerminalContantEmail: '',
        destinationTerminalContactPhone: '',
        pickupOptions: {
          inside: false,
          liftGateServices: false,
          residential: false,
          secureAccess: false,
          limitedAccess: false,
          freezeProtection: false,
          overLength: false,
          callBeforeDelivery: false,
          overLengthValue: 0
        },
        deliveryOptions: {
          inside: false,
          liftGateServices: false,
          residential: false,
          secureAccess: false,
          limitedAccess: false
        },
        pickupOptionsAccessorial: '',
        deliveryOptionAccessorial: '',
        carrierBillToCompany: '',
        carrierBillToAddress: '',
        carrierBillToCity: '',
        carrierBillToState: '',
        carrierBillToZip: '',
        carrierBillToCountry: '',
        carrierBillToContactPerson: '',
        carrierBillToContactEmail: '',
        carrierBillToContactPhone: '',
        surcharges: '',
        surchargesList: '',
        estimatedTransitDays: 0,
        shipmentMiles: calDistanceValue,
        OriginData: '',
        destinationData: '',
        salesOrderNumber: '',
        purchaseOrderNumber: '',
        freightInvoiceNumber: ''
      };
      let obj = {
        shipmentType: shipTypeValue,
        locationFull: selectedLocation.location,
        location: shipLocationValue,
        paymentType:
          paymentTypeValue === 'Outbound Prepaid'
            ? '0'
            : paymentTypeValue === 'Inbound Collect'
              ? '1'
              : '2',
        shipFrom: {
          city: ApiCityFrom,
          stateOrProvinceCode: ApiStateFrom,
          postalCode: ApiZipFrom,
          countryCode: ApiZipFromCountryCode,
          residential: true,
          streetLines:
            paymentTypeValue === 'Outbound Prepaid'
              ? selectedLocDetails[0]?.streetLines
              : ''
        },
        shipTo: {
          city: ApiCityTo,
          stateOrProvinceCode: ApiStateTo,
          postalCode: ApiZipTo,
          countryCode: ApiZipToCountryCode,
          residential: true,
          streetLines:
            paymentTypeValue === 'Inbound Collect'
              ? selectedLocDetails[0]?.streetLines
              : ''
        },
        shipmentDate: new Date(),
        isHazmat: hazmatSwitch,
        commodityInfo: handlePushAddedCommodityInfo(),

        pickupOptions: {
          inside: insidePickupSwitch,
          liftGateServices: liftgatePickupSwitch,
          residential: residentialPickupSwitch,
          secureAccess: secureAccesPickupSwitch,
          limitedAccess: limitedPickupAccessSwitch,
          freezeProtection: freezeProtectionPickupSwitch,
          overLength: overlengthPickupSwitch,
          overLengthValue: overLengthValue ? parseFloat(overLengthValue) : 0,
          callBeforeDelivery: false
        },
        deliveryOptions: {
          inside: insideDeliverySwitch,
          liftGateServices: liftgateDeliverySwitch,
          residential: residentialDeliverySwitch,
          secureAccess: secureAccesDeliverySwitch,
          limitedAccess: limitedDeliverySwitch,
          freezeProtection: false,
          overLength: false,
          overLengthValue: 0,
          callBeforeDelivery: callBeforeDeliveryServicesSwitch
        },
        codAmount: CODAmount ? parseInt(CODAmount) : 0,
        declaredValue: DeclaredValue ? parseInt(DeclaredValue) : 0,
        agencyId: AgencyID ? AgencyID : 0,
        isGuaranteed: false,
        locationId: shipLocationID
      };

      let deepClone = JSON.parse(
        JSON.stringify(shipTypeValue === 'TL' ? TLquoteObj : obj)
      );
      validateAutocompletes(
        shipTypeValue === 'TL' ? TLquoteObj : obj,
        deepClone
      );
    }
  };
  const addLocPermission = userPermissionsArr.some(
    permission => permission.level3
  );

  const checkPickupStatus = () => {
    if (pickUpChecked) {
      setInsidePickupSwitch(false);
      setLiftgatePickupSwitch(false);
      setResidentialPickupSwitch(false);
      setSecureAccesPickupSwitch(false);
      setFreezeProtectionPickupSwitch(false);
      setOverlengthPickupSwitch(false);
      setLimitedPickupAccessSwitch(false);
      setIsOverLength(false);

      //   dispatch(setRateValues(obj));
    }
  };
  const checkDeliveryStatus = () => {
    if (deliveryChecked) {
      setInsideDeliverySwitch(false);
      setLiftgateDeliverySwitch(false);
      setResidentialDeliverySwitch(false);
      setSecureAccesDeliverySwitch(false);
      setCallBeforeDeliveryServicesSwitch(false);
      setLimitedDeliverySwitch(false);

      //   dispatch(setRateValues(obj));
    }
  };
  const handleSetShipLocation = arr => {
    const temp = [];
    setUserLocationsArr(arr.assignedLocations);
    const array = arr.assignedLocations;
    for (let i = 0; i < array.length; i++) {
      const Element =
        array[i].name +
        ': ' +
        array[i].city +
        ' ' +
        array[i].stateOrProvinceCode +
        ' ' +
        array[i].postalCode +
        ' ' +
        array[i].countryCode;
      const LocationId = array[i].id;
      temp.push({ location: Element, id: LocationId });
    }
    setShipLocationLoader(false);
    setShipLocation(temp.reverse());
  };

  useEffect(() => {
    setShipLocationLoader(true);
    GetAagencyUserDetails(UserLoggedInEmail)
      .then(res => res.status === 200 && handleSetShipLocation(res.data.data))
      .catch(err => console.log(err));
    // GetLocations(AgencyID)
    //   .then(res => res.status === 200 && handleSetShipLocation(res.data.data))
    //   .catch(err => console.log(err));
  }, []);

  const handleCheckAddedRow = () => {};
  const handleKeyPress = event => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  };

  const getFreightClassFromDensity = density => {
    if (density >= 50) return '50';
    if (density >= 35) return '55';
    if (density >= 30) return '60';
    if (density >= 22.5) return '65';
    if (density >= 15) return '70';
    if (density >= 13.5) return '77.5';
    if (density >= 12) return '85';
    if (density >= 10.5) return '92.5';
    if (density >= 9) return '100';
    if (density >= 8) return '110';
    if (density >= 7) return '125';
    if (density >= 6) return '150';
    if (density >= 5) return '175';
    if (density >= 4) return '200';
    if (density >= 2) return '250';
    return '300';
  };
  const handleDimensionsInputChange = (inputName, index, event, type) => {
    var filteredClass = [];
    var filteredUnitType = [];

    let totalWeight = 0;
    let TotalWeightSum;
    const maxLimit = 14999;
    const maxLimitParcel = 150;
    const values = [...newAddedDimensionsRow];
    if (inputName === 'WeightLBS') {
      const inputValue = event.target.value.replace(/[^0-9]/g, '');
      if (shipTypeValue === 'Parcel') {
        if (parseInt(inputValue, 10) > maxLimitParcel) {
          const updatedErrors = {
            ...validationErrors,
            [`weightEr${index}`]: 'Maximum weight limit is 150 lbs'
          };
          setValidationErrors(updatedErrors);
        } else {
          const updatedErrors = {
            ...validationErrors,
            [`weightEr${index}`]: null
          };
          setValidationErrors(updatedErrors);
          values[index].WeightLBS = inputValue;

          for (let index = 0; index < newAddedDimensionsRow.length; index++) {
            if (newAddedDimensionsRow[index].WeightLBS !== '') {
              totalWeight += parseInt(newAddedDimensionsRow[index].WeightLBS);
            }
          }
          setTotalLBSWeightDimensions(totalWeight);
          TotalWeightSum = totalLBSWeightClass
            ? parseInt(totalLBSWeightClass) + totalWeight
            : totalWeight;
          setTotalDimensionsWeightSum(totalWeight);
          handlePushAddedCommodityInfo(totalWeight);
        }
      } else if (
        shipTypeValue !== 'TL' &&
        parseInt(inputValue, 10) > maxLimit
      ) {
        const updatedErrors = {
          ...validationErrors,
          [`weightEr${index}`]: 'Maximum weight limit is 14999'
        };
        setValidationErrors(updatedErrors);
      } else {
        const updatedErrors = {
          ...validationErrors,
          [`weightEr${index}`]: null
        };
        setValidationErrors(updatedErrors);
        values[index].WeightLBS = inputValue;

        for (let index = 0; index < newAddedDimensionsRow.length; index++) {
          if (newAddedDimensionsRow[index].WeightLBS !== '') {
            totalWeight += parseInt(newAddedDimensionsRow[index].WeightLBS);
          }
        }
        setTotalLBSWeightDimensions(totalWeight);
        TotalWeightSum = totalLBSWeightClass
          ? parseInt(totalLBSWeightClass) + totalWeight
          : totalWeight;
        setTotalDimensionsWeightSum(totalWeight);
        handlePushAddedCommodityInfo(totalWeight, 'totalWeight');
      }
    } else if (inputName === 'Class') {
      if (event !== null) {
        filteredClass = ClassArray.filter(option =>
          option.toLowerCase().includes(event?.toLowerCase())
        );
      }
      setFreightClassHoveredValue(filteredClass[0]);
      // values[index].Class = event;
      if (!values[index]) {
        // If values[index] is undefined, create a new object
        values[index] = {};
      }

      values[index].Class = event;
    } else if (inputName === 'GrossWeight') {
      const inputValue = event.target.value.replace(/[^0-9]/g, '');
      // if (!isNaN(inputValue) && parseFloat(inputValue) > 0) {
      values[index].GrossWeight = inputValue;
      const totalGrossWeight = values.reduce(
        (sum, item) => sum + Number(item.GrossWeight || 0),
        0
      );
      setTotalGrossWeight(totalGrossWeight);
      // const updatedErrors = {
      //   ...validationErrors,
      //   numberOfUnits: null
      // };
      // setValidationErrors(updatedErrors);
      // }
    } else if (inputName === 'NmbOfUnits') {
      const inputValue = event.target.value.replace(/[^0-9]/g, '');
      handlePushAddedCommodityInfo(inputValue, 'NmbOfUnits');
      // if (parseInt(inputValue, 10) >= 0) {
      //   values[index].NmbOfUnits = inputValue;
      // }
      if (!isNaN(inputValue) && parseFloat(inputValue) > 0) {
        values[index].NmbOfUnits = inputValue;
        const updatedErrors = {
          ...validationErrors,
          [`numberOfUnits${index}`]: null
        };
        setValidationErrors(updatedErrors);
      } else {
        values[index].NmbOfUnits = '';
      }
    } else if (inputName === 'Pieces') {
      const inputValue = event.target.value.replace(/[^0-9]/g, '');
      handlePushAddedCommodityInfo(inputValue, 'Pieces');
      // if (parseInt(inputValue, 10) >= 0) {
      //   values[index].NmbOfUnits = inputValue;
      // }
      if (!isNaN(inputValue) && parseFloat(inputValue) > 0) {
        values[index].Pieces = inputValue;
        const updatedErrors = {
          ...validationErrors,
          [`numberOfPieces${index}`]: null
        };
        setValidationErrors(updatedErrors);
      } else {
        values[index].Pieces = '';
      }
    } else if (inputName === 'UnitType') {
      if (event !== null) {
        filteredUnitType =
          shipTypeValue === 'LTL'
            ? LTLUnitTypeArr.filter(option =>
                option.toLowerCase().includes(event?.toLowerCase())
              )
            : ParcelUnitTypeArr.filter(option =>
                option.toLowerCase().includes(event?.toLowerCase())
              );
      }
      setUnitTypeHoveredValue(filteredUnitType[0]);
      // setUnitTypeName('');
      // values[index].UnitTypeValue = event;
      if (!values[index]) {
        // If values[index] is undefined, create a new object
        values[index] = {};
      }

      setUnitTypeName('');
      values[index].UnitTypeValue = event;
      handlePushAddedCommodityInfo(event, 'UnitType');
    } else if (inputName === 'Stackable') {
      if (type === 'TLCase') {
        values[index].StackAble = event.target.value === 'Yes' ? true : false;
        handlePushAddedCommodityInfo(event, 'Stackable');
      } else {
        values[index].StackAble = event;
        handlePushAddedCommodityInfo(event, 'Stackable');
      }
    } else if (inputName === 'Length') {
      PersistedPaymentType = undefined;
      const inputValue = event.target.value.replace(/[^0-9]/g, '');

      values[index].Length = inputValue;
      handlePushAddedCommodityInfo(inputValue, 'Length');

      const updatedErrors = {
        ...validationErrors,
        PlengthError: null
      };
      setValidationErrors(updatedErrors);
    } else if (inputName === 'Width') {
      PersistedPaymentType = undefined;

      const inputValue = event.target.value.replace(/[^0-9]/g, '');

      handlePushAddedCommodityInfo(inputValue, 'Width');

      values[index].Width = inputValue;
      const updatedErrors = {
        ...validationErrors,
        PwidthError: null
      };
      setValidationErrors(updatedErrors);
    } else if (inputName === 'itemText') {
      const inputValue = event.target.value;

      handlePushAddedCommodityInfo(inputValue, 'itemText');

      values[index].itemText = inputValue;
    } else if (inputName === 'Vehicle') {
      handlePushAddedCommodityInfo(event.target.value, 'Width');

      values[index].Vehicle = event.target.value;
      const updatedErrors = {
        ...validationErrors,
        VehicleError: null
      };
      setValidationErrors(updatedErrors);
    } else {
      PersistedPaymentType = undefined;

      const inputValue = event.target.value.replace(/[^0-9]/g, '');
      handlePushAddedCommodityInfo(inputValue, 'Height');

      values[index].Height = inputValue;
      const updatedErrors = {
        ...validationErrors,
        PheightError: null
      };
      setValidationErrors(updatedErrors);
    }

    const length = parseFloat(values[index].Length);
    const width = parseFloat(values[index].Width);
    const height = parseFloat(values[index].Height);
    const weight = parseFloat(values[index].WeightLBS);
    const pieces = parseInt(values[index].NmbOfUnits);
    if (
      values[index].Length == '' ||
      values[index].Width == '' ||
      values[index].Height == ''
    ) {
      values[index].Class = '50';
    }
    if (
      !isNaN(length) &&
      length > 0 &&
      !isNaN(width) &&
      width > 0 &&
      !isNaN(height) &&
      height > 0 &&
      !isNaN(weight) &&
      weight > 0 &&
      !isNaN(pieces) &&
      pieces > 0
    ) {
      // const volumePerPiece = (length * width * height * pieces) / 1728;
      const totalVolume = (length * width * height * pieces) / 1728;
      const totalWeight = weight;

      const density = totalWeight / totalVolume;
      const freightClass = getFreightClassFromDensity(density);

      values[index].TotalVolume = parseFloat(totalVolume.toFixed(2));
      values[index].density = parseFloat(density.toFixed(2));
      values[index].estimatedFreightClass = freightClass;
      if (values[index].Class !== event && PersistedPaymentType === undefined) {
        values[index].Class = freightClass;
      }
    } else {
      values[index].TotalVolume = null;
      values[index].density = null;
      values[index].estimatedFreightClass = null;
    }
    setNewAddedDimensionsRow(values);
  };

  const handlePushAddedCommodityInfo = (removedIndex, valueName) => {
    let CommodityInfoApi = [];
    if (valueName === 'totalWeightMinus') {
      const updatedRows = finalCommodityInfoApi.filter(
        (row, index) => index !== removedIndex
      );
      setFinalCommodityInfoApi(updatedRows);
    } else {
      for (let i = 0; i < newAddedDimensionsRow.length; i++) {
        CommodityInfoApi.push({
          freightClass: newAddedDimensionsRow[i].Class,
          packaging: newAddedDimensionsRow[i].UnitTypeValue,
          units: newAddedDimensionsRow[i].NmbOfUnits,
          pieces: newAddedDimensionsRow[i].Pieces,
          weight: {
            units: 'lbs',
            value: newAddedDimensionsRow[i].WeightLBS
              ? newAddedDimensionsRow[i].WeightLBS
              : 0
            // valueName === 'totalWeight' ? totalWeight : totalDimensionsWeightSum
          },
          nmfc: newAddedClassRow[0].NMFCnumber,
          dimensions: {
            length: newAddedDimensionsRow[i].Length
              ? newAddedDimensionsRow[i].Length
              : shipTypeValue === 'Parcel'
                ? 15
                : 0,
            width: newAddedDimensionsRow[i].Width
              ? newAddedDimensionsRow[i].Width
              : shipTypeValue === 'Parcel'
                ? 11
                : 0,
            height: newAddedDimensionsRow[i].Height
              ? newAddedDimensionsRow[i].Height
              : shipTypeValue === 'Parcel'
                ? 14
                : 0,
            dimensionsUom: 'inches'
          },
          isStackable: newAddedDimensionsRow[i].StackAble,
          itemText: newAddedDimensionsRow[i].itemText
        });
      }
      // let CommodityInfoApi = [
      //   {
      // freightClass: newAddedDimensionsRow[0].Class,
      // packaging: newAddedDimensionsRow[0].UnitTypeValue,
      // pieces: newAddedDimensionsRow[0].NmbOfUnits,
      // weight: {
      //   units: 'lbs',
      //   value: TotalWeightSum
      // },
      // nmfc: newAddedClassRow[0].NMFCnumber,
      // dimensions: {
      //   length: newAddedDimensionsRow[0].Length,
      //   width: newAddedDimensionsRow[0].Width,
      //   height: newAddedDimensionsRow[0].Height,
      //   dimensionsUom: 'inches',
      //   isStackable: newAddedDimensionsRow[0].StackAble
      // }
      //   }
      // ];
      setFinalCommodityInfoApi(CommodityInfoApi);
      return CommodityInfoApi;
    }
  };
  // const handleClassInputChange = (inputName, index, event) => {
  //   let totalWeight = 0;
  //   let TotalWeightSum;
  //   const values = [...newAddedClassRow];
  //   if (inputName === 'WeightLBS') {
  //     const updatedErrors = { ...validationErrors, weightLBS: null };
  //     setValidationErrors(updatedErrors);

  //     values[index].WeightLBS = event.target.value;

  //     for (let index = 0; index < newAddedClassRow.length; index++) {
  //       if (newAddedClassRow[index].WeightLBS !== '') {
  //         totalWeight += parseInt(newAddedClassRow[index].WeightLBS);
  //       }
  //     }
  //     setTotalLBSWeightClass(totalWeight);
  //     TotalWeightSum = totalLBSWeightDimensions
  //       ? parseInt(totalLBSWeightDimensions) + totalWeight
  //       : totalWeight;
  //     setTotalClassWeightSum(totalWeight);
  //     handlePushAddedCommodityInfo(totalWeight);
  //   } else if (inputName === 'NMFCnumber') {
  //     values[index].NMFCnumber = event.target.value;
  //   } else if (inputName === 'Class') {
  //     setFreightClass(event);
  //     values[index].Class = event === null ? ClassArray[0] : event;
  //   }

  //   setNewAddedClassRow(values);
  // };

  const handleAddMultiPickups = (e, pickupIndex) => {
    setMultiPickupRows(prev => {
      const updated = [...prev];

      if (pickupIndex >= 0 && pickupIndex < updated.length) {
        updated[pickupIndex] = {
          ...updated[pickupIndex],
          pickupLineItems: [
            ...(updated[pickupIndex].pickupLineItems || []),
            {
              Class: '50',
              WeightLBS: '',
              UnitTypeValue: 'Pallet',
              NmbOfUnits: '1',
              Pieces: '1',
              StackAble: false,
              Length: 0,
              Width: 0,
              Height: 0
            }
          ]
        };
      }

      return updated;
    });
  };

  const handleRemoveMultiPickupLineItem = (pickupIndex, itemIndex) => {
    setTLValidationErrors([]);
    setMultiPickupRows(prev => {
      const updated = [...prev];

      if (
        pickupIndex >= 0 &&
        pickupIndex < updated.length &&
        itemIndex >= 0 &&
        itemIndex < (updated[pickupIndex].pickupLineItems?.length || 0)
      ) {
        const updatedLineItems = [...updated[pickupIndex].pickupLineItems];
        updatedLineItems.splice(itemIndex, 1); // remove the item

        updated[pickupIndex] = {
          ...updated[pickupIndex],
          pickupLineItems: updatedLineItems
        };
      }

      return updated;
    });
  };

  const handleAddNewRow = e => {
    const temp = [];
    if (e === 'class') {
      const values = [...newAddedClassRow];
      values.push({ WeightLBS: '', Class: ClassArray[0], NMFCnumber: '' });
      setNewAddedClassRow(values);
    } else {
      const values = [...newAddedDimensionsRow];
      values.push({
        Class: '50',
        WeightLBS: '',
        UnitTypeValue:
          shipTypeValue === 'LTL'
            ? LTLUnitTypeArr[0]
            : newAddedDimensionsRow[0]?.UnitTypeValue,
        NmbOfUnits: '1',
        Pieces: '1',
        StackAble: false,
        Length: shipTypeValue === 'Parcel' ? '15' : 0,
        Width: shipTypeValue === 'Parcel' ? '11' : 0,
        Height: shipTypeValue === 'Parcel' ? '14' : 0
      });
      setNewAddedDimensionsRow(values);
    }
  };

  const parseNumberFromString = str => {
    return Number(str.replace(/,/g, ''));
  };
  const handleSubtractNewRow = (e, removedIndex) => {
    if (e === 'class') {
      const values = [...newAddedClassRow];
      values.splice(removedIndex, 1);
      // finalCommodityInfoApi.splice(removedIndex, 1);
      setNewAddedClassRow(values);
      let totalWeightLBS = parseInt(newAddedClassRow[removedIndex].WeightLBS);
      let totalGWeight = parseInt(newAddedClassRow[removedIndex].GrossWeight);
      let minus;
      let grossMinus;
      if (isNaN(totalWeightLBS) || isNaN(totalGWeight)) {
        minus = parseInt(totalDimensionsWeightSum) - 0;
        grossMinus = parseInt(totalGrossWeight) - 0;
      } else {
        minus = parseInt(totalDimensionsWeightSum) - totalWeightLBS;
        grossMinus = parseInt(totalGrossWeight) - totalGWeight;
      }
      setTotalClassWeightSum(minus);
      setTotalGrossWeight(grossMinus);
      handlePushAddedCommodityInfo(removedIndex, 'totalWeightMinus');

      // setTotalDimensionsWeightSum(totalDimensionsWeightSum - totalWeightLBS);
      let TotalWeightSum = totalDimensionsWeightSum - totalWeightLBS;
    } else {
      const values = [...newAddedDimensionsRow];
      values.splice(removedIndex, 1);
      // finalCommodityInfoApi.splice(removedIndex, 1);

      setNewAddedDimensionsRow(values);
      let totalWeightLBS = parseInt(
        newAddedDimensionsRow[removedIndex].WeightLBS
      );
      let totalGrossWeightSum = parseInt(
        newAddedDimensionsRow[removedIndex].GrossWeight
      );
      let minus;
      let minusGross;
      if (isNaN(totalWeightLBS) || isNaN(totalGrossWeightSum)) {
        minus = parseInt(totalDimensionsWeightSum) - 0;
        minusGross = parseInt(totalGrossWeight) - 0;
      } else {
        setTotalDimensionsWeightSum(
          prev => parseInt(prev) - parseInt(totalWeightLBS)
        );
        setTotalGrossWeight(
          prev => parseInt(prev) - parseInt(totalGrossWeightSum)
        );
      }
      // totalWeightLBS = totalLBSWeightDimensions - totalLBSWeightDimensions;
      // minus = totalDimensionsWeightSum - totalWeightLBS;
      setTotalDimensionsWeightSum(
        prev => parseInt(prev) - parseInt(totalWeightLBS)
      );
      setTotalGrossWeight(
        prev => parseInt(prev) - parseInt(totalGrossWeightSum)
      );
      handlePushAddedCommodityInfo(removedIndex, 'totalWeightMinus');

      setTotalLBSWeightDimensions(totalWeightLBS);
    }
  };
  const totalNetWeightLBS = useMemo(() => {
    return multiPickupRows.reduce((dropAcc, drop) => {
      const rowTotal = drop.pickupLineItems.reduce((itemAcc, item) => {
        const weight = parseFloat(item.WeightLBS) || 0;
        return itemAcc + weight;
      }, 0);
      return dropAcc + rowTotal;
    }, 0);
  }, [multiPickupRows]);

  const totalGrossWeightLBS = useMemo(() => {
    return multiPickupRows.reduce((dropAcc, drop) => {
      const rowTotal = drop.pickupLineItems.reduce((itemAcc, item) => {
        const weight = parseFloat(item.GrossWeight) || 0;
        return itemAcc + weight;
      }, 0);
      return dropAcc + rowTotal;
    }, 0);
  }, [multiPickupRows]);

  const totalDeliveryGrossWeightLBS = useMemo(() => {
    return multiDropsRows.reduce((dropAcc, drop) => {
      const rowTotal = drop.deliveryLineItems.reduce((itemAcc, item) => {
        const weight = parseFloat(item.GrossWeight) || 0;
        return itemAcc + weight;
      }, 0);
      return dropAcc + rowTotal;
    }, 0);
  }, [multiDropsRows]);

  useEffect(() => {
    setTotalDeliveryGrossWeight(totalDeliveryGrossWeightLBS);
  }, [totalDeliveryGrossWeightLBS]);

  useEffect(() => {
    setTotalDimensionsWeightSum(totalGrossWeightLBS);
  }, [totalGrossWeightLBS]);

  const handleClearMultiItemErrors = (type, pickupIndex, itemIndex, field) => {
    // if (type === 'dropRows') {
    // const pickupErrors = validateMultiPickupRows(multiPickupRows);

    // const hasPickupErrors = pickupErrors.some(
    //   rowErr => rowErr && Object.keys(rowErr).length > 0
    // );

    // if (hasPickupErrors) {
    //   console.log('❌ Pickup validation failed:', pickupErrors);
    //   setTLValidationErrors({
    //     pickupRows: pickupErrors,
    //     dropRows: [] // clear any previous drop errors
    //   });
    // }
    // }
    // else if (type === 'pickupRows') {
    // ✅ Now validate drops only if pickups passed
    // const dropErrors =  validateMultiDropRows(multiDropsRows, TLPickupMode);

    // const hasDropErrors = dropErrors.some(
    //   rowErr => rowErr && Object.keys(rowErr).length > 0
    // );

    // if (hasDropErrors) {
    setGrossWeightError('');
    setShowWeightError(false);
    setTLValidationErrors({
      pickupRows: [], // no pickup errors
      dropRows: []
    });
    // }
  };

  useEffect(() => {
    const totalUnitsForNewType = multiPickupRows
      .flatMap(row => row.pickupLineItems)
      // .filter(item => item.UnitTypeValue === newUnitType)
      .reduce((acc, item) => acc + Number(item.NmbOfUnits || 0), 0);

    setTotalNmbofUnits(totalUnitsForNewType);
  }, [multiPickupRows]);

  const handleMultiLineItemChange = (
    type,
    pickupIndex,
    itemIndex,
    field,
    value
  ) => {
    setMultiPickupRows(prev => {
      const updated = [...prev];
      const updatedLineItems = [...updated[pickupIndex]?.pickupLineItems];

      let newValue = value;

      if (field === 'WeightLBS' || field === 'GrossWeight') {
        const inputValue = value.replace(/[^0-9]/g, '');
        const parsed = parseFloat(inputValue);
        newValue = isNaN(parsed) ? '' : Math.max(0, parsed);
      }

      if (field === 'StackAble') {
        updatedLineItems[itemIndex] = {
          ...updatedLineItems[itemIndex],
          [field]: value === 'Yes' ? true : false
        };
      } else {
        updatedLineItems[itemIndex] = {
          ...updatedLineItems[itemIndex],
          [field]: newValue
        };
      }

      updated[pickupIndex] = {
        ...updated[pickupIndex],
        pickupLineItems: updatedLineItems
      };

      return updated;
    });
  };
  useEffect(() => {
    handleCheckAddedRow();
  }, [newAddedClassRow]);

  const switchStyle = {
    borderRadius: 2,
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#d81b60'
    },
    '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
      backgroundColor: '#d81b60'
    },
    '&:hover .MuiSwitch-switchBase': {
      // color: 'brown'
    }
  };

  function sleep(delay = 0) {
    return new Promise(resolve => {
      setTimeout(resolve, delay);
    });
  }

  const [shipFromFinalAddress, setShipFromFinalAddress] = useState('');
  const [shipFromFinalValue, setShipFromFinalValue] = useState(ShipFrom);
  const [shipToFinalValue, setShipToFinalValue] = useState(ShipTo);
  const [shipToFinalAddress, setShipToFinalAddress] = useState('');

  // const history = useHistory()
  const spinnerStyles = {
    '-webkit-appearance': 'none',
    backgroundColor: '#000', // Set the background color
    background:
      '#000 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAcCAYAAADr9QYhAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAI6ADAAQAAAABAAAAHAAAAACbzWzwAAABB0lEQVRIDe2XMQ6DMAxFf6suwAjszLDCTeASHALEyFlg5hLsXIJDtPIQVFkkgrhDVCWLcQzJ84/liEeSJG84MIqiwMMVmCAI8HRAlAPBwxxSsIf/VKZpGozjiCiKWL7X3Z8oQyB1XSPLMnRdZw0khlEgKn8JkAiGg0iBrJse1UZZlmr/U7vvO7ZtO43xSWp61jB8ManvO7BJQVEBmxa2iXkYnWpOKfPSUV6Zb9sWaZpqX12WBeu6auM8IOozBNL3/SnQNE2Y55nvp/XFfYY67DAMIPs97oKob8U1w4FsQQhIdEwqI7J0ZFVVgerEZvi7yaSauGZMi9+NOQMThqEbP3FxHCPPc3wAmdpEetL9b2QAAAAASUVORK5CYII=) no-repeat center center',
    filter: 'invert(100%)', // Invert the spinner color to white
    width: '1.7em',
    opacity: 1,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    borderTopRightRadius: '0.25rem',
    borderBottomRightRadius: '0.25rem'
  };

  const onShipFromChange = (event, values, pickupIndex) => {
    setShipFromloading(true);
    if (values !== null) {
      const formattedCode = values.replace(/\s/g, '');
      GetLocationsJSON(values)
        .then(
          res =>
            res.status === 200 &&
            handleUSAddresses(res.data, 'shipFrom', values)
        )
        .catch(err => {
          setShipFromloading(false);
          setShipToloading(false);
        });
    }
    let FinalObj = {};
    if (values !== null) {
      const updatedErrors = { ...validationErrors, shipFromErr: null };
      setValidationErrors(updatedErrors);
      setShipFromFinalValue(values);

      const tempData = parseAddress(values);
      const City = tempData.city;
      const State = tempData.state;
      const ZipCode = tempData.zip;
      const CountryCode = tempData.countryCode;

      FinalObj = {
        City,
        State,
        ZipCode,
        CountryCode
      };

      setShipFromFinalAddress(FinalObj);

      if (pickupIndex) {
        setMultiPickupRows(prev =>
          prev.map((row, i) =>
            i === pickupIndex
              ? {
                  ...row,
                  pickupAddress: values
                }
              : row
          )
        );
        handleClearRowValidationError(
          'pickupRows',
          pickupIndex,
          'pickupAddress'
        );
      }
    } else {
      // setShipFromFinalAddress('');
      // setShipFromFinalValue('');
      // setShipToFinalValue('');
    }
  };

  const onShipToChange = (event, values, dropIndex) => {
    setResult([]);
    setShipToloading(true);
    // var filtered = [];
    if (values !== null) {
      const formattedCode = values.replace(/\s/g, '');

      GetLocationsJSON(values)
        .then(
          res =>
            res.status === 200 && handleUSAddresses(res.data, 'shipTo', values)
        )
        .catch(err => {
          setShipFromloading(false);
          console.log(err, 'Get Locations Error');
        });
      // filtered = shipCity.filter(option =>
      //   option?.toLowerCase().includes(values?.toLowerCase())
      // );
    }
    // setShipToHoveredValue(filtered[0]);
    let FinalObj2 = {};
    if (values !== null) {
      const updatedErrors = { ...validationErrors, shipToErr: null };
      setValidationErrors(updatedErrors);
      // setShipFromErr(false);
      setShipToFinalValue(values);

      if (dropIndex) {
        setMultiDropsRows(prev =>
          prev.map((row, i) =>
            i === dropIndex
              ? {
                  ...row,
                  dropAddress: values
                }
              : row
          )
        );
        handleClearRowValidationError('dropRows', dropIndex, 'dropAddress');
      }
      const tempData = parseAddress(values);

      const City = tempData.city;
      const State = tempData.state;
      const ZipCode = tempData.zip;
      const CountryCode = tempData.countryCode;

      FinalObj2 = {
        City,
        State,
        ZipCode,
        CountryCode
      };

      setShipToFinalAddress(FinalObj2);
    } else {
      // setShipToFinalAddress('');
      // setShipToFinalValue('');
      // setShipFromErr(true);
    }
  };
  const filterOptions = createFilterOptions({
    limit: 1000
  });

  const validateAutocompletes = (obj, deepClone) => {
    const errors = {};
    if (!shipTypeValue) {
      errors['shipTypeErr'] = 'Please select ship type';
      selectShipType.current.focus();
    }
    //  else if (!paymentTypeValue) {
    //   errors['paymentTypeErr'] = 'Please select payment type';
    // }
    else if (
      !shipLocationValue &&
      paymentTypeValue !== 'Third Party'
      //  && shipTypeValue !== 'TL'
    ) {
      errors['shipTypeLocation'] = 'Please select ship location';
      // if (selectLocations.current) {
      selectLocations.current.focus();
      // }
    } else if (
      shipTypeValue !== 'TL' &&
      (!shipFromFinalAddress || !shipFromFinalValue) &&
      paymentTypeValue !== 'Outbound Prepaid'
      // || paymentTypeValue === 'Sender'
    ) {
      errors['shipFromErr'] = 'Please select ship from';
      selectShipFrom.current.focus();
      setShipFromHoveredValue(null);
      setShipFromFinalValue('');
      setOpenShipFrom(false);
    } else if (
      shipTypeValue !== 'TL' &&
      (!obj?.shipFrom?.city ||
        !obj?.shipFrom?.stateOrProvinceCode ||
        !obj?.shipFrom?.postalCode ||
        !obj?.shipFrom?.countryCode)
    ) {
      setShipFromHoveredValue(null);
      // setShipFromFinalValue('');
      setOpenShipFrom(false);
      errors['shipFromErr'] = 'Please select valid ship from';
      selectShipFrom.current.focus();
    } else if (
      shipTypeValue !== 'TL' &&
      (!obj?.shipFrom?.city ||
        !obj?.shipFrom?.stateOrProvinceCode ||
        !obj?.shipFrom?.postalCode ||
        !obj?.shipFrom?.countryCode)
    ) {
      errors['shipToErr'] = 'Please select ship to';
      selectShipTo.current.focus();
      setShipToHoveredValue(null);
    } else if (
      shipTypeValue !== 'TL' &&
      (!obj?.shipTo?.city ||
        !obj?.shipTo?.stateOrProvinceCode ||
        !obj?.shipTo?.postalCode ||
        !obj?.shipTo?.countryCode)
    ) {
      errors['shipToErr'] = 'Please select valid ship to';
      selectShipTo.current.focus();
      setShipToHoveredValue(null);
    }

    if (Object.keys(errors).length) {
      setValidationErrors(errors);
      return;
    }
    if (shipTypeValue !== 'TL') {
      newAddedDimensionsRow.forEach((dimension, index) => {
        if (!dimension.WeightLBS) {
          errors[`weightEr${index}`] = 'Weight is required';
          enterWeight?.current?.focus();
        }
        if (!dimension.NmbOfUnits) {
          errors[`numberOfUnits${index}`] = '# of units required';
        }
        if (!dimension.Pieces) {
          errors[`numberOfPieces${index}`] = '# of pieces required';
        }
      });
    }

    if (
      obj?.shipFrom?.city &&
      obj?.shipFrom?.stateOrProvinceCode &&
      obj?.shipFrom?.postalCode &&
      obj?.shipFrom?.countryCode
    ) {
      if (
        result.length !== 0 &&
        shipFromFinalValue &&
        !DBJson.includes(shipFromFinalValue)
      ) {
        handleAddLocToDB(shipFromFinalValue, 'shipFrom');
      }
    }

    if (
      obj?.shipTo?.city &&
      obj?.shipTo?.stateOrProvinceCode &&
      obj?.shipTo?.postalCode &&
      obj?.shipTo?.countryCode
    ) {
      if (
        result.length !== 0 &&
        shipToFinalValue &&
        !DBJson.includes(shipToFinalValue)
      ) {
        handleAddLocToDB(shipToFinalValue, 'shipTo');
      }
    }
    if (shipTypeValue !== 'TL') {
      newAddedDimensionsRow.forEach((dimension, index) => {
        if (!dimension.WeightLBS) {
          errors[`weightEr${index}`] = 'Weight is required';
          enterWeight?.current?.focus();
        }
        if (!dimension.NmbOfUnits) {
          errors[`numberOfUnits${index}`] = '# of units required';
        }
        if (!dimension.Pieces) {
          errors[`numberOfPieces${index}`] = '# of pieces required';
        }
      });
    }

    // else if (shipTypeValue === 'Parcel' && !newAddedDimensionsRow[0].Length) {
    //   errors['PlengthError'] = 'enter length';
    // } else if (shipTypeValue === 'Parcel' && !newAddedDimensionsRow[0].Width) {
    //   errors['PwidthError'] = 'enter width';
    // } else if (shipTypeValue === 'Parcel' && !newAddedDimensionsRow[0].Height) {
    //   errors['PheightError'] = 'enter height';
    // }

    // if (ShipFrom) {
    //   const updatedErrors = { ...validationErrors, shipToErr: null };
    //   setValidationErrors(updatedErrors);
    // }
    setValidationErrors(errors);

    if (Object.keys(errors).length) {
      return;
    }
    if (shipTypeValue === 'TL') {
      if (isReefer && temperature === '') {
        setTempError('Enter temperature ');
      } else {
        const pickupErrors = validateMultiPickupRows(multiPickupRows);

        const hasPickupErrors = pickupErrors.some(
          rowErr => rowErr && Object.keys(rowErr).length > 0
        );

        if (hasPickupErrors) {
          setTLValidationErrors({
            pickupRows: pickupErrors,
            dropRows: []
          });
          return;
        }

        const dropErrors = validateMultiDropRows(multiDropsRows, TLPickupMode);
        const hasDropErrors = dropErrors.some(
          rowErr => rowErr && Object.keys(rowErr).length > 0
        );

        if (hasDropErrors) {
          setTLValidationErrors({
            pickupRows: [],
            dropRows: dropErrors
          });
          return;
        } else {
          setTLValidationErrors({ pickupRows: [], dropRows: [] });
          const secondObject = {
            shipmentType: 'TL',
            locationFull: obj.locationName,
            location: obj.location,
            paymentType:
              paymentTypeValue === 'Outbound Prepaid'
                ? '0'
                : paymentTypeValue === 'Inbound Collect'
                  ? '1'
                  : '2',
            shipFrom: {
              city: obj.originCity,
              stateOrProvinceCode: obj.originState,
              postalCode: obj.originZip,
              countryCode: obj.originCountry,
              residential: false,
              streetLines: obj.originAddress
            },
            shipTo: {
              city: obj.destinationCity,
              stateOrProvinceCode: obj.destinationState,
              postalCode: obj.destinationZip,
              countryCode: obj.destinationCountry,
              residential: false, // Assuming residential is false by default
              streetLines: obj.destinationAddress
            },
            shipmentDate: obj.orderDate,
            deliveryDate: obj.deliveryDate,
            totalGrossWeight: totalGrossWeight,
            isHazmat: obj.isHazmat,
            commodityInfo: {
              freightClass: '',
              packaging: '',
              units: '',
              pieces: '',
              weight: {
                units: 'lbs', // Assuming weight units are pounds
                value: ''
              },
              nmfc: '',
              dimensions: {
                length: '',
                width: '',
                height: '',
                dimensionsUom: 'inches', // Assuming dimensions are in inches
                isStackable: false
              }
            },
            pickupOptions: {
              ...obj.pickupOptions,
              callBeforeDelivery: obj.pickupOptions.callBeforeDelivery || false
            },
            deliveryOptions: {
              ...obj.deliveryOptions,
              callBeforeDelivery:
                obj.deliveryOptions.callBeforeDelivery || false
            },
            codAmount: 0, // Default value
            declaredValue: 0, // Default value
            agencyId: 198, // Assuming agency ID is 198
            isGuaranteed: false, // Default value
            locationId: obj.locationId
          };

          const CopyNewAddedClassRow = [...newAddedClassRow];

          dispatch(setQuickQuoteRateValues(secondObject));
          dispatch(setQuickQuoteTLRateValues(obj));

          dispatch(setQuickQuoteRateLoc(selectedLocation));

          dispatch(setQuickQuotePickUpCheckedRedux(pickUpChecked));
          dispatch(setQuickQuoteDeliveryCheckedRedux(deliveryChecked));
          dispatch(setClassDimensionsButton(alignment));
          dispatch(setClassRows(newAddedClassRow));
          dispatch(setDimensionRows(newAddedDimensionsRow));
          dispatch(setClassWeight(totalGrossWeight));
          dispatch(setDimensionsWeight(totalDimensionsWeightSum));
          history.push({
            pathname: '/bookshipmentTL',
            state: {
              createshipObj: obj,
              pickupRowData: JSON.stringify(obj),
              disptachOpen: 'Get Quote',
              rateType: 'Quick Quote',
              carrierApiNames: ParcelCarrierApiNames,
              paymentType: obj.paymentType,
              locationId: shipLocationID,
              userLocationsArr: userLocationsArr
            }
          });
        }
      }
    }
    if (
      shipTypeValue !== 'TL' &&
      shipTypeValue &&
      paymentTypeValue &&
      shipFromFinalAddress &&
      shipFromFinalValue &&
      shipToFinalValue &&
      shipToFinalAddress
    ) {
      const CopyNewAddedClassRow = [...newAddedClassRow];
      dispatch(setQuickQuoteTLRateValues({}));

      dispatch(setQuickQuoteRateValues(obj));

      dispatch(setQuickQuoteRateLoc(selectedLocation));

      dispatch(setQuickQuotePickUpCheckedRedux(pickUpChecked));
      dispatch(setQuickQuoteDeliveryCheckedRedux(deliveryChecked));
      dispatch(setClassDimensionsButton(alignment));
      dispatch(setClassRows(newAddedClassRow));
      dispatch(setDimensionRows(newAddedDimensionsRow));
      // dispatch(setClassWeight(totalClassWeightSum));
      dispatch(setDimensionsWeight(totalDimensionsWeightSum));
      history.push({
        pathname: '/bookshipment',
        state: {
          pickupRowData: JSON.stringify(obj),
          disptachOpen: 'Get Quote',
          rateType: 'Quick Quote',
          carrierApiNames: carrierApiNames,
          paymentType: obj.paymentType,
          locationId: shipLocationID,
          userLocationsArr: userLocationsArr,
          shipmentMiles: calDistanceValue,
          origin: ''
        }
      });
    }
  };

  const handleChangePaymentType = (event, newValue) => {
    setOpenShipFrom(false);
    setOpenShipTo(false);
    var filtered = [];
    if (!Array.isArray(newValue) && newValue !== null) {
      filtered =
        shipTypeValue === 'LTL'
          ? LTLPaymentTypeArr.filter(option =>
              option.toLowerCase().includes(newValue?.toLowerCase())
            )
          : parcelPaymentTypeArr.filter(option =>
              option.toLowerCase().includes(newValue?.toLowerCase())
            );
    }
    setPaymentTypeHoveredValue(filtered[0]);
    if (newValue === null) {
      setPaymentTypeValue(LTLPaymentTypeArr[0]);
    }
    if (newValue === 'Third Party') {
      setPaymentTypeInputChange(true);
      setShipFromFinalAddress('');
      setShipToFinalAddress('');
      setShipFromFinalValue('');
      setShipToFinalValue('');
      setPaymentTypeValue(newValue);
    } else if (newValue === 'Outbound Prepaid') {
      console.log(newValue, 'newValue', shipLocationValue);
      const updatedErrors = { ...validationErrors, shipFromErr: null };
      setValidationErrors(updatedErrors);
      setPaymentTypeInputChange(true);
      setShipFromFinalAddress(shipLocationValue);
      setPaymentTypeValue(newValue);
      setShipToFinalAddress('');
      setShipToFinalValue('');
    } else if (
      newValue === 'Inbound Collect'
      // || newValue === 'Receiver'
    ) {
      setPaymentTypeInputChange(true);
      setShipToFinalAddress(shipLocationValue);
      setPaymentTypeValue(newValue);
      setOpenShipFrom(false);
      setShipFromFinalAddress('');
      setShipFromFinalValue('');
    }
    setMultiDropsRows([
      {
        dropAddress: '',
        itemText: '',
        expDropDeliveryDate: deliveryDate,
        deliveryOpenHours: originOpenTimeValue,
        deliveryCloseHours: originCloseTimeValue,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        deliveryLineItems: [
          {
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: LTLUnitTypeArr?.[0] ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
    setMultiPickupRows([
      {
        pickupAddress: '',
        itemText: '',
        pickupDate: shipmentDate,
        expPickDeliveryDate: '',
        pickupOpenHours: originOpenTimeValue,
        pickupCloseHours: originCloseTimeValue,
        isHazmat: false,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        pickupLineItems: [
          {
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: LTLUnitTypeArr?.[0] ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
  };

  const [distanceMiles, setDistanceMiles] = useState(0);
  const [calDistanceValue, setCalDistanceValue] = useState(0);

  const PrettoSlider = styled(Slider)({
    // color: '#52af77',
    height: 6.5,
    '& .MuiSlider-track': {
      border: 'none'
    },
    '& .MuiSlider-thumb': {
      display: 'none',
      height: 10,
      width: 10
    },
    '& .MuiSlider-valueLabel': {
      display: 'none'
    }
  });

  useEffect(() => {
    let OutbondShipper;
    let OutbondReciever;
    let ApiZipFrom = '';
    let ApiZipTo = '';

    if (shipTypeValue !== 'TL') {
      if (
        paymentTypeValue === 'Outbound Prepaid' &&
        !shipFromFinalAddress.City
      ) {
        OutbondShipper = parseAddress(shipFromFinalAddress);

        ApiZipFrom =
          paymentTypeValue === 'Outbound Prepaid'
            ? OutbondShipper.zip
            : shipFromFinalAddress.ZipCode;
      } else {
        ApiZipFrom = shipFromFinalAddress.ZipCode;
      }

      if (paymentTypeValue === 'Inbound Collect' && !shipToFinalAddress.City) {
        OutbondReciever = parseAddress(shipToFinalAddress);
        ApiZipTo =
          paymentTypeValue === 'Inbound Collect'
            ? // ||paymentTypeValue === 'Receiver'
              OutbondReciever.zip
            : shipToFinalAddress.ZipCode;
      } else {
        ApiZipTo = shipToFinalAddress.ZipCode;
      }
      setDistanceMiles(0);

      if (ApiZipFrom && ApiZipTo) {
        CalculateDistance(ApiZipFrom, ApiZipTo)
          .then(res => {
            setDistanceMiles(res?.data?.rows[0]?.elements[0]?.distance?.text);
            setCalDistanceValue(
              res?.data?.rows[0]?.elements[0]?.distance?.value
            );
          })
          .catch(err => console.log(err, 'Distance Api Error'));
      }
    }
  }, [
    shipFromFinalAddress,
    shipToFinalAddress,
    paymentTypeValue,
    shipTypeValue
  ]);

  const handlePickupModeChange = event => {
    setTLPickupMode(event.target.value);
    setMultiDropsRows([
      {
        dropAddress: '',
        itemText: '',
        expDropDeliveryDate: deliveryDate,
        deliveryOpenHours: originOpenTimeValue,
        deliveryCloseHours: originCloseTimeValue,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        deliveryLineItems: [
          {
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: newAddedDimensionsRow[0]?.UnitTypeValue ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
    setMultiPickupRows([
      {
        pickupAddress: '',
        itemText: '',
        pickupDate: shipmentDate,
        expPickDeliveryDate: '',
        pickupOpenHours: originOpenTimeValue,
        pickupCloseHours: originCloseTimeValue,
        isHazmat: false,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        pickupLineItems: [
          {
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: newAddedDimensionsRow[0]?.UnitTypeValue ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
  };

  const handleTLequipmentTypeChnage = event => {
    setTLequipmentType(event.target.value);
  };
  const handleTLDriverTypeChange = event => {
    setTLDriverType(event.target.value);
  };
  const handleShipLocationChange = (event, newValue, reason) => {
    // reason can be: 'input' | 'selectOption' | 'clear' | 'blur' | 'removeOption'
    setOpenShipFrom(false);
    setOpenShipTo(false);
    setCity('');

    // Typing in the input
    if (reason === 'input') {
      const text = (newValue ?? '').toString();
      setShipLocationValue(text);
      setLocationInputChange(true);

      // update hovered suggestion
      const filtered = shipLocation.filter(o =>
        o.location?.toLowerCase().includes(text.toLowerCase())
      );
      setLocationHoveredValue(filtered[0] || null);
      return;
    }

    // Selecting an option
    if (reason === 'selectOption') {
      if (newValue?.isButton) {
        handleAddLocation();
        return;
      }

      if (newValue?.location) {
        const parts = newValue.location.split(': ');
        const label = parts[1] || parts[0] || '';

        setShipLocationValue(label); // input text
        setShipLocationID(newValue.id); // keep id
        setSelectedLocation(newValue); // <-- selected option object
        dispatch(setQuickQuoteRateLoc(newValue));

        if (paymentTypeValue === 'Outbound Prepaid')
          setShipFromFinalAddress(label);
        if (paymentTypeValue === 'Inbound Collect')
          setShipToFinalAddress(label);

        setValidationErrors(v => ({ ...v, shipTypeLocation: null }));
        setLocationInputChange(false);
        return;
      }
    }

    // Clearing or anything else
    if (reason === 'clear') {
      setShipLocationValue('');
      setSelectedLocation(null);
      setLocationInputChange(true);
    }
  };

  const handleClearAddresses = () => {
    setDistanceMiles(0);
    setSelectedLocation('');
    setCalDistanceValue(0);
    setTotalDimensionsWeightSum('');
    setShipLocationValue('');
    setShipLocationID('');
    setShipFromFinalAddress('');
    setShipToFinalAddress('');
    setShipFromFinalValue('');
    setShipToFinalValue('');
    handleClearForm();
  };
  const handleTlFlow = () => {
    handleClearAddresses();
    setNewAddedDimensionsRow([
      {
        Class: '50',
        WeightLBS: '',
        UnitTypeValue: newAddedDimensionsRow[0]?.UnitTypeValue,
        NmbOfUnits: '1',
        Pieces: '1',
        StackAble: false,
        Length: 0,
        Width: 0,
        Height: 0
      }
    ]);
  };
  const handleParcelFlow = () => {
    handleClearAddresses();

    setNewAddedDimensionsRow([
      {
        Class: '50',
        WeightLBS: '',
        UnitTypeValue: LTLUnitTypeArr[2],
        NmbOfUnits: '1',
        Pieces: '1',
        StackAble: false,
        Length: '15',
        Width: '11',
        Height: '14'
      }
    ]);
  };

  const handleLTLFlow = () => {
    handleClearAddresses();

    setNewAddedDimensionsRow([
      {
        Class: '50',
        WeightLBS: '',
        UnitTypeValue: LTLUnitTypeArr[0],
        NmbOfUnits: '1',
        Pieces: '1',
        StackAble: false,
        Length: '',
        Width: '',
        Height: ''
      }
    ]);
  };

  const isMobile = useIsMobile();
  const responsiveStyle = {
    height: '33vw',
    overflowY: 'hidden',
    position: 'relative'
  };

  const largeScreenStyle = {
    height: '27vw',
    overflowY: 'hidden',
    position: 'relative'
  };
  const validateMultiPickupRows = rows => {
    const errors = [];

    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
      const row = rows[rowIndex];
      const rowErrors = {};
      console.log(row, 'rowvalidation');
      if (!row.pickupAddress) {
        rowErrors.pickupAddress = 'Pickup address is required';
        errors[rowIndex] = rowErrors;
        selectShipFrom?.current[rowIndex]?.focus();
        break;
      }

      if (!row.expPickDeliveryDate) {
        handleIconClick(rowIndex);
        rowErrors.expPickDeliveryDate = 'Select Exp delivery date';
        errors[rowIndex] = rowErrors;
        break;
      }

      const lineItems = row.pickupLineItems || [];
      console.log(lineItems, 'lineItems');
      for (let itemIndex = 0; itemIndex < lineItems.length; itemIndex++) {
        const item = lineItems[itemIndex];

        if (!item.WeightLBS || parseFloat(item.WeightLBS) <= 0) {
          console.log(weightRefs.current, 'weightRefs');
          weightRefs.current?.[rowIndex]?.[itemIndex]?.focus();
          rowErrors.pickupLineItems = {
            [itemIndex]: { WeightLBS: 'Enter Net Weight' }
          };
          errors[rowIndex] = rowErrors;
          return errors;
        } else if (!item.GrossWeight || parseFloat(item.GrossWeight) <= 0) {
          grossWeightRefs.current?.[rowIndex]?.[itemIndex]?.focus();
          rowErrors.pickupLineItems = {
            [itemIndex]: { GrossWeight: 'Enter Gross Weight' }
          };
          errors[rowIndex] = rowErrors;
          return errors;
        } else if (parseFloat(item.GrossWeight) < parseFloat(item.WeightLBS)) {
          grossWeightRefs.current?.[rowIndex]?.[itemIndex]?.focus();
          rowErrors.pickupLineItems = {
            [itemIndex]: {
              GrossWeight: 'Gross Weight Cannot be less than Net Weight'
            }
          };
          errors[rowIndex] = rowErrors;
          return errors;
        }
      }
    }

    return errors;
  };

  const datepickerRef = useRef([]);
  const deliveryDatepickerRef = useRef(null);
  const pickupDatepickerRef = useRef(null);

  const handlePickupDateIconClick = () => {
    if (pickupDatepickerRef.current) {
      pickupDatepickerRef.current.setFocus();

      if (pickupDatepickerRef.current.input) {
        pickupDatepickerRef.current.input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  const handleDeliveryDateIconClick = () => {
    if (deliveryDatepickerRef.current) {
      deliveryDatepickerRef.current.setFocus();

      if (deliveryDatepickerRef.current.input) {
        deliveryDatepickerRef.current.input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };

  const handleIconClick = rowIndex => {
    console.log(datepickerRef, rowIndex, 'datepickerRef');
    if (datepickerRef.current) {
      datepickerRef?.current[rowIndex].setFocus();

      if (datepickerRef.current[rowIndex].input) {
        datepickerRef.current[rowIndex].input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  const validateMultiDropRows = rows => {
    console.log(rows, 'rowsvalidation');
    const errors = [];
    const skipDropValidation = TLPickupMode.includes('1 Drop');

    const buildUnitTotals = (rows, key) => {
      return rows.reduce((acc, row) => {
        (row[key] || []).forEach(item => {
          const type = (item.UnitTypeValue || '').trim();
          const qty = parseFloat(item.NmbOfUnits) || 0;
          if (type) acc[type] = (acc[type] || 0) + qty;
        });
        return acc;
      }, {});
    };

    const pickupUnits = buildUnitTotals(
      multiPickupRows || [],
      'pickupLineItems'
    );
    const deliveryUnits = buildUnitTotals(rows || [], 'deliveryLineItems');

    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
      const row = rows[rowIndex];
      const rowErrors = {};

      if (!row.dropAddress?.trim()) {
        rowErrors.dropAddress = 'Delivery address is required';
        errors[rowIndex] = rowErrors;
        selectShipTo?.current?.[rowIndex]?.focus?.();
        break;
      }

      if (!skipDropValidation) {
        const lineItems = row.deliveryLineItems || [];

        for (let itemIndex = 0; itemIndex < lineItems.length; itemIndex++) {
          const item = lineItems[itemIndex];

          if (!item.GrossWeight || parseFloat(item.GrossWeight) <= 0) {
            rowErrors.deliveryLineItems = {
              [itemIndex]: { GrossWeight: 'Enter Gross Weight' }
            };
            errors[rowIndex] = rowErrors;
            grossWeightRefsDelivery?.current?.[rowIndex]?.[
              itemIndex
            ]?.focus?.();
            break;
          }

          const totalGrossWeightOfRow = row.deliveryLineItems.reduce(
            (sum, i) => {
              const weight =
                parseFloat(
                  i.GrossWeight?.toString().replace(/,/g, '').trim()
                ) || 0;
              return sum + weight;
            },
            0
          );

          // --- Missing weight check ---
          if (
            totalDeliveryGrossWeight < totalGrossWeightLBS &&
            totalGrossWeightLBS - totalDeliveryGrossWeight !== 0
          ) {
            const remaining = totalGrossWeightLBS - totalDeliveryGrossWeight;

            // Calculate missing weight per unit type
            const totalPickupQty = Object.values(pickupUnits).reduce(
              (a, b) => a + b,
              0
            );
            const avgWeightPerUnit =
              totalPickupQty > 0
                ? totalGrossWeightLBS / totalPickupQty
                : totalGrossWeightLBS;

            const missingWeightDetails = Object.keys(pickupUnits)
              .map(type => {
                const pickupQty = pickupUnits[type] || 0;
                const deliveryQty = deliveryUnits[type] || 0;
                if (pickupQty > deliveryQty) {
                  const diffQty = pickupQty - deliveryQty;
                  const missingWeight = Math.round(diffQty * avgWeightPerUnit);
                  return `<b>${missingWeight} lbs</b> missing in <b>${type}</b>`;
                }
                return null;
              })
              .filter(Boolean)
              .join(', ');

            rowErrors.deliveryLineItems = { [itemIndex]: { GrossWeight: '' } };
            errors[rowIndex] = rowErrors;

            setGrossWeightError(
              `Some items are missing weight, around <b>${remaining} lbs</b> total. </br> Details: ${
                missingWeightDetails || 'N/A'
              }.`
            );
            setShowWeightError(true);
            grossWeightRefsDelivery?.current?.[rowIndex]?.[
              itemIndex
            ]?.focus?.();
            break;
          }

          // --- Extra weight check ---
          if (
            totalDeliveryGrossWeight > totalGrossWeightLBS &&
            totalGrossWeightLBS - totalDeliveryGrossWeight !== 0
          ) {
            const extra = totalDeliveryGrossWeight - totalGrossWeightLBS;

            // Calculate extra weight per unit type
            const totalPickupQty = Object.values(pickupUnits).reduce(
              (a, b) => a + b,
              0
            );
            const avgWeightPerUnit =
              totalPickupQty > 0
                ? totalGrossWeightLBS / totalPickupQty
                : totalGrossWeightLBS;

            const extraWeightDetails = Object.keys(deliveryUnits)
              .map(type => {
                const pickupQty = pickupUnits[type] || 0;
                const deliveryQty = deliveryUnits[type] || 0;
                if (deliveryQty > pickupQty) {
                  const diffQty = deliveryQty - pickupQty;
                  const extraWeight = Math.round(diffQty * avgWeightPerUnit);
                  return `<b>${extraWeight} lbs</b> extra in <b>${type}</b>`;
                }
                return null;
              })
              .filter(Boolean)
              .join(', ');

            rowErrors.deliveryLineItems = { [itemIndex]: { GrossWeight: '' } };
            errors[rowIndex] = rowErrors;

            setGrossWeightError(
              `Some items have extra weight, around <b>${extra} lbs</b> total. </br> Details: ${
                extraWeightDetails || 'N/A'
              }.`
            );
            setShowWeightError(true);
            grossWeightRefsDelivery?.current?.[rowIndex]?.[
              itemIndex
            ]?.focus?.();
            break;
          }

          // --- Over-limit check per row ---
          if (totalGrossWeightOfRow > parseFloat(totalGrossWeightLBS)) {
            rowErrors.deliveryLineItems = {
              _error: `Exceeded limit — maximum allowed is <b>${totalGrossWeightLBS} lbs</b>, current total: <b>${totalGrossWeightOfRow} lbs</b>.`
            };
            errors[rowIndex] = rowErrors;
            grossWeightRefsDelivery?.current?.[rowIndex]?.[
              itemIndex
            ]?.focus?.();
            break;
          } else {
            setGrossWeightError('');
            setShowWeightError(false);
          }
        }

        if (errors[rowIndex]) break;
      }
    }

    // --- Unit quantity mismatch summary ---
    if (errors.length === 0) {
      const discrepancies = [];

      Object.keys(pickupUnits).forEach(type => {
        const pQty = pickupUnits[type] || 0;
        const dQty = deliveryUnits[type] || 0;
        if (pQty > dQty)
          discrepancies.push(`<b>${pQty - dQty} ${type}</b> missing`);
        else if (dQty > pQty)
          discrepancies.push(`<b>${dQty - pQty} ${type}</b> extra`);
      });

      Object.keys(deliveryUnits).forEach(type => {
        if (!pickupUnits[type] && deliveryUnits[type] > 0)
          discrepancies.push(`<b>${deliveryUnits[type]} ${type}</b> extra`);
      });

      if (discrepancies.length > 0 && TLPickupMode.includes('Multiple')) {
        const message = `Quantity mismatch found: ${discrepancies.join(
          ' and '
        )}. Please verify pickup and delivery unit types and quantities.`;
        setGrossWeightError(message);
        setShowWeightError(true);
        errors[0] = { deliveryLineItems: { _unitError: message } };
      }
    }

    return errors;
  };

  const handleClearRowValidationError = (type, rowIndex, field) => {
    setTLValidationErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      const rowErrors = [...(newErrors?.[type] || [])];

      if (!rowErrors[rowIndex]) return prevErrors;

      delete rowErrors[rowIndex][field];

      newErrors[type] = rowErrors;
      return newErrors;
    });
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [addAddressLoading, setAddAddressLoading] = useState(false);
  const [hideAddLocText, setHideAddLocText] = useState(false);

  function formatAddress(addressArray) {
    if (addressArray.length < 3) {
      throw new Error('Address array must have at least 3 elements.');
    }

    const city = addressArray.slice(0, -3).join(' ');
    const state = addressArray.at(-3);
    const country = addressArray.at(-1);
    const postalCode = addressArray.at(-2);

    return { city, state, country, postalCode };
  }

  const handleLoading = type => {
    alert(type);
    if (type === 'shipFrom') {
      onShipFromChange('', result);
    } else if (type === 'shipTo') {
      onShipToChange('', result);
    }
    return <div>Loading ...</div>;
  };
  const handleAddLocToDB = (result, type) => {
    setAddAddressLoading(true);
    const formatedAddress = formatAddress(result.split(' '));

    AddLocation(formatedAddress)
      .then(res => {
        res.status === 200 &&
          //   successToast(`Location "${result}", added in Database successfully!`);
          // setAddAddressLoading(false);
          // setHideAddLocText(true);
          setResult([]);
        // if (type === 'shipFrom') {
        //   setShipFromOpen(false);
        //   onShipFromChange('', result);
        //   selectShipTo.current.focus();
        // } else if (type === 'shipTo') {
        //   onShipToChange('', result);
        //   enterWeight.current.focus();
        // }
      })
      .catch(err => {
        console.log(err, 'addLocation Error');
        // ErrorToast('Server Side Error');
        // setAddAddressLoading(false);
        // setHideAddLocText(false);
      });
  };
  // Update screen width on resize
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleRemoveDrop = dropIndexToRemove => {
    setMultiDropsRows(prev =>
      prev.filter((_, index) => index !== dropIndexToRemove)
    );

    // Also optionally remove errors for that drop
    setMultiDropsErrors(prevErrors =>
      prevErrors.filter((_, index) => index !== dropIndexToRemove)
    );
  };

  const handleRemovePickup = dropPickupIndex => {
    setMultiPickupRows(prev =>
      prev.filter((_, index) => index !== dropPickupIndex)
    );
  };

  const handleAddMorePickups = () => {
    setMultiPickupRows(prev => [
      ...prev,
      {
        pickupAddress: '',
        itemText: '',
        pickupDate: shipmentDate,
        expPickDeliveryDate: '',
        pickupOpenHours: originOpenTimeValue,
        pickupCloseHours: originCloseTimeValue,
        isHazmat: false,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        pickupLineItems: [
          {
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: newAddedDimensionsRow[0]?.UnitTypeValue ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
  };

  const handleAddMoreDrops = () => {
    setMultiDropsRows(prev => {
      const cleanedRows = prev.map(row => ({
        ...row,
        deliveryLineItems: row.deliveryLineItems.map(item => ({
          ...item,
          NmbOfUnitsError: ''
        }))
      }));

      const newRow = {
        dropAddress: '',
        expDropDeliveryDate: multiPickupRows[0]?.expPickDeliveryDate,
        expDeliveryDisplayDate: deliveryDate,
        deliveryOpenHours: originOpenTimeValue,
        deliveryCloseHours: originCloseTimeValue,
        isHazmat: false,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        deliveryLineItems: [
          {
            Class: '50',
            NmbOfUnitsError: '',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue:
              multiPickupRows[0]?.pickupLineItems[0]?.UnitTypeValue ?? '',
            nmfc: '',
            NmbOfUnits: '0',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      };

      return [...cleanedRows, newRow];
    });
  };

  const handleAddMultiDropsLineItems = (e, index) => {
    setRatesDisable(false);
    setMultiDropsErrors([]);
    setMultiDropsRows(prev => {
      const updated = [...prev];

      if (!updated[index]) return prev;

      const newItem = {
        Class: '50',
        WeightLBS: '',
        GrossWeight: '',
        UnitTypeValue:
          multiPickupRows[0]?.pickupLineItems[0]?.UnitTypeValue ?? '',
        nmfc: '',
        NmbOfUnits: '0',
        Pieces: '1',
        StackAble: false,
        Length: 0,
        Width: 0,
        Height: 0,
        NmbOfUnitsError: ''
      };

      const updateddeliveryLineItems = [
        ...(updated[index].deliveryLineItems || []),
        newItem
      ].map(item => ({
        ...item,
        NmbOfUnitsError: ''
      }));

      updated[index] = {
        ...updated[index],
        deliveryLineItems: updateddeliveryLineItems
      };

      return updated;
    });
  };

  const handleRemoveMultiDropsLineItems = (dropIndex, lineIndex) => {
    setRatesDisable(false);
    setMultiDropsErrors([]);
    setMultiDropsRows(prev => {
      const updated = [...prev];

      if (!updated[dropIndex] || !updated[dropIndex].deliveryLineItems)
        return prev;

      const updateddeliveryLineItems = updated[dropIndex].deliveryLineItems
        .filter((_, idx) => idx !== lineIndex)
        .map(item => ({
          ...item,
          NmbOfUnitsError: ''
        }));

      updated[dropIndex] = {
        ...updated[dropIndex],
        deliveryLineItems: updateddeliveryLineItems
      };

      return updated;
    });
  };

  const validateUnitTypeQuantity = (
    items,
    currentLineIndex,
    newValue,
    newUnitType
  ) => {
    const currentUnits = Number(newValue || 0);

    const totalUnitsForNewType = multiPickupRows
      .flatMap(row => row.pickupLineItems)
      .filter(item => item.UnitTypeValue === newUnitType)
      .reduce((acc, item) => acc + Number(item.NmbOfUnits || 0), 0);

    const unitsInDropSameTypeExclCurrent = items.reduce((sum, item, idx) => {
      if (idx === currentLineIndex) return sum;
      return item.UnitTypeValue === newUnitType
        ? sum + Number(item.NmbOfUnits || 0)
        : sum;
    }, 0);
    setTotalNmbofUnits(totalUnitsForNewType);
    const totalTryingToAllocate = unitsInDropSameTypeExclCurrent + currentUnits;

    return {
      isValid: totalTryingToAllocate <= totalUnitsForNewType,
      totalUnitsForNewType,
      totalTryingToAllocate,
      remainingUnits: totalUnitsForNewType <= totalTryingToAllocate
    };
  };
  function calculateGrossWeightByUnitType(pickups, unitType) {
    let total = 0;

    pickups.forEach(pickup => {
      pickup.pickupLineItems.forEach(item => {
        if (item.UnitTypeValue === unitType) {
          total += Number(item.GrossWeight) || 0;
        }
      });
    });

    return total;
  }
  const handleMultilineItemChange = (dropIndex, lineIndex, field, value) => {
    const numericFields = ['GrossWeight', 'Length', 'Width', 'Height'];
    const cleanedValue = numericFields.includes(field)
      ? String(value).replace(/,/g, '')
      : value;
    const numericValue = numericFields.includes(field)
      ? Number(cleanedValue)
      : value;
    // const allowedWeight = Number(totalDimensionsWeightSum);
    const currentUnitType =
      multiDropsRows[dropIndex].deliveryLineItems[lineIndex].UnitTypeValue;
    calculateGrossWeightByUnitType(multiPickupRows, currentUnitType);
    const allowedWeight = calculateGrossWeightByUnitType(
      multiPickupRows,
      currentUnitType
    );

    if (numericFields.includes(field) && !/^\d*\.?\d*$/.test(cleanedValue)) {
      return;
    }

    let validValue = value;
    let errorMsg = '';

    setMultiDropsRows(prev => {
      const updated = [...prev];

      if (
        !updated[dropIndex] ||
        !updated[dropIndex].deliveryLineItems?.[lineIndex]
      ) {
        return prev;
      }

      let updateddeliveryLineItems = [...updated[dropIndex].deliveryLineItems];
      const currentItem = updateddeliveryLineItems[lineIndex];
      const currentItemWeight = Number(
        (currentItem.GrossWeight || '').toString().replace(/,/g, '')
      );

      // Calculate new total weight
      const currentTotalExcludingThis = prev.reduce((acc, drop, dIdx) => {
        return (
          acc +
          drop.deliveryLineItems.reduce((sub, item, lIdx) => {
            if (dIdx === dropIndex && lIdx === lineIndex) return sub;

            // ✅ Only include items with matching unit type
            if (item.UnitTypeValue !== currentUnitType) return sub;

            const w = Number(
              (item.GrossWeight || '').toString().replace(/,/g, '')
            );

            return sub + (isNaN(w) ? 0 : w);
          }, 0)
        );
      }, 0);
      const newTotalWeightIfAccepted =
        currentTotalExcludingThis + (isNaN(numericValue) ? 0 : numericValue);

      // Weight check
      if (field === 'GrossWeight') {
        setRatesDisable(false);
        if (!isNaN(numericValue) && newTotalWeightIfAccepted > allowedWeight) {
          errorMsg = `Exceeded limit. Max ${allowedWeight} lbs allowed.`;
          validValue = cleanedValue;
          setRatesDisable(true);
        }
        if (!isNaN(numericValue) && newTotalWeightIfAccepted < allowedWeight) {
          setRatesDisable(true);
          errorMsg = `Remaining gross weight ${
            allowedWeight - newTotalWeightIfAccepted
          } lbs for ${currentUnitType}`;
          validValue = cleanedValue;
        }
        // else {
        //   setRatesDisable(false);
        // }
      }
      if (field === 'StackAble') {
        updateddeliveryLineItems[lineIndex] = {
          ...updateddeliveryLineItems[lineIndex],
          [field]: value == 'Yes' ? true : false
        };
      }
      // Update the field

      if (field !== 'StackAble') {
        updateddeliveryLineItems[lineIndex] = {
          ...updateddeliveryLineItems[lineIndex],
          [field]: validValue
        };
      }

      // Get latest values after field change
      const updatedItem = updateddeliveryLineItems[lineIndex];
      const latestUnits = updatedItem.NmbOfUnits;
      const latestUnitType = updatedItem.UnitTypeValue;

      if (field === 'NmbOfUnits' && latestUnits && latestUnitType) {
        const {
          isValid,
          totalTryingToAllocate,
          totalUnitsForNewType,
          remainingUnits
        } = validateUnitTypeQuantity(
          updateddeliveryLineItems,
          lineIndex,
          latestUnits,
          latestUnitType
        );

        // ✅ New: Check same unit type across ALL drops
        const totalAcrossDropsSameUnitType = updated.reduce(
          (acc, drop, dIdx) => {
            return (
              acc +
              drop.deliveryLineItems.reduce((sub, item, lIdx) => {
                const isSameType = item.UnitTypeValue === latestUnitType;
                const isCurrent = dIdx === dropIndex && lIdx === lineIndex;
                return (
                  sub +
                  (isSameType && !isCurrent ? Number(item.NmbOfUnits || 0) : 0)
                );
              }, 0)
            );
          },
          Number(latestUnits)
        ); // include current line's units in total

        const isDropLevelValid =
          totalAcrossDropsSameUnitType <= totalUnitsForNewType;

        if (
          !remainingUnits &&
          totalUnitsForNewType - totalAcrossDropsSameUnitType !== 0
        ) {
          setRatesDisable(true);
          errorMsg = `Remaining ${
            totalUnitsForNewType - totalAcrossDropsSameUnitType
          } units to assign of "${latestUnitType}", ${totalUnitsForNewType} are allowed.`;

          // clear all first, then set only on active row
          updateddeliveryLineItems = updateddeliveryLineItems.map(
            (item, idx) => ({
              ...item,
              NmbOfUnits: idx === lineIndex ? validValue : item.NmbOfUnits,
              NmbOfUnitsError: idx === lineIndex ? errorMsg : ''
            })
          );
        } else if (
          (!isValid || !isDropLevelValid) &&
          totalUnitsForNewType - totalAcrossDropsSameUnitType !== 0
        ) {
          errorMsg = `You're trying to assign ${totalAcrossDropsSameUnitType} units of "${latestUnitType}", but only ${totalUnitsForNewType} are allowed.`;
          validValue = '';

          updateddeliveryLineItems = updateddeliveryLineItems.map(
            (item, idx) => ({
              ...item,
              NmbOfUnits: idx === lineIndex ? validValue : item.NmbOfUnits,
              NmbOfUnitsError: idx === lineIndex ? errorMsg : ''
            })
          );
        } else {
          setRatesDisable(false);

          updateddeliveryLineItems = updateddeliveryLineItems.map(
            (item, idx) => ({
              ...item,
              [field]: idx === lineIndex ? validValue : item[field],
              NmbOfUnitsError: '' // ✅ clear everywhere
            })
          );
        }
      }
      if (field === 'UnitTypeValue') {
        const hasGrossWeight = multiDropsErrors?.find(drop =>
          drop?.deliveryLineItems?.some(
            line => line.GrossWeight !== '' && line.GrossWeight != null
          )
        );
        const hasNmbOfUnits = multiDropsErrors?.find(drop =>
          drop?.deliveryLineItems?.some(
            line => line.NmbOfUnits !== '' && line.NmbOfUnits != null
          )
        );
        updateddeliveryLineItems[lineIndex] = {
          ...updateddeliveryLineItems[lineIndex],
          [field]: validValue,
          GrossWeight: hasGrossWeight
            ? ''
            : updateddeliveryLineItems[lineIndex].GrossWeight,
          NmbOfUnits: hasNmbOfUnits
            ? ''
            : updateddeliveryLineItems[lineIndex].NmbOfUnits,
          NmbOfUnitsError: hasNmbOfUnits ? '' : hasNmbOfUnits
        };

        setMultiDropsErrors([]);
      }
      updated[dropIndex] = {
        ...updated[dropIndex],
        deliveryLineItems: updateddeliveryLineItems
      };

      return updated;
    });

    // ✅ Set or clear error
    setMultiDropsErrors(prevErrors => {
      const updatedErrors = [...prevErrors];

      if (!updatedErrors[dropIndex]) {
        updatedErrors[dropIndex] = { deliveryLineItems: [] };
      }

      const dropErrors = updatedErrors[dropIndex];
      const lineErrors = dropErrors.deliveryLineItems?.[lineIndex] || {};

      const newLineErrors = {
        ...lineErrors,
        [field]: errorMsg
      };

      if (!dropErrors.deliveryLineItems) {
        dropErrors.deliveryLineItems = [];
      }

      dropErrors.deliveryLineItems[lineIndex] = newLineErrors;
      updatedErrors[dropIndex] = dropErrors;

      return updatedErrors;
    });
  };

  const handleAddLocation = () => {
    let TLquoteObj = {
      id: 0,
      defaultLocation: city,
      carrierId: 0,
      carrierName: '',
      carrierLogo: '',
      invoiceType: '',
      shipmentId: '',
      proNumber: '',
      TLPickupMode: TLPickupMode,
      temperature: temperature,
      pickupInstructions: cleanHtmlString(pickupRemarks) ?? '',
      deliveryInstructions: cleanHtmlString(deliveryRemarks) ?? '',
      unit: unit,
      orderDate: multiPickupRows[0]?.pickupDate,
      pickupDate: multiPickupRows[0]?.pickupDate,
      invoiceNumber: '',
      deliveryDate: multiDropsRows[0]?.expDropDeliveryDate,
      ExpectedDeliveryDate: multiDropsRows[0]?.expDropDeliveryDate,
      invoiceDate: multiDropsRows[0]?.expDropDeliveryDate,
      originCompany:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.companyName || ''
          : '',
      originAddress:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.streetLines || ''
          : multiPickupRows[0]?.pickupAddress || '',
      originCity:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.city || ''
          : multiPickupRows[0]?.city || '',
      originState:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.stateOrProvinceCode || ''
          : multiPickupRows[0]?.state || '',
      originZip:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.postalCode || ''
          : multiPickupRows[0]?.zip || '',
      originCountry:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.countryCode || ''
          : multiPickupRows[0]?.country || '',
      originContactPerson:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.contactName || ''
          : multiPickupRows[0]?.contactName || '',
      originContactEmail:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.contactEmail?.split(',')[0] || ''
          : multiPickupRows[0]?.email || '',
      originContactPhone:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.contactPhone || ''
          : multiPickupRows[0]?.phone,

      destinationCompany:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.companyName || ''
          : multiDropsRows[multiDropsRows.length - 1]?.company || '',
      destinationAddress:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.streetLines || ''
          : multiDropsRows[0]?.address || '',
      destinationCity:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.city || ''
          : multiDropsRows[0]?.city || '',
      destinationState:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.stateOrProvinceCode || ''
          : multiDropsRows[0]?.state || '',
      destinationZip:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.postalCode || ''
          : multiDropsRows[0]?.zip || '',
      destinationCountry:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.countryCode || ''
          : multiDropsRows[0]?.country || '',
      destinationContactPerson:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.contactName || ''
          : '',
      destinationContactEmail:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.contactEmail?.split(',')[0] || ''
          : '',
      destinationContactPhone:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.contactPhone || ''
          : '',
      billToCompany: '',
      billToAddress: '',
      billToCity: '',
      billToState: '',
      billToZip: '',
      billToCountry: '',
      shipmentType: 'TL',
      equipmentType: TLequipmentType,
      soNumber: '',
      clientPONumber: '',
      isHazmat: hazmatSwitch,
      pickupLineItems: [],
      deliveryLineItems: [],
      pickupNumber: '',
      shipmentStatus: 'Saved',
      cargoValue: '',
      freightTerms: paymentTypeValue.replace(/\s+/g, ''),
      paymentTerms: paymentTypeValue,
      bolNumber: '',
      customerId: '',
      shippingNotes: pickupRemarks,
      billToContactPerson: '',
      billToContactEmail: '',
      billToContactPhone: '',
      locationName: selectedLocation?.location,
      location: shipLocationValue,
      locationId: shipLocationID,
      pickupStartTime: '',
      pickupEndTime: '',
      deliverStartTime: '',
      deliverEndTime: '',
      quoteId: 0,
      shipmentCharges: 0,
      actualPickupDate: '',
      actualDeliveryDate: '',
      sessionId: '',
      quoteNumber: '',
      dispatchInput1: '',
      lastUpdatedOn: '',
      serviceType: TLDriverType,
      totalNetWeight: totalNetWeightLBS ? totalNetWeightLBS : 0,
      totalGrossWeight: totalGrossWeightLBS ? totalGrossWeightLBS : 0,
      originTerminalAddress: '',
      originTerminalCity: '',
      originTerminalState: '',
      originTerminalPostalCode: '',
      originTerminalCountry: '',
      originTerminalContact: '',
      originTerminalContantEmail: '',
      originTerminalContactPhone: '',
      destinationTerminalAddress: '',
      destinationTerminalCity: '',
      destinationTerminalState: '',
      destinationTerminalPostalCode: '',
      destinationTerminalCountry: '',
      destinationTerminalContact: '',
      destinationTerminalContantEmail: '',
      destinationTerminalContactPhone: '',
      pickupOptions: {
        inside: false,
        liftGateServices: false,
        residential: false,
        secureAccess: false,
        limitedAccess: false,
        freezeProtection: false,
        overLength: false,
        callBeforeDelivery: false,
        overLengthValue: 0
      },
      deliveryOptions: {
        inside: false,
        liftGateServices: false,
        residential: false,
        secureAccess: false,
        limitedAccess: false
      },
      pickupOptionsAccessorial: '',
      deliveryOptionAccessorial: '',
      carrierBillToCompany: '',
      carrierBillToAddress: '',
      carrierBillToCity: '',
      carrierBillToState: '',
      carrierBillToZip: '',
      carrierBillToCountry: '',
      carrierBillToContactPerson: '',
      carrierBillToContactEmail: '',
      carrierBillToContactPhone: '',
      surcharges: '',
      surchargesList: '',
      estimatedTransitDays: 0,
      shipmentMiles: calDistanceValue,
      OriginData: '',
      destinationData: '',
      salesOrderNumber: '',
      purchaseOrderNumber: '',
      freightInvoiceNumber: ''
    };
    let ApiCityFrom = '';
    let ApiStateFrom = '';
    let ApiZipFrom = '';
    let ApiZipFromCountryCode = '';
    let OutbondShipper;
    let OutbondReciever;

    if (
      paymentTypeValue === 'Outbound Prepaid' &&
      // ||
      // paymentTypeValue === 'Sender') &&
      !shipFromFinalAddress.City
    ) {
      OutbondShipper = parseAddress(shipFromFinalAddress);
      ApiCityFrom =
        paymentTypeValue === 'Outbound Prepaid'
          ? // ||
            // paymentTypeValue === 'Sender'
            OutbondShipper.city
          : shipFromFinalAddress.City;
      ApiStateFrom =
        paymentTypeValue === 'Outbound Prepaid'
          ? // ||
            // paymentTypeValue === 'Sender'
            OutbondShipper.state
          : shipFromFinalAddress.State;
      ApiZipFrom =
        paymentTypeValue === 'Outbound Prepaid'
          ? // ||
            // paymentTypeValue === 'Sender'
            OutbondShipper.zip
          : shipFromFinalAddress.ZipCode;
      ApiZipFromCountryCode =
        paymentTypeValue === 'Outbound Prepaid'
          ? // ||
            // paymentTypeValue === 'Sender'
            OutbondShipper.countryCode
          : shipFromFinalAddress.CountryCode;
    } else {
      ApiCityFrom = shipFromFinalAddress.City;
      ApiStateFrom = shipFromFinalAddress.State;
      ApiZipFrom = shipFromFinalAddress.ZipCode;
      ApiZipFromCountryCode = shipFromFinalAddress.CountryCode;
    }

    let ApiCityTo = '';
    let ApiStateTo = '';
    let ApiZipTo = '';
    let ApiZipToCountryCode = '';
    if (
      paymentTypeValue === 'Inbound Collect' &&
      // || paymentTypeValue === 'Receiver'
      !shipToFinalAddress.City
    ) {
      OutbondReciever = parseAddress(shipToFinalAddress);

      ApiCityTo =
        paymentTypeValue === 'Inbound Collect'
          ? // || paymentTypeValue === 'Receiver'
            OutbondReciever.city
          : shipToFinalAddress.City;
      ApiStateTo =
        paymentTypeValue === 'Inbound Collect'
          ? // || paymentTypeValue === 'Receiver'
            OutbondReciever.state
          : shipToFinalAddress.State;
      ApiZipTo =
        paymentTypeValue === 'Inbound Collect'
          ? // ||paymentTypeValue === 'Receiver'
            OutbondReciever.zip
          : shipToFinalAddress.ZipCode;
      ApiZipToCountryCode =
        paymentTypeValue === 'Inbound Collect'
          ? // || paymentTypeValue === 'Receiver'
            OutbondReciever.countryCode
          : shipToFinalAddress.CountryCode;
    } else {
      ApiCityTo = shipToFinalAddress.City;
      ApiStateTo = shipToFinalAddress.State;
      ApiZipTo = shipToFinalAddress.ZipCode;
      ApiZipToCountryCode = shipToFinalAddress.CountryCode;
    }

    let obj = {
      shipmentType: shipTypeValue,
      locationFull: selectedLocation.location,
      location: shipLocationValue,
      paymentType:
        paymentTypeValue === 'Outbound Prepaid'
          ? '0'
          : paymentTypeValue === 'Inbound Collect'
            ? '1'
            : '2',
      shipFrom: {
        city: ApiCityFrom,
        stateOrProvinceCode: ApiStateFrom,
        postalCode: ApiZipFrom,
        countryCode: ApiZipFromCountryCode,
        residential: true,
        streetLines:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.streetLines
            : ''
      },
      shipTo: {
        city: ApiCityTo,
        stateOrProvinceCode: ApiStateTo,
        postalCode: ApiZipTo,
        countryCode: ApiZipToCountryCode,
        residential: true,
        streetLines:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.streetLines
            : ''
      },
      shipmentDate: new Date(),
      isHazmat: hazmatSwitch,
      commodityInfo: handlePushAddedCommodityInfo(),

      pickupOptions: {
        inside: insidePickupSwitch,
        liftGateServices: liftgatePickupSwitch,
        residential: residentialPickupSwitch,
        secureAccess: secureAccesPickupSwitch,
        limitedAccess: limitedPickupAccessSwitch,
        freezeProtection: freezeProtectionPickupSwitch,
        overLength: overlengthPickupSwitch,
        overLengthValue: overLengthValue ? parseFloat(overLengthValue) : 0,
        callBeforeDelivery: false
      },
      deliveryOptions: {
        inside: insideDeliverySwitch,
        liftGateServices: liftgateDeliverySwitch,
        residential: residentialDeliverySwitch,
        secureAccess: secureAccesDeliverySwitch,
        limitedAccess: limitedDeliverySwitch,
        freezeProtection: false,
        overLength: false,
        overLengthValue: 0,
        callBeforeDelivery: callBeforeDeliveryServicesSwitch
      },
      codAmount: CODAmount ? parseInt(CODAmount) : 0,
      declaredValue: DeclaredValue ? parseInt(DeclaredValue) : 0,
      agencyId: AgencyID ? AgencyID : 0,
      isGuaranteed: false,
      locationId: shipLocationID
    };

    const secondObject = {
      shipmentType: 'TL',
      locationFull: selectedLocation?.location,
      location: shipLocationValue,
      paymentType:
        paymentTypeValue === 'Outbound Prepaid'
          ? '0'
          : paymentTypeValue === 'Inbound Collect'
            ? '1'
            : '2',
      shipFrom: {
        city: obj.originCity,
        stateOrProvinceCode: obj.originState,
        postalCode: obj.originZip,
        countryCode: obj.originCountry,
        residential: false,
        streetLines: obj.originAddress
      },
      shipTo: {
        city: obj.destinationCity,
        stateOrProvinceCode: obj.destinationState,
        postalCode: obj.destinationZip,
        countryCode: obj.destinationCountry,
        residential: false, // Assuming residential is false by default
        streetLines: obj.destinationAddress
      },
      shipmentDate: obj.orderDate,
      deliveryDate: obj.deliveryDate,
      totalGrossWeight: totalGrossWeight,
      isHazmat: obj.isHazmat,
      commodityInfo: {
        freightClass: '',
        packaging: '',
        units: '',
        pieces: '',
        weight: {
          units: 'lbs', // Assuming weight units are pounds
          value: ''
        },
        nmfc: '',
        dimensions: {
          length: '',
          width: '',
          height: '',
          dimensionsUom: 'inches', // Assuming dimensions are in inches
          isStackable: false
        }
      },
      pickupOptions: {
        ...obj.pickupOptions,
        callBeforeDelivery: obj.pickupOptions.callBeforeDelivery || false
      },
      deliveryOptions: {
        ...obj.deliveryOptions,
        callBeforeDelivery: obj.deliveryOptions.callBeforeDelivery || false
      },
      codAmount: 0, // Default value
      declaredValue: 0, // Default value
      agencyId: 198, // Assuming agency ID is 198
      isGuaranteed: false, // Default value
      locationId: obj.locationId
    };
    // open your create dialog or trigger flow here
    dispatch(setQuickQuoteRateValues(secondObject));
    dispatch(
      setQuickQuoteTLRateValues(shipTypeValue === 'TL' ? TLquoteObj : obj)
    );

    history.push({
      pathname: '/add-locations',
      state: { type: 'quickQoute', assignedLocations: userLocationsArr }
    });
  };

  const getOrdinal = n => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };
  const finalStyle = screenWidth >= 1800 ? largeScreenStyle : responsiveStyle;
  return (
    <div
      style={
        layoutMode === 'dark'
          ? {
              backgroundColor: '#303841',
              display: 'flex',
              justifyContent: 'center',
              padding: '10 0 10 0'
            }
          : {
              display: 'flex',
              justifyContent: 'center',
              padding: '10 0 10 0'
            }
      }
    >
      <ToastContainer
        position='top-center'
        style={
          isMobile
            ? { width: '100%', display: 'flex', justifyContent: 'center' }
            : { width: 'auto' }
        }
        autoClose={7000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Snackbar
        sx={{ mb: 3 }}
        open={showWeightError}
        // autoHideDuration={8000}
        onClose={() => setShowWeightError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setShowWeightError(false)}
          severity='error'
          sx={{
            ml: 9,
            width: '100%',
            borderRadius: 2,
            boxShadow: 5,
            fontSize: 14
            // py: 1
          }}
        >
          <span dangerouslySetInnerHTML={{ __html: grossWeightError }} />
        </Alert>
      </Snackbar>
      <MetaTags>
        {/* <title>TMS | Quick Quote</title> */}
        <title>
          {' '}
          {base_url === 'https://beta.api.shiptechpro.com/'
            ? 'Quick Quote | Shiptechpro'
            : 'Quick Quote | TMS'}
        </title>
      </MetaTags>
      <div>
        <Grid container spacing={0} justifyContent='center'>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            justifyContent='center'
          >
            <Paper style={{ borderRadius: 5 }}>
              <Card
                sx={
                  isMobile
                    ? { width: '90vw' }
                    : {
                        width: '70vw'
                      }
                }
              >
                <CardContent
                  sx={
                    isMobile
                      ? { overflowY: 'scroll', position: 'relative' }
                      : {
                          height: '32vw',
                          overflowY: 'auto',
                          position: 'relative'
                        }
                  }
                >
                  <Grid container spacing={2}>
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      xl={4}
                    >
                      <Autocomplete
                        sx={{ m: 0, p: 0 }}
                        // multiple
                        fullWidth
                        size='small'
                        openOnFocus
                        // renderOption={(props, option) => (
                        //   <Box style={{ fontSize: 12, m: 0, p: 0 }} {...props}>
                        //     {option}
                        //   </Box>
                        // )}
                        options={ShipTypeArr}
                        value={selectedOptions}
                        onChange={(event, newValue) => {
                          setValidationErrors({
                            ...validationErrors,
                            shipTypeErr: null
                          });
                          if (newValue === 'TL') {
                            setSelectedOptions(newValue);
                            setShipTypeValue(newValue);
                            handleTlFlow();
                          } else if (newValue === 'LTL') {
                            setSelectedOptions(newValue);
                            setShipTypeValue(newValue);
                            handleLTLFlow();
                          } else if (newValue === 'Parcel') {
                            setSelectedOptions(newValue);
                            setShipTypeValue(newValue);
                            handleParcelFlow();
                          } else if (newValue === 'LTL/Parcel') {
                            setSelectedOptions(newValue);
                            setShipTypeValue(newValue);
                            handleLTLFlow();
                          }
                        }}
                        // isOptionDisabled={option => isOptionDisabled(option)}
                        renderOption={(props, option) => {
                          // const disabled = isOptionDisabled(option);
                          return (
                            <li
                              {...props}
                              style={{
                                fontSize: 13
                                // opacity: disabled ? 0.5 : 1,
                                // pointerEvents: disabled ? 'none' : 'auto'
                              }}
                            >
                              {option}
                            </li>
                          );
                        }}
                        renderInput={params => (
                          <TextField
                            {...params}
                            error={Boolean(validationErrors['shipTypeErr'])}
                            helperText={validationErrors['shipTypeErr']}
                            // placeholder='Ship type'
                            variant='standard'
                            sx={{
                              '& .MuiChip-root': {
                                fontSize: '13px', // Adjust font size here
                                height: '18px' // Optionally adjust chip height
                              }
                            }}
                            InputProps={{
                              style: { fontSize: 12, m: 0, p: 0 },
                              ...params.InputProps,
                              startAdornment: (
                                <>
                                  <InputAdornment position='start'>
                                    <MergeTypeIcon />
                                  </InputAdornment>
                                  {params.InputProps.startAdornment}
                                </>
                              )
                            }}
                            inputRef={selectShipType}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Autocomplete
                        fullWidth
                        disableClearable
                        openOnFocus
                        size='small'
                        // ✅ Selected option object
                        value={selectedLocation || null}
                        // ✅ Text inside the input
                        inputValue={shipLocationValue || ''}
                        // Needed when your options are objects
                        isOptionEqualToValue={(option, value) =>
                          option?.id === value?.id
                        }
                        // Keep your hover logic
                        onHighlightChange={(event, option) => {
                          !locationInputChange &&
                            setLocationHoveredValue(option);
                        }}
                        options={[
                          ...shipLocation,
                          ...(addLocPermission || UserIsAdmin
                            ? [
                                {
                                  isButton: true,
                                  label: '+ Add Location',
                                  id: 'Add-location'
                                }
                              ]
                            : [])
                        ]}
                        getOptionLabel={option => {
                          if (typeof option === 'string') return option; // free typing
                          if (
                            option?.isButton &&
                            (addLocPermission || UserIsAdmin)
                          )
                            return option.label; // special row
                          return option?.location?.split(': ')[1] || ''; // normal option
                        }}
                        filterOptions={(options, state) => {
                          const filtered = options
                            .slice(0, -1) // exclude the last "create" item from filtering
                            .filter(option =>
                              option?.location
                                ?.split(': ')[1]
                                ?.toLowerCase()
                                ?.includes(state.inputValue.toLowerCase())
                            );
                          // Always append "create" at end
                          return [...filtered, options[options.length - 1]];
                        }}
                        renderOption={(props, option, state) => {
                          if (
                            (addLocPermission || UserIsAdmin) &&
                            option.isButton
                          ) {
                            return (
                              <Box
                                {...props}
                                key='create-location'
                                sx={{
                                  fontSize: 13,
                                  fontWeight: 600,
                                  color: 'primary.main',
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                              >
                                {option.label}
                              </Box>
                            );
                          }
                          return (
                            <Box
                              {...props}
                              key={state.index}
                              sx={{ fontSize: 13 }}
                            >
                              <b>{option?.location.split(': ')[0] + ': '}</b>
                              &nbsp;
                              {option?.location.split(': ')[1]}
                            </Box>
                          );
                        }}
                        // ✅ Select option
                        onChange={(event, newValue, reason) => {
                          handleShipLocationChange(event, newValue, reason);
                        }}
                        // ✅ Typing in the field
                        onInputChange={(event, newInputValue, reason) => {
                          handleShipLocationChange(
                            event,
                            newInputValue,
                            reason
                          );
                        }}
                        loading={shipLocationLoader}
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant='standard'
                            placeholder='Select Locations'
                            error={Boolean(
                              validationErrors['shipTypeLocation']
                            )}
                            helperText={validationErrors['shipTypeLocation']}
                            onKeyDown={e => {
                              if (e.key === 'Tab' && locationHoveredValue) {
                                // treat as selecting the highlighted option
                                handleShipLocationChange(
                                  e,
                                  locationHoveredValue,
                                  'selectOption'
                                );
                                setOpenShipFrom(false);
                                setOpenShipTo(false);
                              }
                            }}
                            inputRef={selectLocations}
                            InputProps={{
                              style: { fontSize: 12 },
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position='start'>
                                  <LocationOnIcon />
                                </InputAdornment>
                              )
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Autocomplete
                        fullWidth
                        disableClearable
                        // onHighlightChange={(event, option) => {
                        //   !paymentTypeInputChange &&
                        //     setPaymentTypeHoveredValue(option);
                        // }}
                        onBlur={() => {
                          setPaymentTypeInputChange(false);
                          if (paymentTypeHoveredValue) {
                            handleChangePaymentType(
                              null,
                              paymentTypeHoveredValue
                            );
                          }
                        }}
                        openOnFocus
                        renderOption={(props, option) => (
                          <Box style={{ fontSize: 13 }} {...props}>
                            {option}
                          </Box>
                        )}
                        size='small'
                        options={
                          // shipTypeValue === 'LTL'
                          //   ?
                          LTLPaymentTypeArr
                          // : parcelPaymentTypeArr
                        }
                        disabled={!shipLocationValue ? true : false}
                        value={
                          // SelectedRates?.paymentType
                          //   ? SelectedRates?.paymentType
                          // :
                          paymentTypeValue
                        }
                        onChange={(event, newValue) => {
                          setPaymentTypeInputChange(false);
                          handleChangePaymentType(event, newValue);
                        }}
                        onInputChange={(event, newValue) =>
                          handleChangePaymentType(event, newValue)
                        }
                        // sx={{ marginLeft: 1 }}
                        renderInput={params => (
                          <TextField
                            onKeyDown={e => {
                              if (e.key === 'Tab' && paymentTypeHoveredValue) {
                                handleChangePaymentType(
                                  e,
                                  paymentTypeHoveredValue
                                );
                                setOpenShipFrom(false);
                                setOpenShipTo(false);
                              }
                            }}
                            error={Boolean(validationErrors['paymentTypeErr'])}
                            helperText={validationErrors['paymentTypeErr']}
                            // sx={{ width: 290 }}
                            placeholder='Payment Type'
                            variant='standard'
                            {...params}
                            InputProps={{
                              style: { fontSize: 12 },
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position='start'>
                                  <PaymentIcon />
                                </InputAdornment>
                              )
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                  {shipTypeValue === 'TL' ? (
                    <>
                      <Grid sx={{ mt: 1 }} container spacing={1}>
                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                          <Label
                            style={{
                              margin: '8px 0px 5px 0px',
                              fontWeight: 700,
                              fontSize: 12
                            }}
                          >
                            Pickup/Drop Mode
                          </Label>
                          <FormControl fullWidth size='small'>
                            <Select
                              // disabled
                              size='small'
                              id='pickup-drop-mode-select'
                              value={TLPickupMode}
                              onChange={handlePickupModeChange}
                              sx={{
                                fontSize: 13, // control font size
                                '& .MuiSelect-select': {
                                  fontSize: 13
                                }
                              }}
                            >
                              <MenuItem
                                value={'1 Pickup - 1 Drop'}
                                sx={{ fontSize: 13 }}
                              >
                                1 Pickup - 1 Drop
                              </MenuItem>
                              <MenuItem
                                value={'1 Pickup - Multiple Drops'}
                                sx={{ fontSize: 13 }}
                              >
                                1 Pickup - Multiple Drops
                              </MenuItem>

                              <MenuItem
                                value={'Multiple Pickups - 1 Drop'}
                                sx={{ fontSize: 13 }}
                              >
                                Multiple Pickups - 1 Drop
                              </MenuItem>

                              <MenuItem
                                value={'Multiple Pickups - Multiple Drops'}
                                sx={{ fontSize: 13 }}
                              >
                                Multiple Pickups - Multiple Drops
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                          <Label
                            style={{
                              margin: '8px 0px 5px 0px',
                              fontWeight: 700,
                              fontSize: 12
                            }}
                          >
                            Equipment Type
                          </Label>
                          <FormControl fullWidth size='small'>
                            <Select
                              size='small'
                              id='pickup-drop-mode-select'
                              value={TLequipmentType}
                              onChange={handleTLequipmentTypeChnage}
                              sx={{
                                fontSize: 13, // control font size
                                '& .MuiSelect-select': {
                                  fontSize: 13
                                }
                              }}
                            >
                              {TLequipmentArr.map(items => (
                                <MenuItem value={items} sx={{ fontSize: 13 }}>
                                  {items}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        {isReefer && (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={isReefer ? 2 : 2}
                            lg={isReefer ? 2 : 2}
                            xl={isReefer ? 2 : 2}
                          >
                            <Label
                              style={{
                                margin: '8px 0px 5px 0px',
                                fontWeight: 700,
                                fontSize: 12
                              }}
                            >
                              Required Temperature
                            </Label>

                            <Box display='flex' gap={0}>
                              <TextField
                                error={Boolean(tempError)}
                                helperText={tempError}
                                fullWidth
                                type='number'
                                placeholder={
                                  unit === '°C' ? 'e.g., -5.5°C' : 'e.g., 23°F'
                                }
                                value={temperature}
                                onChange={e => {
                                  setTempError('');
                                  setTemperature(e.target.value);
                                }}
                                inputProps={{
                                  step: '0.1',
                                  min: unit === '°C' ? -30 : -22,
                                  max: unit === '°C' ? 30 : 86,
                                  style: {
                                    padding: '8px 10px',
                                    fontSize: 13
                                  }
                                }}
                                InputProps={{
                                  sx: {
                                    height: 36
                                  }
                                }}
                                size='small'
                                variant='outlined'
                                sx={{
                                  '& .MuiInputBase-root': {
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                    height: 36,
                                    fontSize: 13
                                  }
                                }}
                              />

                              <TextField
                                select
                                value={unit}
                                onChange={e => setUnit(e.target.value)}
                                size='small'
                                variant='outlined'
                                sx={{
                                  minWidth: '4.5rem',
                                  '& .MuiInputBase-root': {
                                    borderTopLeftRadius: 0,
                                    borderBottomLeftRadius: 0,
                                    height: 36,
                                    fontSize: 13,
                                    paddingRight: '6px'
                                  },
                                  '& .MuiSelect-select': {
                                    padding: '8px 10px'
                                  }
                                }}
                              >
                                <MenuItem value='°C' sx={{ fontSize: 13 }}>
                                  °C
                                </MenuItem>
                                <MenuItem value='°F' sx={{ fontSize: 13 }}>
                                  °F
                                </MenuItem>
                              </TextField>
                            </Box>
                          </Grid>
                        )}
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={isReefer ? 2 : 4}
                          lg={isReefer ? 2 : 4}
                          xl={isReefer ? 2 : 4}
                        >
                          <Label
                            style={{
                              margin: '8px 0px 5px 0px',
                              fontWeight: 700,
                              fontSize: 12
                            }}
                          >
                            Driver Type
                          </Label>
                          <FormControl fullWidth size='small'>
                            <Select
                              size='small'
                              id='pickup-drop-mode-select'
                              value={TLDriverType}
                              onChange={handleTLDriverTypeChange}
                              sx={{
                                fontSize: 13, // control font size
                                '& .MuiSelect-select': {
                                  fontSize: 13
                                }
                              }}
                            >
                              <MenuItem value={'Team'} sx={{ fontSize: 13 }}>
                                Team
                              </MenuItem>
                              <MenuItem value={'Solo'} sx={{ fontSize: 13 }}>
                                Solo
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>

                      {multiPickupRows.map((pickupItems, pickupIndex) => {
                        return (
                          <Grid
                            sx={{
                              p: 1,
                              mt: 3,
                              display: 'flex',
                              flexDirection: 'column',
                              width: '100%',
                              border: '1px solid #d0d7de',
                              borderRadius: '10px',
                              boxShadow: '1 6px 20px rgba(0, 0, 0, 0.05)',
                              background:
                                'linear-gradient(375deg, #f0f0f0 , #ffffff)'
                            }}
                            container
                            // spacing={1}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                              }}
                            >
                              <Label
                                style={{
                                  padding: 2,
                                  margin: '1px 0px 15px 0px',
                                  fontWeight: 700,
                                  fontSize: 15
                                }}
                              >
                                {!TLPickupMode.includes('1 Pickup')
                                  ? `Pickup Address ${pickupIndex + 1}`
                                  : 'Pickup Information'}
                              </Label>

                              <Grid
                                item
                                sx={{ display: 'flex', alignItems: 'center' }}
                              >
                                <Grid
                                  item
                                  sx={{ display: 'flex', alignItems: 'center' }}
                                >
                                  <Grid item>
                                    <Box
                                      display='flex'
                                      alignItems='center'
                                      gap={1}
                                    >
                                      <Typography
                                        color='error'
                                        sx={{
                                          fontSize: 15,
                                          fontWeight: 'bold',
                                          color: 'red'
                                        }}
                                      >
                                        Hazmat?
                                      </Typography>
                                      <Switch
                                        size='small'
                                        checked={pickupItems.isHazmat}
                                        value={pickupItems.isHazmat}
                                        sx={{
                                          ...switchStyle,
                                          color: 'red',
                                          '& .MuiSwitch-switchBase.Mui-checked':
                                            {
                                              color: 'red'
                                            },
                                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track':
                                            {
                                              backgroundColor: 'red'
                                            }
                                        }}
                                        onChange={e =>
                                          setMultiPickupRows(prev =>
                                            prev.map((row, i) =>
                                              i === pickupIndex
                                                ? {
                                                    ...row,
                                                    isHazmat: e.target.checked
                                                  }
                                                : row
                                            )
                                          )
                                        }
                                        name='Hazmat'
                                      />
                                    </Box>
                                  </Grid>
                                </Grid>

                                {multiPickupRows.length > 1 && (
                                  <HighlightOffIcon
                                    onClick={() =>
                                      handleRemovePickup(pickupIndex)
                                    }
                                    sx={{
                                      cursor: 'pointer',
                                      color: '#f44336', // Red color
                                      fontSize: 24,
                                      transition:
                                        'transform 0.2s ease, color 0.2s ease',
                                      '&:hover': {
                                        transform: 'scale(1.3)',
                                        color: '#d32f2f' // Darker red on hover
                                      }
                                    }}
                                  />
                                )}
                              </Grid>
                            </Box>
                            <Box sx={{ display: 'flex' }} gap={2}>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={4}
                                lg={4}
                                xl={4}
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Label
                                  style={{
                                    margin: '0px 5px 1px 0px',
                                    fontWeight: 700,
                                    fontSize: 12
                                  }}
                                >
                                  <LocationOnIcon />
                                  {!TLPickupMode.includes('1 Pickup')
                                    ? `${getOrdinal(pickupIndex + 1)} Pickup`
                                    : 'Pickup Address'}
                                </Label>

                                {paymentTypeValue === 'Outbound Prepaid' ? (
                                  <Autocomplete
                                    disabled={pickupIndex === 0}
                                    fullWidth
                                    sx={{ backgroundColor: 'white' }}
                                    disableClearable
                                    openOnFocus
                                    size='small'
                                    value={pickupItems.pickupAddress || null}
                                    options={shipLocation}
                                    getOptionLabel={option => {
                                      if (typeof option === 'string')
                                        return option;
                                      if (
                                        option?.isButton &&
                                        (addLocPermission || UserIsAdmin)
                                      )
                                        return option.label;
                                      return (
                                        option?.location?.split(': ')[1] || ''
                                      );
                                    }}
                                    renderOption={(props, option, state) => {
                                      if (
                                        (addLocPermission || UserIsAdmin) &&
                                        option.isButton
                                      ) {
                                        return (
                                          <Box
                                            {...props}
                                            key='create-location'
                                            sx={{
                                              fontSize: 13,
                                              fontWeight: 600,
                                              color: 'primary.main',
                                              display: 'flex',
                                              alignItems: 'center'
                                            }}
                                          >
                                            {option.label}
                                          </Box>
                                        );
                                      }
                                      return (
                                        <Box
                                          {...props}
                                          key={state.index}
                                          sx={{ fontSize: 13 }}
                                        >
                                          <b>
                                            {option?.location.split(': ')[0] +
                                              ': '}
                                          </b>
                                          &nbsp;
                                          {option?.location.split(': ')[1]}
                                        </Box>
                                      );
                                    }}
                                    onChange={(event, newValue, reason) => {
                                      setShipFromFinalValue(newValue);
                                      handleClearRowValidationError(
                                        'pickupRows',
                                        pickupIndex,
                                        'pickupAddress'
                                      );
                                      setValidationErrors({
                                        ...validationErrors,
                                        shipFromErr: null
                                      });
                                      const details = parseTLFlowAddress(
                                        newValue.location?.split(': ')[1] || ''
                                      );

                                      setMultiPickupRows(prev =>
                                        prev.map((row, i) =>
                                          i === pickupIndex
                                            ? {
                                                ...row,
                                                city: details.city ?? '',
                                                state:
                                                  details.stateOrProvinceCode ??
                                                  '',
                                                zip: details.postalCode ?? '',
                                                country: details.countryCode,
                                                company:
                                                  userLocationsArr.filter(
                                                    items =>
                                                      items.id === newValue.id
                                                  )?.[0]?.companyName ?? '',
                                                email:
                                                  userLocationsArr
                                                    .filter(
                                                      items =>
                                                        items.id === newValue.id
                                                    )?.[0]
                                                    ?.contactEmail?.split(
                                                      ','
                                                    )[0]
                                                    .trim() ?? '',
                                                contactName:
                                                  userLocationsArr.filter(
                                                    items =>
                                                      items.id === newValue.id
                                                  )?.[0]?.contactName ?? '',
                                                phone:
                                                  userLocationsArr.filter(
                                                    items =>
                                                      items.id === newValue.id
                                                  )?.[0]?.contactPhone ?? '',
                                                address:
                                                  userLocationsArr.filter(
                                                    items =>
                                                      items.id === newValue.id
                                                  )?.[0]?.streetLines ?? '',
                                                pickupAddress:
                                                  details?.city +
                                                  ' ' +
                                                  details?.stateOrProvinceCode +
                                                  ' ' +
                                                  details?.postalCode +
                                                  ' ' +
                                                  details?.countryCode
                                              }
                                            : row
                                        )
                                      );
                                    }}
                                    renderInput={params => (
                                      <TextField
                                        {...params}
                                        variant='outlined'
                                        error={Boolean(
                                          TLValidationErrors?.pickupRows?.[
                                            pickupIndex
                                          ]?.pickupAddress
                                        )}
                                        helperText={
                                          TLValidationErrors?.pickupRows?.[
                                            pickupIndex
                                          ]?.pickupAddress
                                        }
                                        inputRef={el => {
                                          if (!selectShipFrom.current)
                                            selectShipFrom.current = [];
                                          selectShipFrom.current[pickupIndex] =
                                            el;
                                        }}
                                        InputProps={{
                                          style: { fontSize: 12 },
                                          ...params.InputProps
                                        }}
                                      />
                                    )}
                                  />
                                ) : (
                                  <AddressAutocomplete
                                    fontSize={13}
                                    inputRef={el => {
                                      if (!selectShipFrom.current)
                                        selectShipFrom.current = [];
                                      selectShipFrom.current[pickupIndex] = el;
                                    }}
                                    locationFlow='TLMultiDropCase'
                                    errorMsg={'pickupAddress'}
                                    validattionErrors={
                                      TLValidationErrors?.pickupRows?.[
                                        pickupIndex
                                      ]
                                    }
                                    inputVariant='outlined'
                                    defaultValue={pickupItems.pickupAddress}
                                    onInputChange={val => {
                                      setShipFromFinalValue(val);
                                      handleClearRowValidationError(
                                        'pickupRows',
                                        pickupIndex,
                                        'pickupAddress'
                                      );
                                      setValidationErrors({
                                        ...validationErrors,
                                        shipFromErr: null
                                      });
                                    }}
                                    onSelectDetails={details => {
                                      if (!details) {
                                        setCity('');
                                        setState('');
                                        setZip('');
                                        setCountry('');
                                      } else {
                                        setMultiPickupRows(prev =>
                                          prev.map((row, i) =>
                                            i === pickupIndex
                                              ? {
                                                  ...row,
                                                  pickupAddress: [
                                                    details?.company &&
                                                    details?.company?.toLowerCase() !==
                                                      details?.streetLines?.toLowerCase()
                                                      ? details.company
                                                      : null,
                                                    details?.streetLines,
                                                    details?.city,
                                                    details?.state,
                                                    details?.zip,
                                                    details?.country
                                                  ]
                                                    .filter(Boolean)
                                                    .join(', ')
                                                }
                                              : row
                                          )
                                        );

                                        setMultiPickupRows(prev =>
                                          prev.map((row, i) =>
                                            i === pickupIndex
                                              ? {
                                                  ...row,
                                                  company:
                                                    details?.company || '',
                                                  city: details.city,
                                                  state: details.state,
                                                  zip: details.zip,
                                                  country: details.country,
                                                  address: details?.streetLines
                                                }
                                              : row
                                          )
                                        );

                                        setCity(details.city);
                                      }
                                    }}
                                    inputType='quickQuote'
                                  />
                                )}
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={2.5}
                                lg={2.5}
                                xl={2.5}
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Label
                                  style={{
                                    // margin: '10px 0px 6px 0px',
                                    margin: '0px 5px 10px 0px',
                                    fontWeight: 700,
                                    fontSize: 12,
                                    whiteSpace: 'nowrap'
                                  }}
                                >
                                  Pickup Date
                                </Label>

                                <DateRangeFilter
                                  inputRef={pickupDatepickerRef}
                                  handleIconClick={handlePickupDateIconClick}
                                  minDate={new Date()}
                                  selected={pickupItems.pickupDate}
                                  onChange={date => {
                                    setMultiPickupRows(prev =>
                                      prev.map((row, i) =>
                                        i === pickupIndex
                                          ? {
                                              ...row,
                                              pickupDate: date.date
                                            }
                                          : row
                                      )
                                    );
                                  }}
                                  // setShipmentDDate(date.displayDate);
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={2.5}
                                lg={2.5}
                                xl={2.5}
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Label
                                  style={{
                                    // margin: '10px 0px 6px 0px',
                                    margin: '0px 5px 10px 0px',
                                    fontWeight: 700,
                                    fontSize: 12,
                                    whiteSpace: 'nowrap'
                                  }}
                                >
                                  Exp. Delivery Date
                                </Label>
                                <DateRangeFilter
                                  key={pickupIndex}
                                  inputRef={el =>
                                    (datepickerRef.current[pickupIndex] = el)
                                  }
                                  handleIconClick={() =>
                                    handleIconClick(pickupIndex)
                                  }
                                  minDate={new Date(pickupItems.pickupDate)}
                                  selected={pickupItems.expPickDeliveryDate}
                                  onChange={date => {
                                    setMultiPickupRows(prev => {
                                      const updatedPickups = prev.map(
                                        (row, i) =>
                                          i === pickupIndex
                                            ? {
                                                ...row,
                                                expPickDeliveryDate: date.date
                                              }
                                            : row
                                      );

                                      const firstPickupDate =
                                        updatedPickups[0]
                                          ?.expPickDeliveryDate || null;

                                      setMultiDropsRows(prevDrops =>
                                        prevDrops.map(row => ({
                                          ...row,
                                          expDropDeliveryDate: firstPickupDate
                                        }))
                                      );

                                      handleClearRowValidationError(
                                        'pickupRows',
                                        pickupIndex,
                                        'expPickDeliveryDate'
                                      );

                                      return updatedPickups;
                                    });
                                  }}
                                  placeholderText='Select Delivery Date'
                                  deliveryDateError={deliveryDateError}
                                />
                                {TLValidationErrors?.pickupRows?.[
                                  pickupIndex
                                ]?.['expPickDeliveryDate'] && (
                                  <span
                                    style={{
                                      marginBottom: -5,
                                      color: 'rgb(211, 47, 47)',
                                      fontWeight: '400',
                                      fontSize: '0.79rem',
                                      fontFamily:
                                        'Roboto, Helvetica, Arial, sans-serif'
                                    }}
                                  >
                                    Select delivery date
                                  </span>
                                )}
                              </Grid>

                              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                <div>
                                  <div
                                    className='mt-0 d-flex flex-column'
                                    style={{ width: '15.5vw' }}
                                  >
                                    <Label
                                      style={{
                                        margin: '0px 5px 1px 0px',
                                        fontWeight: 700,
                                        fontSize: 12,
                                        whiteSpace: 'nowrap'
                                      }}
                                    >
                                      Pickup Hours
                                    </Label>
                                    <div className='mt-2 d-flex justify-content-between'>
                                      <TextField
                                        size='small'
                                        label='Open Time'
                                        value={pickupItems.pickupOpenHours}
                                        onChange={e => {
                                          setMultiPickupRows(prev =>
                                            prev.map((row, i) =>
                                              i === pickupIndex
                                                ? {
                                                    ...row,
                                                    pickupOpenHours:
                                                      e.target.value
                                                  }
                                                : row
                                            )
                                          );
                                        }}
                                        type='time'
                                        sx={{
                                          width: '48%',
                                          '& input': {
                                            backgroundColor: 'white',
                                            fontSize: '13px'
                                          },
                                          '& label': {
                                            fontSize: '13px'
                                          }
                                        }}
                                      />

                                      <TextField
                                        size='small'
                                        label='Close Time'
                                        value={pickupItems.pickupCloseHours}
                                        onChange={e => {
                                          setMultiPickupRows(prev =>
                                            prev.map((row, i) =>
                                              i === pickupIndex
                                                ? {
                                                    ...row,
                                                    pickupCloseHours:
                                                      e.target.value
                                                  }
                                                : row
                                            )
                                          );
                                        }}
                                        type='time'
                                        sx={{
                                          width: '48%',
                                          '& input': {
                                            backgroundColor: 'white',
                                            fontSize: '13px'
                                          },
                                          '& label': {
                                            fontSize: '13px'
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Grid>
                            </Box>

                            {pickupItems.pickupLineItems.map(
                              (items, index, arr) => (
                                <Grid
                                  container
                                  sx={
                                    {
                                      // display: 'flex',
                                      // justifyContent: 'center',
                                      // alignItems: 'center'
                                    }
                                  }
                                  spacing={2}
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={1.5}
                                    lg={1.5}
                                    xl={1.5}
                                  >
                                    <Label
                                      style={{
                                        margin:
                                          arr.length > 1
                                            ? '10px 0px 6px 22px'
                                            : '10px 0px 6px 2px',
                                        fontWeight: 700,
                                        fontSize: 12,
                                        whiteSpace: 'noWrap'
                                      }}
                                    >
                                      {shipTypeValue === 'TL'
                                        ? 'Net Weight (lbs)'
                                        : 'Weight (lbs)'}
                                    </Label>

                                    <Grid
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                      }}
                                    >
                                      {arr.length > 1 && (
                                        <RemoveCircleIcon
                                          style={{
                                            cursor: 'pointer'
                                          }}
                                          onClick={e =>
                                            handleRemoveMultiPickupLineItem(
                                              pickupIndex,
                                              index
                                            )
                                          }
                                        />
                                      )}

                                      <TextField
                                        InputLabelProps={{
                                          style: { fontSize: 12 }
                                        }}
                                        InputProps={{
                                          inputMode: 'numeric',
                                          style: { height: 32, fontSize: 12 }
                                        }}
                                        sx={{ backgroundColor: 'white' }}
                                        fullWidth
                                        inputRef={el => {
                                          if (
                                            !weightRefs.current[pickupIndex]
                                          ) {
                                            weightRefs.current[pickupIndex] =
                                              [];
                                          }
                                          weightRefs.current[pickupIndex][
                                            index
                                          ] = el;
                                        }}
                                        error={Boolean(
                                          TLValidationErrors?.pickupRows?.[
                                            pickupIndex
                                          ]?.pickupLineItems?.[index]?.WeightLBS
                                        )}
                                        helperText={
                                          TLValidationErrors?.pickupRows?.[
                                            pickupIndex
                                          ]?.pickupLineItems?.[index]?.WeightLBS
                                        }
                                        FormHelperTextProps={{
                                          style: {
                                            whiteSpace: 'nowrap',
                                            margin: '0 0 0 0'
                                          }
                                        }}
                                        value={
                                          items.WeightLBS === 0
                                            ? ''
                                            : formatNumberWithCommas(
                                                items.WeightLBS
                                              )
                                        }
                                        onChange={e => {
                                          handleMultiLineItemChange(
                                            'pickupRows',
                                            pickupIndex,
                                            index,
                                            'WeightLBS',
                                            e.target.value
                                          );
                                          handleClearMultiItemErrors(
                                            'pickupRows',
                                            pickupIndex,
                                            index,
                                            'WeightLBS',
                                            e.target.value
                                          );
                                        }}
                                        size='small'
                                        type='text'
                                      />
                                    </Grid>
                                    {index + 1 === arr.length && (
                                      <AddCircleIcon
                                        color='success'
                                        style={{
                                          cursor: 'pointer',
                                          marginTop: 8
                                        }}
                                        onClick={e =>
                                          handleAddMultiPickups(e, pickupIndex)
                                        }
                                      />
                                    )}
                                  </Grid>

                                  {shipTypeValue !== 'Parcel' && (
                                    <Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={2}
                                      lg={1}
                                      xl={1}
                                    >
                                      <Label
                                        style={{
                                          margin: '10px 0px 6px 0px',
                                          fontWeight: 700,
                                          fontSize: 12,
                                          whiteSpace: 'nowrap'
                                        }}
                                      >
                                        Class
                                      </Label>
                                      <Autocomplete
                                        fullWidth
                                        // onHighlightChange={(event, option) => {
                                        //   setFreightClassHoveredValue(option);
                                        // }}
                                        disableClearable
                                        onBlur={() => {
                                          if (items.Class) {
                                            handleMultiLineItemChange(
                                              'pickupRows',
                                              pickupIndex,
                                              index,
                                              'Class',
                                              items.Class
                                            );
                                          }
                                        }}
                                        renderOption={(props, option) => (
                                          <Box
                                            style={{ fontSize: 13 }}
                                            {...props}
                                          >
                                            {option}
                                          </Box>
                                        )}
                                        name='Class'
                                        size='small'
                                        options={ClassArray}
                                        // defaultValue={'50'}
                                        value={items.Class}
                                        onChange={(event, newValue) =>
                                          handleMultiLineItemChange(
                                            'pickupRows',
                                            pickupIndex,
                                            index,
                                            'Class',
                                            newValue
                                          )
                                        }
                                        onInputChange={(event, newValue) =>
                                          handleMultiLineItemChange(
                                            'pickupRows',
                                            pickupIndex,
                                            index,
                                            'Class',
                                            newValue
                                          )
                                        }
                                        sx={{ backgroundColor: 'white' }}
                                        renderInput={params => (
                                          <TextField
                                            onKeyDown={e => {
                                              if (
                                                e.key === 'Tab' &&
                                                items.Class
                                              ) {
                                                // e.preventDefault(); // prevent the default Tab behavior
                                                handleMultiLineItemChange(
                                                  'pickupRows',
                                                  pickupIndex,
                                                  index,
                                                  'Class',
                                                  items.Class
                                                );
                                              }
                                            }}
                                            // sx={{ width: 90 }}
                                            // placeholder='Payment Type'
                                            variant='outlined'
                                            {...params}
                                            InputProps={{
                                              style: {
                                                fontSize: 12,
                                                height: 32
                                              },
                                              ...params.InputProps
                                            }}
                                          />
                                        )}
                                      />
                                    </Grid>
                                  )}

                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={3}
                                    lg={1}
                                    xl={1}
                                  >
                                    <Label
                                      style={{
                                        margin: '10px 0px 6px -3px',
                                        fontWeight: 700,
                                        fontSize: 12,
                                        whiteSpace: 'nowrap'
                                      }}
                                    >
                                      Gross Weight
                                    </Label>
                                    <TextField
                                      inputRef={el => {
                                        if (
                                          !grossWeightRefs.current[pickupIndex]
                                        ) {
                                          grossWeightRefs.current[pickupIndex] =
                                            [];
                                        }
                                        grossWeightRefs.current[pickupIndex][
                                          index
                                        ] = el;
                                      }}
                                      fullWidth
                                      className={classes.inputRoot}
                                      error={Boolean(
                                        TLValidationErrors?.pickupRows?.[
                                          pickupIndex
                                        ]?.pickupLineItems?.[index]?.GrossWeight
                                      )}
                                      helperText={
                                        TLValidationErrors?.pickupRows?.[
                                          pickupIndex
                                        ]?.pickupLineItems?.[index]?.GrossWeight
                                      }
                                      FormHelperTextProps={{
                                        style: {
                                          whiteSpace: 'nowrap',
                                          margin: '0 0 0 0'
                                        }
                                      }}
                                      value={formatNumberWithCommas(
                                        items.GrossWeight
                                      )}
                                      onChange={e => {
                                        handleMultiLineItemChange(
                                          'pickupRows',
                                          pickupIndex,
                                          index,
                                          'GrossWeight',
                                          e.target.value
                                        );
                                        handleClearMultiItemErrors(
                                          'pickupRows',
                                          pickupIndex,
                                          index,
                                          'GrossWeight',
                                          e.target.value
                                        );
                                      }}
                                      size='small'
                                      type='text'
                                      InputLabelProps={{
                                        style: { fontSize: 12 }
                                      }}
                                      InputProps={{
                                        // min: 0,
                                        style: {
                                          height: 32,
                                          fontSize: 12
                                        }
                                      }}
                                      sx={{ backgroundColor: 'white' }}
                                    />
                                  </Grid>

                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={2}
                                    lg={1.5}
                                    xl={1.5}
                                  >
                                    <Label
                                      style={{
                                        margin: '10px 0px 6px 0px',
                                        fontWeight: 700,
                                        fontSize: 12
                                      }}
                                    >
                                      {shipTypeValue === 'TL'
                                        ? 'Handling Units'
                                        : 'Packaging Type'}
                                    </Label>
                                    <Autocomplete
                                      // onHighlightChange={(event, option) => {
                                      //   setUnitTypeHoveredValue(option);
                                      // }}
                                      disableClearable
                                      fullWidth
                                      onBlur={() => {
                                        if (items.UnitTypeValue) {
                                          handleMultiLineItemChange(
                                            'pickupRows',
                                            pickupIndex,
                                            index,
                                            'UnitTypeValue',
                                            items.UnitTypeValue
                                          );
                                        }
                                      }}
                                      renderOption={(props, option) => (
                                        <Box
                                          style={{ fontSize: 13 }}
                                          {...props}
                                        >
                                          {option}
                                        </Box>
                                      )}
                                      // sx={{ m: 1 }}
                                      size='small'
                                      options={LTLUnitTypeArr}
                                      value={items.UnitTypeValue}
                                      onChange={(event, newValue) => {
                                        handleMultiLineItemChange(
                                          'pickupRows',
                                          pickupIndex,
                                          index,
                                          'UnitTypeValue',
                                          newValue
                                        );
                                        multiDropsRows.forEach(
                                          (items, outerIndex) =>
                                            items.deliveryLineItems.map(
                                              (nestedItems, innerIndex) =>
                                                handleMultilineItemChange(
                                                  outerIndex,
                                                  innerIndex,
                                                  'UnitTypeValue',
                                                  newValue
                                                )
                                            )
                                        );
                                      }}
                                      onInputChange={(event, newValue) => {
                                        handleMultiLineItemChange(
                                          'pickupRows',
                                          pickupIndex,
                                          index,
                                          'UnitTypeValue',
                                          newValue
                                        );
                                        multiDropsRows.forEach(
                                          (items, outerIndex) =>
                                            items.deliveryLineItems.map(
                                              (nestedItems, innerIndex) =>
                                                handleMultilineItemChange(
                                                  outerIndex,
                                                  innerIndex,
                                                  'UnitTypeValue',
                                                  newValue
                                                )
                                            )
                                        );
                                      }}
                                      sx={{ backgroundColor: 'white' }}
                                      renderInput={params => (
                                        <TextField
                                          fullWidth
                                          onKeyDown={e => {
                                            if (
                                              e.key === 'Tab' &&
                                              items.UnitTypeValue
                                            ) {
                                              handleMultiLineItemChange(
                                                'pickupRows',
                                                pickupIndex,
                                                index,
                                                'UnitTypeValue',
                                                items.UnitTypeValue
                                              );
                                            }
                                          }}
                                          variant='outlined'
                                          {...params}
                                          InputProps={{
                                            style: { fontSize: 12, height: 32 },
                                            ...params.InputProps
                                          }}
                                        />
                                      )}
                                    />
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={1}
                                    lg={1}
                                    xl={1}
                                  >
                                    <Label
                                      style={{
                                        whiteSpace: 'nowrap',
                                        margin: '10px 0px 6px 0px',
                                        fontWeight: 700,
                                        fontSize: 12
                                      }}
                                    >
                                      Quantity
                                    </Label>
                                    <Grid
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <TextField
                                        fullWidth
                                        error={Boolean(
                                          validationErrors[
                                            `numberOfUnits${index}`
                                          ]
                                        )}
                                        helperText={
                                          validationErrors[
                                            `numberOfUnits${index}`
                                          ]
                                        }
                                        FormHelperTextProps={{
                                          style: {
                                            whiteSpace: 'nowrap',
                                            margin: '0 0 -15 0'
                                          }
                                        }}
                                        value={formatNumberWithCommas(
                                          items.NmbOfUnits
                                        )}
                                        onChange={e =>
                                          handleMultiLineItemChange(
                                            'pickupRows',
                                            pickupIndex,
                                            index,
                                            'NmbOfUnits',
                                            e.target.value
                                          )
                                        }
                                        size='small'
                                        sx={
                                          isMobile
                                            ? {
                                                backgroundColor: 'white',
                                                '& input[type=number]::-webkit-outer-spin-button':
                                                  {
                                                    ...spinnerStyles
                                                  },
                                                '& input[type=number]::-webkit-inner-spin-button':
                                                  {
                                                    ...spinnerStyles
                                                  }
                                              }
                                            : { backgroundColor: 'white' }
                                        }
                                        type='text'
                                        inputProps={{
                                          style: {
                                            height: 15,
                                            fontSize: 12
                                          },
                                          min: 0
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={2}
                                    lg={2}
                                    xl={2}
                                  >
                                    <Label
                                      style={{
                                        margin: '10px 0px 6px 1px',
                                        fontWeight: 700,
                                        fontSize: 12
                                      }}
                                    >
                                      Dimensions
                                    </Label>
                                    <Grid sx={{ display: 'flex' }}>
                                      <TextField
                                        fullWidth
                                        error={Boolean(
                                          validationErrors['PlengthError']
                                        )}
                                        helperText={
                                          validationErrors['PlengthError']
                                        }
                                        FormHelperTextProps={{
                                          style: {
                                            whiteSpace: 'nowrap',
                                            margin: '0 0 -10 0'
                                          }
                                        }}
                                        value={
                                          items.Length
                                            ? formatNumberWithCommas(
                                                items.Length
                                              )
                                            : ''
                                        }
                                        onChange={e =>
                                          handleMultiLineItemChange(
                                            'pickupRows',
                                            pickupIndex,
                                            index,
                                            'Length',
                                            e.target.value
                                          )
                                        }
                                        type='text'
                                        onKeyPress={handleKeyPress}
                                        // className='inputRounded_Length'
                                        size='small'
                                        // sx={{ width: 95 }}
                                        label='L'
                                        className={classes.input}
                                        // autoComplete='current-password'
                                        // value={'L'}
                                        InputLabelProps={{
                                          style: { fontSize: 11 }
                                        }}
                                        inputProps={{
                                          style: {
                                            height: 15,
                                            fontSize: 12,
                                            textAlign: 'center'
                                          }
                                        }}
                                        sx={{ backgroundColor: 'white' }}
                                      />
                                      <TextField
                                        sx={{ backgroundColor: 'white' }}
                                        fullWidth
                                        error={Boolean(
                                          validationErrors['PwidthError']
                                        )}
                                        helperText={
                                          validationErrors['PwidthError']
                                        }
                                        FormHelperTextProps={{
                                          style: {
                                            whiteSpace: 'nowrap',
                                            margin: '0 0 -10 0'
                                          }
                                        }}
                                        value={
                                          items.Width
                                            ? formatNumberWithCommas(
                                                items.Width
                                              )
                                            : ''
                                        }
                                        onChange={e =>
                                          handleMultiLineItemChange(
                                            'pickupRows',
                                            pickupIndex,
                                            index,
                                            'Width',
                                            e.target.value
                                          )
                                        }
                                        type='text'
                                        onKeyPress={handleKeyPress}
                                        // className='inputRounded_Width'
                                        className={classes.input}
                                        size='small'
                                        // sx={{ width: 95 }}
                                        label='W'
                                        // value={'W'}
                                        InputLabelProps={{
                                          style: { fontSize: 11 }
                                        }}
                                        inputProps={{
                                          style: {
                                            height: 15,
                                            fontSize: 12,
                                            textAlign: 'center'
                                          }
                                        }}
                                      />
                                      <TextField
                                        sx={{ backgroundColor: 'white' }}
                                        fullWidth
                                        error={Boolean(
                                          validationErrors['PheightError']
                                        )}
                                        helperText={
                                          validationErrors['PheightError']
                                        }
                                        FormHelperTextProps={{
                                          style: {
                                            whiteSpace: 'nowrap',
                                            margin: '0 0 -10 0'
                                          }
                                        }}
                                        value={
                                          items.Height
                                            ? formatNumberWithCommas(
                                                items.Height
                                              )
                                            : ''
                                        }
                                        onChange={e =>
                                          handleMultiLineItemChange(
                                            'pickupRows',
                                            pickupIndex,
                                            index,
                                            'Height',
                                            e.target.value
                                          )
                                        }
                                        type='text'
                                        onKeyPress={handleKeyPress}
                                        className={classes.input}
                                        // className='inputRounded_Height'
                                        size='small'
                                        // sx={{ width: 95 }}
                                        label='H'
                                        // value={'H'}
                                        InputLabelProps={{
                                          style: { fontSize: 11 }
                                        }}
                                        inputProps={{
                                          style: {
                                            height: 15,
                                            fontSize: 12,
                                            textAlign: 'center'
                                          }
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      whiteSpace: 'nowrap'
                                    }}
                                    item
                                    xs={12}
                                    sm={12}
                                    md={3}
                                    lg={3}
                                    xl={3}
                                  >
                                    <Label
                                      style={{
                                        margin: '10px 0px 6px -3px',
                                        fontWeight: 700,
                                        fontSize: 12
                                      }}
                                    >
                                      Item Description
                                    </Label>
                                    <TextField
                                      sx={{ backgroundColor: 'white' }}
                                      type='text'
                                      placeholder='Enter item description'
                                      inputProps={{
                                        style: {
                                          height: 15,
                                          fontSize: 12
                                        }
                                      }}
                                      fullWidth
                                      size='small'
                                      value={items.itemText}
                                      onChange={e =>
                                        handleMultiLineItemChange(
                                          'pickupRows',
                                          pickupIndex,
                                          index,
                                          'itemText',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Grid>
                                  <Grid
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      whiteSpace: 'nowrap'
                                    }}
                                    item
                                    xs={12}
                                    sm={12}
                                    md={1}
                                    lg={1}
                                    xl={1}
                                  >
                                    <Label
                                      style={{
                                        margin: '10px 0px 6px -3px',
                                        fontWeight: 700,
                                        fontSize: 12
                                      }}
                                    >
                                      Stackable?
                                    </Label>
                                    <FormControl
                                      sx={{ fontSize: 12, height: 32 }}
                                      fullWidth
                                      size='small'
                                    >
                                      <Select
                                        size='small'
                                        id='pickup-drop-mode-select'
                                        value={items.StackAble ? 'Yes' : 'No'}
                                        onChange={e =>
                                          handleMultiLineItemChange(
                                            'pickupRows',
                                            pickupIndex,
                                            index,
                                            'StackAble',
                                            e.target.value
                                          )
                                        }
                                        sx={{
                                          backgroundColor: 'white',
                                          fontSize: 12,
                                          height: 30,
                                          '& .MuiSelect-select': {
                                            fontSize: 12
                                          }
                                        }}
                                      >
                                        <MenuItem
                                          value={'Yes'}
                                          sx={{ fontSize: 12 }}
                                        >
                                          Yes
                                        </MenuItem>
                                        <MenuItem
                                          value={'No'}
                                          sx={{ fontSize: 12 }}
                                        >
                                          No
                                        </MenuItem>
                                      </Select>
                                    </FormControl>

                                    <Typography
                                      style={{
                                        margin: '10 0 0 0',
                                        fontSize: 12,
                                        fontWeight: 'bold',
                                        color: '#1976d2',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end'
                                      }}
                                    >
                                      <u>
                                        {index ===
                                          pickupItems.pickupLineItems.length -
                                            1 &&
                                          pickupIndex ===
                                            multiPickupRows.length - 1 && (
                                            <span>
                                              Total pickup shipment gross weight{' '}
                                              {totalGrossWeightLBS > 0 &&
                                                formatNumberWithCommas(
                                                  totalGrossWeightLBS
                                                )}{' '}
                                              (lbs)
                                            </span>
                                          )}
                                      </u>
                                    </Typography>
                                  </Grid>
                                </Grid>
                              )
                            )}
                          </Grid>
                        );
                      })}
                      {!TLPickupMode.includes('1 Pickup') && (
                        <Grid
                          item
                          sx={{
                            mt: 2,
                            display: 'flex',
                            justifyContent: 'center'
                          }}
                        >
                          <Button
                            onClick={e => handleAddMorePickups(e)}
                            size='small'
                            variant='contained'
                            color='info'
                          >
                            Add More Pickups
                          </Button>
                        </Grid>
                      )}

                      <Grid
                        sx={{
                          p: 1,
                          mt: 3,
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                          border: '1px solid #d0d7de',
                          borderRadius: '10px',
                          boxShadow: '1 6px 20px rgba(0, 0, 0, 0.05)',
                          background:
                            'linear-gradient(375deg, #f0f0f0 , #ffffff)'
                        }}
                        mt={2}
                        width='100%'
                      >
                        <Label
                          style={{
                            // padding: 2,
                            margin: '1px 0px 15px 0px',
                            fontWeight: 700,
                            fontSize: 13
                          }}
                        >
                          Pickup Instructions
                        </Label>
                        {/* <ReactQuill
                          style={{
                            width: '100%',
                            height: '60px',
                            // marginTop: 10,
                            backgroundColor: 'white'
                          }}
                          value={pickupRemarks}
                          onChange={e => {
                            setPickupRemarks(e);
                          }}
                        /> */}
                        <TextField
                          placeholder='Enter pickup instructions'
                          fullWidth
                          multiline
                          value={pickupRemarks}
                          onChange={e => {
                            setPickupRemarks(e.target.value);
                          }}
                          sx={{ backgroundColor: 'white' }}
                          inputProps={{
                            style: {
                              fontSize: 12
                            }
                          }}
                        />
                      </Grid>

                      {multiDropsRows.map((multiDrops, index) => {
                        return (
                          <Grid
                            sx={{
                              p: 1,
                              mt: 6,
                              display: 'flex',
                              flexDirection: 'column',
                              width: '100%',
                              border: '1px solid #d0d7de',
                              borderRadius: '10px',
                              boxShadow: '1 6px 20px rgba(0, 0, 0, 0.05)',
                              background:
                                'linear-gradient(415deg, #f0f0f0 , #ffffff)'
                            }}
                            container
                            // spacing={1}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                              }}
                            >
                              <Label
                                style={{
                                  padding: 2,
                                  margin: '1px 0px 15px 0px',
                                  fontWeight: 700,
                                  fontSize: 15
                                }}
                              >
                                {!TLPickupMode.includes('1 Drop')
                                  ? `Delivery Address ${index + 1}`
                                  : 'Delivery Information'}
                              </Label>
                              {multiDropsRows.length > 1 && (
                                <HighlightOffIcon
                                  onClick={() => handleRemoveDrop(index)}
                                  sx={{
                                    cursor: 'pointer',
                                    color: '#f44336', // Red color
                                    fontSize: 24,
                                    transition:
                                      'transform 0.2s ease, color 0.2s ease',
                                    '&:hover': {
                                      transform: 'scale(1.3)',
                                      color: '#d32f2f' // Darker red on hover
                                    }
                                  }}
                                />
                              )}
                            </Box>
                            <Box sx={{ display: 'flex' }} gap={2}>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={7}
                                lg={7}
                                xl={7}
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Label
                                  style={{
                                    margin: '0px 5px 3px 0px',
                                    fontWeight: 700,
                                    fontSize: 12
                                  }}
                                >
                                  <WhereToVoteIcon />
                                  {!TLPickupMode.includes('1 Drop')
                                    ? `${getOrdinal(index + 1)} Drop`
                                    : 'Delivery Address'}
                                </Label>

                                {paymentTypeValue === 'Inbound Collect' ? (
                                  <Autocomplete
                                    disabled={index === 0}
                                    fullWidth
                                    sx={{ backgroundColor: 'white' }}
                                    disableClearable
                                    openOnFocus
                                    size='small'
                                    value={multiDrops.dropAddress || null}
                                    options={shipLocation}
                                    getOptionLabel={option => {
                                      if (typeof option === 'string')
                                        return option;
                                      if (
                                        option?.isButton &&
                                        (addLocPermission || UserIsAdmin)
                                      )
                                        return option.label;
                                      return (
                                        option?.location?.split(': ')[1] || ''
                                      );
                                    }}
                                    renderOption={(props, option, state) => {
                                      if (
                                        (addLocPermission || UserIsAdmin) &&
                                        option.isButton
                                      ) {
                                        return (
                                          <Box
                                            {...props}
                                            key='create-location'
                                            sx={{
                                              fontSize: 13,
                                              fontWeight: 600,
                                              color: 'primary.main',
                                              display: 'flex',
                                              alignItems: 'center'
                                            }}
                                          >
                                            {option.label}
                                          </Box>
                                        );
                                      }
                                      return (
                                        <Box
                                          {...props}
                                          key={state.index}
                                          sx={{ fontSize: 13 }}
                                        >
                                          <b>
                                            {option?.location.split(': ')[0] +
                                              ': '}
                                          </b>
                                          &nbsp;
                                          {option?.location.split(': ')[1]}
                                        </Box>
                                      );
                                    }}
                                    onChange={(event, newValue, reason) => {
                                      setShipToFinalValue(newValue);
                                      handleClearRowValidationError(
                                        'dropRows',
                                        index,
                                        'dropAddress'
                                      );
                                      setValidationErrors({
                                        ...validationErrors,
                                        shipToErr: null
                                      });
                                      const details = parseTLFlowAddress(
                                        newValue.location?.split(': ')[1] || ''
                                      );

                                      setMultiDropsRows(prev =>
                                        prev.map((row, i) =>
                                          i === index
                                            ? {
                                                ...row,
                                                city: details.city ?? '',
                                                state:
                                                  details.stateOrProvinceCode ??
                                                  '',
                                                zip: details.postalCode ?? '',
                                                country: details.countryCode,
                                                company:
                                                  userLocationsArr.filter(
                                                    items =>
                                                      items.id === newValue.id
                                                  )?.[0]?.companyName ?? '',
                                                email:
                                                  userLocationsArr
                                                    .filter(
                                                      items =>
                                                        items.id === newValue.id
                                                    )?.[0]
                                                    ?.contactEmail?.split(
                                                      ','
                                                    )[0]
                                                    .trim() ?? '',
                                                contactName:
                                                  userLocationsArr.filter(
                                                    items =>
                                                      items.id === newValue.id
                                                  )?.[0]?.contactName ?? '',
                                                phone:
                                                  userLocationsArr.filter(
                                                    items =>
                                                      items.id === newValue.id
                                                  )?.[0]?.contactPhone ?? '',
                                                address:
                                                  userLocationsArr.filter(
                                                    items =>
                                                      items.id === newValue.id
                                                  )?.[0]?.streetLines ?? '',
                                                dropAddress:
                                                  details?.city +
                                                  ' ' +
                                                  details?.stateOrProvinceCode +
                                                  ' ' +
                                                  details?.postalCode +
                                                  ' ' +
                                                  details?.countryCode
                                              }
                                            : row
                                        )
                                      );
                                    }}
                                    renderInput={params => (
                                      <TextField
                                        {...params}
                                        variant='outlined'
                                        error={Boolean(
                                          TLValidationErrors?.dropRows?.[index]
                                            ?.pickupAddress
                                        )}
                                        helperText={
                                          TLValidationErrors?.dropRows?.[index]
                                            ?.pickupAddress
                                        }
                                        inputRef={el => {
                                          if (
                                            Array.isArray(selectShipTo.current)
                                          ) {
                                            selectShipTo.current[index] = el;
                                          } else {
                                            selectShipTo.current = [];
                                            selectShipTo.current[index] = el;
                                          }
                                        }}
                                        InputProps={{
                                          style: { fontSize: 12 },
                                          ...params.InputProps
                                        }}
                                      />
                                    )}
                                  />
                                ) : (
                                  <AddressAutocomplete
                                    fontSize={13}
                                    inputRef={el => {
                                      if (Array.isArray(selectShipTo.current)) {
                                        selectShipTo.current[index] = el;
                                      } else {
                                        selectShipTo.current = [];
                                        selectShipTo.current[index] = el;
                                      }
                                    }}
                                    locationFlow='TLMultiDropCase'
                                    errorMsg={'dropAddress'}
                                    validattionErrors={
                                      TLValidationErrors?.dropRows?.[index]
                                    }
                                    inputVariant='outlined'
                                    defaultValue={multiDrops.dropAddress}
                                    onInputChange={val => {
                                      setShipToFinalValue(val);

                                      handleClearRowValidationError(
                                        'dropRows',
                                        index,
                                        'dropAddress'
                                      );
                                    }}
                                    onSelectDetails={details => {
                                      if (!details) {
                                        setCity('');
                                        setState('');
                                        setZip('');
                                        setCountry('');
                                      } else {
                                        setMultiDropsRows(prev =>
                                          prev.map((row, i) =>
                                            i === index
                                              ? {
                                                  ...row,
                                                  dropAddress: [
                                                    details?.company &&
                                                    details?.company?.toLowerCase() !==
                                                      details?.streetLines?.toLowerCase()
                                                      ? details.company
                                                      : null,
                                                    details?.streetLines,
                                                    details?.city,
                                                    details?.state,
                                                    details?.zip,
                                                    details?.country
                                                  ]
                                                    .filter(Boolean)
                                                    .join(', ')
                                                }
                                              : row
                                          )
                                        );
                                        setMultiDropsRows(prev =>
                                          prev.map((row, i) =>
                                            i === index
                                              ? {
                                                  ...row,
                                                  company:
                                                    details?.company || '',
                                                  city: details.city,
                                                  state: details.state,
                                                  zip: details.zip,
                                                  country: details.country,
                                                  address: details?.streetLines
                                                }
                                              : row
                                          )
                                        );
                                      }
                                    }}
                                    inputType='quickQuote'
                                  />
                                )}
                              </Grid>

                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={2.5}
                                lg={2.5}
                                xl={2.5}
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Label
                                  style={{
                                    // margin: '10px 0px 6px 0px',
                                    margin: '0px 5px 10px 0px',
                                    fontWeight: 700,
                                    fontSize: 12,
                                    whiteSpace: 'nowrap'
                                  }}
                                >
                                  Exp. Delivery Date
                                </Label>
                                <DateRangeFilter
                                  inputRef={deliveryDatepickerRef}
                                  handleIconClick={handleDeliveryDateIconClick}
                                  minDate={
                                    new Date(
                                      [...multiPickupRows]
                                        .filter(item => item.pickupDate)
                                        .sort(
                                          (a, b) =>
                                            new Date(a.pickupDate) -
                                            new Date(b.pickupDate)
                                        )[0]?.pickupDate
                                    )
                                  }
                                  maxDate={
                                    new Date(
                                      [...multiPickupRows]
                                        .filter(
                                          item => item.expPickDeliveryDate
                                        )
                                        .sort(
                                          (a, b) =>
                                            new Date(b.expPickDeliveryDate) -
                                            new Date(a.expPickDeliveryDate)
                                        )[0]?.expPickDeliveryDate
                                    )
                                  }
                                  selected={multiDrops.expDropDeliveryDate}
                                  onChange={date => {
                                    setMultiDropsRows(prev =>
                                      prev.map((row, i) =>
                                        i === index
                                          ? {
                                              ...row,
                                              expDropDeliveryDate: date.date
                                              // expDeliveryDisplayDate:
                                              //   date.displayDate
                                            }
                                          : row
                                      )
                                    );
                                    handleClearRowValidationError(
                                      'dropRows',
                                      index,
                                      'expDropDeliveryDate'
                                    );
                                  }}
                                  placeholderText='Select Delivery Date'
                                  deliveryDateError={deliveryDateError}
                                />
                                {TLValidationErrors?.dropRows?.[index]?.[
                                  'expDropDeliveryDate'
                                ] && (
                                  <span
                                    style={{
                                      marginBottom: -10,
                                      color: 'rgb(211, 47, 47)',
                                      fontWeight: '400',
                                      fontSize: '0.85rem',
                                      fontFamily:
                                        'Roboto, Helvetica, Arial, sans-serif'
                                    }}
                                  >
                                    Select delivery date
                                  </span>
                                )}
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={!TLPickupMode.includes('1 Drop') ? 3 : 5}
                                lg={!TLPickupMode.includes('1 Drop') ? 3 : 5}
                                xl={!TLPickupMode.includes('1 Drop') ? 3 : 5}
                              >
                                <div>
                                  <div
                                    className='mt-0 d-flex flex-column'
                                    // style={{ width: '15.5vw' }}
                                  >
                                    <Label
                                      style={{
                                        margin: '0px 5px 1px 0px',
                                        fontWeight: 700,
                                        fontSize: 12,
                                        whiteSpace: 'nowrap'
                                      }}
                                    >
                                      Delivery Hours
                                    </Label>
                                    <div className='mt-2 d-flex justify-content-between'>
                                      <TextField
                                        size='small'
                                        label='Open Time'
                                        value={multiDrops.deliveryOpenHours}
                                        onChange={e => {
                                          setMultiDropsRows(prev =>
                                            prev.map((row, i) =>
                                              i === index
                                                ? {
                                                    ...row,
                                                    deliveryOpenHours:
                                                      e.target.value
                                                  }
                                                : row
                                            )
                                          );
                                          // setOriginOpenTimeValue(e.target.value);
                                          // setValidationErrors({
                                          //   ...validationErrors,
                                          //   originOpenTime: null
                                          // });
                                        }}
                                        type='time'
                                        sx={{
                                          backgroundColor: 'white',
                                          width: '48%',
                                          '& input': {
                                            fontSize: '13px'
                                          },
                                          '& label': {
                                            fontSize: '13px'
                                          }
                                        }}
                                        InputProps={{
                                          sx: {
                                            backgroundColor: 'white',
                                            fontSize: '13px',
                                            height: '36px',
                                            '& input': {
                                              backgroundColor: 'white',
                                              fontSize: '13px'
                                            }
                                          }
                                        }}
                                      />

                                      <TextField
                                        size='small'
                                        label='Close Time'
                                        value={multiDrops.deliveryCloseHours}
                                        onChange={e => {
                                          setMultiDropsRows(prev =>
                                            prev.map((row, i) =>
                                              i === index
                                                ? {
                                                    ...row,
                                                    deliveryCloseHours:
                                                      e.target.value
                                                  }
                                                : row
                                            )
                                          );
                                          // setOriginCloseTimeValue(e.target.value);
                                          // setValidationErrors({
                                          //   ...validationErrors,
                                          //   originOpenTime: null
                                          // });
                                        }}
                                        type='time'
                                        InputProps={{
                                          sx: {
                                            backgroundColor: 'white',
                                            fontSize: '13px',
                                            height: '36px',
                                            '& input': {
                                              backgroundColor: 'white',
                                              fontSize: '13px'
                                            }
                                          }
                                        }}
                                        sx={{
                                          backgroundColor: 'white',
                                          width: '48%',
                                          '& input': {
                                            fontSize: '13px'
                                          },
                                          '& label': {
                                            fontSize: '13px'
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Grid>
                            </Box>
                            {!TLPickupMode.includes('1 Drop') &&
                              multiDrops.deliveryLineItems.map(
                                (lineItems, lineItemIndex, lineItemsArr) => (
                                  <Grid
                                    container
                                    sx={
                                      {
                                        // display: 'flex',
                                        // justifyContent: 'center',
                                        // alignItems: 'center'
                                      }
                                    }
                                    spacing={2}
                                  >
                                    <Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={1.5}
                                      lg={1.5}
                                      xl={1.5}
                                    >
                                      <Label
                                        style={{
                                          margin:
                                            lineItemsArr.length > 1
                                              ? '10px 0px 6px 24px'
                                              : '10px 0px 6px 2px',
                                          fontWeight: 700,
                                          fontSize: 12
                                        }}
                                      >
                                        {shipTypeValue === 'TL'
                                          ? 'Handling Units'
                                          : 'Packaging Type'}
                                      </Label>

                                      <Grid
                                        sx={{
                                          display: 'flex'
                                        }}
                                      >
                                        {lineItemsArr.length > 1 && (
                                          <RemoveCircleIcon
                                            style={{
                                              cursor: 'pointer',
                                              marginTop: 3
                                            }}
                                            onClick={e =>
                                              handleRemoveMultiDropsLineItems(
                                                index,
                                                lineItemIndex
                                              )
                                            }
                                          />
                                        )}

                                        <Autocomplete
                                          disableClearable
                                          fullWidth
                                          renderOption={(props, option) => (
                                            <Box
                                              style={{ fontSize: 13 }}
                                              {...props}
                                            >
                                              {option}
                                            </Box>
                                          )}
                                          sx={{ backgroundColor: 'white' }}
                                          size='small'
                                          options={[
                                            ...new Set(
                                              multiPickupRows.flatMap(row =>
                                                row.pickupLineItems.map(
                                                  items => items.UnitTypeValue
                                                )
                                              )
                                            )
                                          ]}
                                          value={lineItems.UnitTypeValue}
                                          onChange={(event, newValue) => {
                                            handleMultilineItemChange(
                                              index,
                                              lineItemIndex,
                                              'UnitTypeValue',
                                              newValue
                                            );
                                          }}
                                          onInputChange={(event, newValue) => {
                                            handleMultilineItemChange(
                                              index,
                                              lineItemIndex,
                                              'UnitTypeValue',
                                              newValue
                                            );
                                          }}
                                          // sx={{ marginLeft: 1 }}
                                          renderInput={params => (
                                            <TextField
                                              fullWidth
                                              variant='outlined'
                                              {...params}
                                              InputProps={{
                                                style: {
                                                  fontSize: 12,
                                                  height: 32
                                                },
                                                ...params.InputProps
                                              }}
                                            />
                                          )}
                                        />
                                      </Grid>
                                      {lineItemIndex + 1 ===
                                        lineItemsArr.length && (
                                        <AddCircleIcon
                                          color='success'
                                          style={{
                                            cursor: 'pointer',
                                            marginTop: 8
                                          }}
                                          onClick={e =>
                                            handleAddMultiDropsLineItems(
                                              e,
                                              index
                                            )
                                          }
                                        />
                                      )}
                                    </Grid>

                                    <Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={2}
                                      lg={1.5}
                                      xl={1.5}
                                    >
                                      <Label
                                        style={{
                                          margin: '10px 0px 6px 0px',
                                          fontWeight: 700,
                                          fontSize: 12,
                                          whiteSpace: 'nowrap'
                                        }}
                                      >
                                        Gross Weight
                                      </Label>
                                      <TextField
                                        inputRef={el => {
                                          if (
                                            !grossWeightRefsDelivery.current[
                                              index
                                            ]
                                          ) {
                                            grossWeightRefsDelivery.current[
                                              index
                                            ] = [];
                                          }
                                          grossWeightRefsDelivery.current[
                                            index
                                          ][lineItemIndex] = el;
                                        }}
                                        fullWidth
                                        className={classes.inputRoot}
                                        error={
                                          !!TLValidationErrors?.dropRows?.[
                                            index
                                          ]?.deliveryLineItems?.[lineItemIndex]
                                            ?.GrossWeight ||
                                          !!multiDropsErrors?.[index]
                                            ?.deliveryLineItems?.[lineItemIndex]
                                            ?.GrossWeight
                                        }
                                        helperText={[
                                          TLValidationErrors?.dropRows?.[index]
                                            ?.deliveryLineItems?.[lineItemIndex]
                                            ?.GrossWeight,
                                          multiDropsErrors?.[index]
                                            ?.deliveryLineItems?.[lineItemIndex]
                                            ?.GrossWeight
                                        ]
                                          .filter(Boolean)
                                          .join(' | ')}
                                        FormHelperTextProps={{
                                          style: {
                                            whiteSpace: 'nowrap',
                                            margin: '0 0 0 0'
                                          }
                                        }}
                                        value={formatNumberWithCommas(
                                          lineItems.GrossWeight
                                        )}
                                        onChange={e => {
                                          handleMultilineItemChange(
                                            index,
                                            lineItemIndex,
                                            'GrossWeight',
                                            e.target.value
                                          );
                                          handleClearMultiItemErrors(
                                            'dropRows',
                                            index,
                                            lineItemIndex,
                                            'GrossWeight',
                                            e.target.value
                                          );
                                        }}
                                        size='small'
                                        type='text'
                                        InputLabelProps={{
                                          style: { fontSize: 12 }
                                        }}
                                        InputProps={{
                                          // min: 0,
                                          style: {
                                            height: 32,
                                            fontSize: 12
                                          }
                                        }}
                                        sx={{ backgroundColor: 'white' }}
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={1}
                                      lg={1}
                                      xl={1}
                                    >
                                      <Label
                                        style={{
                                          whiteSpace: 'nowrap',
                                          margin: '10px 0px 6px 5px',
                                          fontWeight: 700,
                                          fontSize: 12
                                        }}
                                      >
                                        Quantity
                                      </Label>
                                      <Grid
                                        sx={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center'
                                        }}
                                      >
                                        <TextField
                                          fullWidth
                                          error={!!lineItems.NmbOfUnitsError}
                                          helperText={lineItems.NmbOfUnitsError}
                                          FormHelperTextProps={{
                                            style: {
                                              whiteSpace: 'nowrap'
                                              // margin: '0 0 -15 0'
                                            }
                                          }}
                                          value={formatNumberWithCommas(
                                            lineItems.NmbOfUnits
                                          )}
                                          onChange={e =>
                                            handleMultilineItemChange(
                                              index,
                                              lineItemIndex,
                                              'NmbOfUnits',
                                              e.target.value
                                            )
                                          }
                                          size='small'
                                          sx={
                                            isMobile
                                              ? {
                                                  '& input[type=number]::-webkit-outer-spin-button':
                                                    {
                                                      ...spinnerStyles
                                                    },
                                                  '& input[type=number]::-webkit-inner-spin-button':
                                                    {
                                                      ...spinnerStyles
                                                    }
                                                }
                                              : { backgroundColor: 'white' }
                                          }
                                          type='text'
                                          inputProps={{
                                            style: {
                                              height: 15,
                                              fontSize: 12
                                            },
                                            min: 0
                                          }}
                                        />
                                      </Grid>
                                    </Grid>

                                    <Grid
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        whiteSpace: 'nowrap'
                                      }}
                                      item
                                      xs={12}
                                      sm={12}
                                      md={7}
                                      lg={7}
                                      xl={7}
                                    >
                                      <Label
                                        style={{
                                          margin: '10px 0px 6px 3px',
                                          fontWeight: 700,
                                          fontSize: 12
                                        }}
                                      >
                                        Item Description
                                      </Label>
                                      <Autocomplete
                                        freeSolo // allows custom input not in options
                                        options={[
                                          ...new Set(
                                            multiPickupRows.flatMap(row => {
                                              const items = Array.isArray(
                                                row.pickupLineItems
                                              )
                                                ? row.pickupLineItems
                                                : [row.pickupLineItems];

                                              return items
                                                .filter(
                                                  item =>
                                                    item.UnitTypeValue ===
                                                    lineItems.UnitTypeValue
                                                )
                                                .map(item => item.itemText);
                                            })
                                          )
                                        ].filter(Boolean)}
                                        value={lineItems.itemText || ''}
                                        onInputChange={(event, newInputValue) =>
                                          handleMultilineItemChange(
                                            index,
                                            lineItemIndex,
                                            'itemText',
                                            newInputValue
                                          )
                                        }
                                        renderInput={params => (
                                          <TextField
                                            {...params}
                                            placeholder='Enter item description'
                                            fullWidth
                                            size='small'
                                            sx={{ backgroundColor: 'white' }}
                                            inputProps={{
                                              ...params.inputProps,
                                              style: {
                                                height: 15,
                                                fontSize: 12
                                              }
                                            }}
                                          />
                                        )}
                                      />
                                    </Grid>
                                    <Grid
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        // alignItems: 'center',
                                        // justifyContent: 'space-between',
                                        whiteSpace: 'nowrap'
                                        // mt: 3
                                      }}
                                      item
                                      xs={12}
                                      sm={12}
                                      md={1}
                                      lg={1}
                                      xl={1}
                                    >
                                      <Label
                                        style={{
                                          margin: '10px 0px 6px -3px',
                                          fontWeight: 700,
                                          fontSize: 12
                                        }}
                                      >
                                        Stackable?
                                      </Label>
                                      <FormControl
                                        sx={{ fontSize: 12, height: 32 }}
                                        fullWidth
                                        size='small'
                                      >
                                        <Select
                                          disabled
                                          size='small'
                                          id='pickup-drop-mode-select'
                                          value={''}
                                          onChange={e =>
                                            handleMultilineItemChange(
                                              index,
                                              lineItemIndex,
                                              'StackAble',
                                              e.target.value
                                            )
                                          }
                                          sx={{
                                            backgroundColor: 'white',
                                            fontSize: 12,
                                            height: 30,
                                            '& .MuiSelect-select': {
                                              fontSize: 12
                                            }
                                          }}
                                        >
                                          <MenuItem
                                            value={'Yes'}
                                            sx={{ fontSize: 12 }}
                                          >
                                            Yes
                                          </MenuItem>
                                          <MenuItem
                                            value={'No'}
                                            sx={{ fontSize: 12 }}
                                          >
                                            No
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                      <Typography
                                        style={{
                                          margin: '10 0 0 0',
                                          fontSize: 12,
                                          fontWeight: 'bold',
                                          color: '#1976d2',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'flex-end'
                                        }}
                                      >
                                        <u>
                                          {lineItemIndex ===
                                            multiDrops?.deliveryLineItems
                                              ?.length -
                                              1 &&
                                            index ===
                                              multiDropsRows.length - 1 && (
                                              <span>
                                                Total delivery gross weight{' '}
                                                {totalDeliveryGrossWeight > 0 &&
                                                  formatNumberWithCommas(
                                                    totalDeliveryGrossWeight
                                                  )}{' '}
                                                (lbs)
                                              </span>
                                            )}
                                        </u>
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                )
                              )}
                          </Grid>
                        );
                      })}
                      <Grid
                        sx={{
                          p: 1,
                          mt: 3,
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                          border: '1px solid #d0d7de',
                          borderRadius: '10px',
                          boxShadow: '1 6px 20px rgba(0, 0, 0, 0.05)',
                          background:
                            'linear-gradient(375deg, #f0f0f0 , #ffffff)'
                        }}
                        mt={2}
                        width='100%'
                      >
                        <Label
                          style={{
                            // padding: 2,
                            margin: '1px 0px 15px 0px',
                            fontWeight: 700,
                            fontSize: 13
                          }}
                        >
                          Delivery Instructions
                        </Label>

                        <TextField
                          sx={{ backgroundColor: 'white' }}
                          inputProps={{
                            style: {
                              fontSize: 12
                            }
                          }}
                          fullWidth
                          placeholder='Enter delivery instructions'
                          multiline
                          value={deliveryRemarks}
                          onChange={e => {
                            setDeliveryRemarks(e.target.value);
                          }}
                        />
                      </Grid>
                      {!TLPickupMode.includes('1 Drop') && (
                        <Grid
                          item
                          sx={{
                            mt: 2,
                            display: 'flex',
                            justifyContent: 'center'
                          }}
                        >
                          <Button
                            onClick={e => handleAddMoreDrops(e)}
                            size='small'
                            variant='contained'
                            color='info'
                          >
                            Add More Drops
                          </Button>
                        </Grid>
                      )}
                    </>
                  ) : shipTypeValue !== 'TL' ? (
                    <>
                      <Grid sx={{ mt: 1 }} container spacing={0}>
                        <Label
                          style={{
                            margin: '8px 0px 1px 0px',
                            fontWeight: 700,
                            fontSize: 12
                          }}
                        >
                          Shipment Info
                        </Label>
                        <Grid sx={{ mt: 0 }} container spacing={2}>
                          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            <Autocomplete
                              fullWidth
                              sx={{
                                '& .MuiAutocomplete-noOptions': {
                                  display: 'none'
                                }
                              }}
                              open={openShipFrom}
                              onHighlightChange={(event, option) => {
                                !shipFromHoveredValue &&
                                  setShipFromHoveredValue(option);
                              }}
                              onBlur={() => {
                                if (shipFromHoveredValue) {
                                  onShipFromChange(null, shipFromHoveredValue);
                                }
                              }}
                              renderOption={(props, option, state) => (
                                <Box
                                  style={{ fontSize: 13 }}
                                  {...props}
                                  key={state.index}
                                >
                                  {option}
                                </Box>
                              )}
                              disabled={paymentTypeValue === 'Outbound Prepaid'}
                              filterOptions={filterOptions}
                              onFocus={event => {
                                setOpenShipTo(false);
                                event.stopPropagation();
                              }}
                              size='small'
                              options={shipCity}
                              value={
                                paymentTypeValue === 'Outbound Prepaid' ||
                                paymentTypeValue === 'Sender'
                                  ? shipLocationValue
                                  : shipFromFinalValue
                              }
                              onChange={(event, newValue) =>
                                onShipFromChange(event, newValue)
                              }
                              onInputChange={(event, newValue) => {
                                onShipFromChange(event, newValue);
                                shipLocationValue !== newValue &&
                                  setOpenShipFrom(!!newValue);
                              }}
                              onClose={() => setOpenShipFrom(false)}
                              loading={shipFromloading}
                              renderInput={params => (
                                <TextField
                                  placeholder='Search with Zipcode'
                                  {...params}
                                  onKeyDown={e => {
                                    if (
                                      e.key === 'Tab' &&
                                      shipFromHoveredValue
                                    ) {
                                      onShipFromChange(e, shipFromHoveredValue);
                                    }
                                  }}
                                  slotProps={{
                                    input: {
                                      ...params.InputProps,
                                      endAdornment: (
                                        <React.Fragment>
                                          {shipFromloading ? (
                                            <CircularProgress
                                              color='inherit'
                                              size={20}
                                            />
                                          ) : null}
                                          {params.InputProps.endAdornment}
                                        </React.Fragment>
                                      )
                                    }
                                  }}
                                  inputRef={selectShipFrom}
                                  error={Boolean(
                                    validationErrors['shipFromErr']
                                  )}
                                  helperText={validationErrors['shipFromErr']}
                                  label='Ship From'
                                  disableClearable
                                  InputLabelProps={{ style: { fontSize: 12 } }}
                                  InputProps={{
                                    style: {
                                      fontSize: 12
                                    },
                                    ...params.InputProps
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            <Autocomplete
                              fullWidth
                              loading={shipToloading}
                              open={openShipTo}
                              onHighlightChange={(event, option) => {
                                !shipToHoveredValue &&
                                  setShipToHoveredValue(option);
                              }}
                              onChange={(event, newValue) =>
                                onShipToChange(event, newValue)
                              }
                              onInputChange={(event, newValue) => {
                                onShipToChange(event, newValue);
                                shipLocationValue !== newValue &&
                                  setOpenShipTo(!!newValue);
                              }}
                              onClose={() => setOpenShipTo(false)}
                              renderOption={(props, option) => (
                                <Box style={{ fontSize: 13 }} {...props}>
                                  {option}
                                </Box>
                              )}
                              filterOptions={filterOptions}
                              disabled={
                                paymentTypeValue === 'Inbound Collect' ||
                                paymentTypeValue === 'Receiver'
                                  ? true
                                  : false
                              }
                              size='small'
                              // sx={{ width: 290 }}
                              options={shipCity}
                              value={
                                paymentTypeValue === 'Inbound Collect' ||
                                paymentTypeValue === 'Receiver'
                                  ? shipLocationValue
                                  : shipToFinalValue
                              }
                              onFocus={event => {
                                setOpenShipFrom(false);
                                event.stopPropagation();
                              }}
                              // onChange={onShipToChange}
                              renderInput={params => (
                                <TextField
                                  placeholder='Search with Zipcode'
                                  onKeyDown={e => {
                                    if (e.key === 'Tab' && shipToHoveredValue) {
                                      // e.preventDefault(); // prevent the default Tab behavior
                                      onShipToChange(e, shipToHoveredValue);
                                    }
                                  }}
                                  disableClearable
                                  inputRef={selectShipTo}
                                  // required={true}
                                  {...params}
                                  error={Boolean(validationErrors['shipToErr'])}
                                  helperText={validationErrors['shipToErr']}
                                  label='Ship To'
                                  InputLabelProps={{ style: { fontSize: 12 } }}
                                  InputProps={{
                                    style: {
                                      fontSize: 12
                                    },
                                    ...params.InputProps
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            <Stack
                              spacing={-2}
                              direction='row'
                              sx={{
                                alignItems: 'start',
                                mb: 0,
                                position: 'relative'
                              }}
                            >
                              {/* <div style={{ width: '100%', position: 'relative', display: 'flex', spacing: -2 }}> */}
                              <LocationOnIcon
                                color='info'
                                sx={{ zIndex: 99, my: -1 }}
                              />
                              <PrettoSlider
                                aria-label='Distance-miles'
                                value={distanceMiles === 0 ? 0 : 40}
                                step={15}
                                marks
                              />
                              <LocalShippingIcon
                                color='info'
                                fontSize='large'
                                sx={{
                                  position: 'absolute',
                                  left: distanceMiles === 0 ? '10%' : '40%',
                                  top: -15
                                }}
                              />
                              <Typography
                                style={{
                                  position: 'absolute',
                                  left: distanceMiles === 0 ? '10%' : '32%',
                                  top: 20,
                                  color: '#1976d2'
                                }}
                              >
                                {distanceMiles}
                              </Typography>
                              <WhereToVoteIcon
                                color='info'
                                sx={{ zIndex: 99, my: -1 }}
                              />
                            </Stack>

                            {/* <TextField
                          fullWidth
                          onChange={e => setShipmentDate(e.target.value)}
                          size='small'
                          // sx={
                          //   shipTypeValue === 'LTL'
                          //     ? { width: 170, marginRight: 1 }
                          //     : { width: 290 }
                          // }
                          disabled
                          id='outlined-password-input'
                          defaultValue={shipmentDate}
                          type='date'
                          InputLabelProps={{ style: { fontSize: 12 } }}
                          inputProps={{
                            min: today,
                            style: {
                              fontSize: 12
                            }
                          }}
                        /> */}
                          </Grid>
                        </Grid>
                      </Grid>

                      {shipTypeValue === 'Tanker' ? (
                        <div>
                          <Label
                            style={{
                              margin: '20px 0px 20px 0px',
                              fontWeight: 700,
                              fontSize: 12
                            }}
                          >
                            Tanker / Equipment Requirements
                          </Label>
                        </div>
                      ) : (
                        <>
                          {/* <div style={{ marginTop: 5 }}>
                        Distance in Miles: {distanceMiles}
                      </div> */}
                          <div>
                            <Label
                              style={{
                                margin: '17px 0px 1px 0px',
                                fontWeight: 700,
                                fontSize: 12
                              }}
                            >
                              Commodity Info
                            </Label>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    ''
                  )}

                  <>
                    {shipTypeValue === 'Tanker' ? (
                      <div style={{ height: '20vh' }}>
                        <ReactQuill
                          style={{ height: '15vh' }}
                          // value={pickupInstContent}
                          // onChange={handlePickupInstEditorChange}
                        />
                      </div>
                    ) : (
                      shipTypeValue !== 'TL' &&
                      newAddedDimensionsRow.map((items, index, arr) => (
                        <Grid
                          container
                          sx={
                            {
                              // display: 'flex',
                              // justifyContent: 'center',
                              // alignItems: 'center'
                            }
                          }
                          spacing={2}
                        >
                          <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <Label
                              style={{
                                margin: '10px 0px 6px 28px',
                                fontWeight: 700,
                                fontSize: 12,
                                whiteSpace: 'noWrap'
                              }}
                            >
                              {shipTypeValue === 'TL'
                                ? 'Net Weight (lbs) '
                                : 'Weight (lbs)'}
                            </Label>

                            <Grid
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}
                            >
                              {index + 1 === arr.length && arr.length > 1 ? (
                                <AddCircleIcon
                                  style={{
                                    cursor: 'pointer'
                                  }}
                                  onClick={e => handleAddNewRow('dimensions')}
                                />
                              ) : arr.length == 1 ? (
                                <AddCircleIcon
                                  style={{
                                    cursor: 'pointer'
                                  }}
                                  onClick={e => handleAddNewRow('dimensions')}
                                />
                              ) : (
                                <RemoveCircleIcon
                                  style={{
                                    cursor: 'pointer'
                                  }}
                                  onClick={e =>
                                    handleSubtractNewRow('dimensions', index)
                                  }
                                />
                              )}

                              <TextField
                                fullWidth
                                className={classes.inputRoot}
                                inputRef={enterWeight}
                                error={Boolean(
                                  validationErrors[`weightEr${index}`]
                                )}
                                helperText={
                                  validationErrors[`weightEr${index}`]
                                }
                                FormHelperTextProps={{
                                  style: {
                                    whiteSpace: 'nowrap',
                                    margin: '0 0 0 0'
                                  }
                                }}
                                value={
                                  items.WeightLBS === 0
                                    ? ''
                                    : formatNumberWithCommas(items.WeightLBS)
                                }
                                onChange={e =>
                                  handleDimensionsInputChange(
                                    'WeightLBS',
                                    index,
                                    e
                                  )
                                }
                                size='small'
                                // sx={{ ml: 0.5 }}
                                // sx={
                                //   shipTypeValue === 'LTL'
                                //     ? { width: 100 }
                                //     : { width: 190 }
                                // }
                                id='outlined-weight'
                                type='text'
                                // autoComplete='current-password'
                                InputLabelProps={{
                                  style: { fontSize: 12 }
                                }}
                                InputProps={{
                                  inputMode: 'numeric',
                                  // min: 0,
                                  style: {
                                    height: 32,
                                    fontSize: 12
                                  }
                                }}
                              />
                            </Grid>
                          </Grid>

                          {shipTypeValue !== 'Parcel' && (
                            <Grid item xs={12} sm={12} md={2} lg={1.5} xl={1.5}>
                              <Label
                                style={{
                                  margin: '10px 0px 6px 0px',
                                  fontWeight: 700,
                                  fontSize: 12,
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                Freight Class
                              </Label>
                              <Autocomplete
                                fullWidth
                                // onHighlightChange={(event, option) => {
                                //   setFreightClassHoveredValue(option);
                                // }}
                                disableClearable
                                onBlur={() => {
                                  if (freightClassHoveredValue) {
                                    handleDimensionsInputChange(
                                      'Class',
                                      index,
                                      freightClassHoveredValue
                                    );
                                  }
                                }}
                                renderOption={(props, option) => (
                                  <Box style={{ fontSize: 13 }} {...props}>
                                    {option}
                                  </Box>
                                )}
                                name='Class'
                                size='small'
                                options={ClassArray}
                                // defaultValue={'50'}
                                value={items.Class}
                                onChange={(event, newValue) =>
                                  handleDimensionsInputChange(
                                    'Class',
                                    index,
                                    newValue
                                  )
                                }
                                onInputChange={(event, newValue) =>
                                  handleDimensionsInputChange(
                                    'Class',
                                    index,
                                    newValue
                                  )
                                }
                                // sx={{ marginLeft: 1 }}
                                renderInput={params => (
                                  <TextField
                                    onKeyDown={e => {
                                      if (
                                        e.key === 'Tab' &&
                                        freightClassHoveredValue
                                      ) {
                                        // e.preventDefault(); // prevent the default Tab behavior
                                        handleDimensionsInputChange(
                                          'Class',
                                          e,
                                          freightClassHoveredValue
                                        );
                                      }
                                    }}
                                    // sx={{ width: 90 }}
                                    // placeholder='Payment Type'
                                    variant='outlined'
                                    {...params}
                                    InputProps={{
                                      style: { fontSize: 12, height: 32 },
                                      ...params.InputProps
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                          )}
                          {shipTypeValue !== 'TL' ? (
                            <>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={2}
                                lg={shipTypeValue === 'Parcel' ? 2 : 1.5}
                                xl={shipTypeValue === 'Parcel' ? 2 : 1.5}
                              >
                                <Label
                                  style={{
                                    margin: '10px 0px 6px 0px',
                                    fontWeight: 700,
                                    fontSize: 12
                                  }}
                                >
                                  Unit Type
                                </Label>
                                <Autocomplete
                                  // onHighlightChange={(event, option) => {
                                  //   setUnitTypeHoveredValue(option);
                                  // }}
                                  disableClearable
                                  fullWidth
                                  onBlur={() => {
                                    if (unitTypeHoveredValue) {
                                      handleDimensionsInputChange(
                                        'UnitType',
                                        index,
                                        unitTypeHoveredValue
                                      );
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <Box style={{ fontSize: 13 }} {...props}>
                                      {option}
                                    </Box>
                                  )}
                                  // sx={{ m: 1 }}
                                  size='small'
                                  options={
                                    shipTypeValue === 'Parcel'
                                      ? ParcelUnitTypeArr
                                      : LTLUnitTypeArr
                                  }
                                  value={
                                    // shipTypeValue === 'Parcel'
                                    //   ? ParcelUnitTypeArr[0]
                                    //   :
                                    items.UnitTypeValue
                                  }
                                  onChange={(event, newValue) => {
                                    handleDimensionsInputChange(
                                      'UnitType',
                                      index,
                                      newValue
                                    );
                                  }}
                                  onInputChange={(event, newValue) => {
                                    handleDimensionsInputChange(
                                      'UnitType',
                                      index,
                                      newValue
                                    );
                                  }}
                                  // sx={{ marginLeft: 1 }}
                                  renderInput={params => (
                                    <TextField
                                      fullWidth
                                      onKeyDown={e => {
                                        if (
                                          e.key === 'Tab' &&
                                          unitTypeHoveredValue
                                        ) {
                                          // e.preventDefault(); // prevent the default Tab behavior
                                          handleDimensionsInputChange(
                                            'UnitType',
                                            e,
                                            unitTypeHoveredValue
                                          );
                                        }
                                      }}
                                      // type='number'
                                      // sx={{ width: 120 }}
                                      // sx={
                                      //   shipTypeValue === 'LTL'
                                      //     ? { width: 120 }
                                      //     : { width: 190 }
                                      // }
                                      variant='outlined'
                                      {...params}
                                      InputProps={{
                                        style: { fontSize: 12, height: 32 },
                                        ...params.InputProps
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} md={3} lg={4} xl={4}>
                                <Grid container>
                                  <Grid
                                    item
                                    xs={shipTypeValue !== 'Parcel' ? 4 : 6}
                                    sm={shipTypeValue !== 'Parcel' ? 4 : 6}
                                    md={shipTypeValue !== 'Parcel' ? 4 : 6}
                                    lg={shipTypeValue !== 'Parcel' ? 4 : 6}
                                    xl={shipTypeValue !== 'Parcel' ? 4 : 6}
                                  >
                                    <Label
                                      style={
                                        shipTypeValue === 'Parcel'
                                          ? {
                                              margin: '10px 0px 6px 0px',
                                              fontWeight: 700,
                                              fontSize: 12
                                            }
                                          : {
                                              margin: '6px 0px 6px 0px',
                                              fontWeight: 700,
                                              fontSize: 12
                                            }
                                      }
                                    >
                                      # of Units
                                    </Label>
                                  </Grid>

                                  <Grid
                                    item
                                    xs={shipTypeValue === 'LTL' ? 8 : 6}
                                    sm={shipTypeValue === 'LTL' ? 8 : 6}
                                    md={shipTypeValue === 'LTL' ? 8 : 6}
                                    lg={shipTypeValue === 'LTL' ? 8 : 6}
                                    xl={shipTypeValue === 'LTL' ? 8 : 6}
                                  >
                                    <Label
                                      style={
                                        shipTypeValue === 'Parcel'
                                          ? {
                                              margin: '10px 0px 6px 0px',
                                              fontWeight: 700,
                                              fontSize: 12
                                            }
                                          : {
                                              margin: '6px 0px 6px 0px',
                                              fontWeight: 700,
                                              fontSize: 12
                                            }
                                      }
                                    >
                                      # of Pieces
                                    </Label>
                                  </Grid>
                                </Grid>
                                <Grid
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                  }}
                                >
                                  <TextField
                                    fullWidth
                                    error={Boolean(
                                      validationErrors[`numberOfUnits${index}`]
                                    )}
                                    helperText={
                                      validationErrors[`numberOfUnits${index}`]
                                    }
                                    FormHelperTextProps={{
                                      style: {
                                        whiteSpace: 'nowrap',
                                        margin: '0 0 -15 0'
                                      }
                                    }}
                                    value={formatNumberWithCommas(
                                      items.NmbOfUnits
                                    )}
                                    onChange={e =>
                                      handleDimensionsInputChange(
                                        'NmbOfUnits',
                                        index,
                                        e
                                      )
                                    }
                                    size='small'
                                    sx={
                                      isMobile
                                        ? {
                                            '& input[type=number]::-webkit-outer-spin-button':
                                              {
                                                ...spinnerStyles
                                              },
                                            '& input[type=number]::-webkit-inner-spin-button':
                                              {
                                                ...spinnerStyles
                                              }
                                          }
                                        : {}
                                    }
                                    type='text'
                                    inputProps={{
                                      style: {
                                        height: 15,
                                        fontSize: 12
                                      },
                                      min: 0
                                    }}
                                  />

                                  <TextField
                                    fullWidth
                                    error={Boolean(
                                      validationErrors[`numberOfPieces${index}`]
                                    )}
                                    helperText={
                                      validationErrors[`numberOfPieces${index}`]
                                    }
                                    FormHelperTextProps={{
                                      style: {
                                        whiteSpace: 'nowrap',
                                        margin: '0 0 -15 0'
                                      }
                                    }}
                                    value={formatNumberWithCommas(items.Pieces)}
                                    onChange={e =>
                                      handleDimensionsInputChange(
                                        'Pieces',
                                        index,
                                        e
                                      )
                                    }
                                    size='small'
                                    sx={
                                      isMobile
                                        ? {
                                            '& input[type=number]::-webkit-outer-spin-button':
                                              {
                                                ...spinnerStyles
                                              },
                                            '& input[type=number]::-webkit-inner-spin-button':
                                              {
                                                ...spinnerStyles
                                              }
                                          }
                                        : { ml: 1 }
                                    }
                                    type='text'
                                    inputProps={{
                                      style: {
                                        height: 15,
                                        fontSize: 12
                                      },
                                      min: 0
                                    }}
                                  />

                                  {shipTypeValue !== 'Parcel' && (
                                    <>
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            sx={{ ml: 2 }}
                                            checked={items.StackAble}
                                            value={items.StackAble}
                                            onChange={(e, c) =>
                                              // handlePickUpServicesChange('Stackable')
                                              handleDimensionsInputChange(
                                                'Stackable',
                                                index,
                                                c
                                              )
                                            }
                                            color='primary'
                                            name='Stackable'
                                          />
                                        }
                                      />
                                      <Typography
                                        style={{
                                          margin: '0 0 0 -20',
                                          fontSize: 12,
                                          // whiteSpace: 'nowrap',
                                          fontWeight: 700
                                        }}
                                      >
                                        Stackable
                                      </Typography>
                                    </>
                                  )}
                                </Grid>
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={3}
                                lg={shipTypeValue === 'Parcel' ? 4 : 3}
                                xl={shipTypeValue === 'Parcel' ? 4 : 3}
                              >
                                <Label
                                  style={{
                                    margin: '10px 0px 6px 0px',
                                    fontWeight: 700,
                                    fontSize: 12
                                  }}
                                >
                                  Dimensions
                                </Label>
                                <Grid sx={{ display: 'flex' }}>
                                  <TextField
                                    fullWidth
                                    error={Boolean(
                                      validationErrors['PlengthError']
                                    )}
                                    helperText={
                                      validationErrors['PlengthError']
                                    }
                                    FormHelperTextProps={{
                                      style: {
                                        whiteSpace: 'nowrap',
                                        margin: '0 0 -10 0'
                                      }
                                    }}
                                    value={
                                      items.Length
                                        ? formatNumberWithCommas(items.Length)
                                        : ''
                                    }
                                    onChange={e =>
                                      handleDimensionsInputChange(
                                        'Length',
                                        index,
                                        e
                                      )
                                    }
                                    type='text'
                                    onKeyPress={handleKeyPress}
                                    // className='inputRounded_Length'
                                    size='small'
                                    // sx={{ width: 95 }}
                                    label='L'
                                    className={classes.input}
                                    // autoComplete='current-password'
                                    // value={'L'}
                                    InputLabelProps={{
                                      style: { fontSize: 11 }
                                    }}
                                    inputProps={{
                                      style: {
                                        height: 15,
                                        fontSize: 12,
                                        textAlign: 'center'
                                      }
                                    }}
                                  />
                                  <TextField
                                    fullWidth
                                    error={Boolean(
                                      validationErrors['PwidthError']
                                    )}
                                    helperText={validationErrors['PwidthError']}
                                    FormHelperTextProps={{
                                      style: {
                                        whiteSpace: 'nowrap',
                                        margin: '0 0 -10 0'
                                      }
                                    }}
                                    value={
                                      items.Width
                                        ? formatNumberWithCommas(items.Width)
                                        : ''
                                    }
                                    onChange={e =>
                                      handleDimensionsInputChange(
                                        'Width',
                                        index,
                                        e
                                      )
                                    }
                                    type='text'
                                    onKeyPress={handleKeyPress}
                                    // className='inputRounded_Width'
                                    className={classes.input}
                                    size='small'
                                    // sx={{ width: 95 }}
                                    label='W'
                                    // value={'W'}
                                    InputLabelProps={{
                                      style: { fontSize: 11 }
                                    }}
                                    inputProps={{
                                      style: {
                                        height: 15,
                                        fontSize: 12,
                                        textAlign: 'center'
                                      }
                                    }}
                                  />
                                  <TextField
                                    fullWidth
                                    error={Boolean(
                                      validationErrors['PheightError']
                                    )}
                                    helperText={
                                      validationErrors['PheightError']
                                    }
                                    FormHelperTextProps={{
                                      style: {
                                        whiteSpace: 'nowrap',
                                        margin: '0 0 -10 0'
                                      }
                                    }}
                                    value={
                                      items.Height
                                        ? formatNumberWithCommas(items.Height)
                                        : ''
                                    }
                                    onChange={e =>
                                      handleDimensionsInputChange(
                                        'Height',
                                        index,
                                        e
                                      )
                                    }
                                    type='text'
                                    onKeyPress={handleKeyPress}
                                    className={classes.input}
                                    // className='inputRounded_Height'
                                    size='small'
                                    // sx={{ width: 95 }}
                                    label='H'
                                    // value={'H'}
                                    InputLabelProps={{
                                      style: { fontSize: 11 }
                                    }}
                                    inputProps={{
                                      style: {
                                        height: 15,
                                        fontSize: 12,
                                        textAlign: 'center'
                                      }
                                    }}
                                  />
                                </Grid>
                              </Grid>
                              <Grid
                                md={12}
                                lg={12}
                                xl={12}
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {items.TotalVolume && (
                                  <Grid
                                    container
                                    spacing={0.5}
                                    sx={{
                                      minWidth: '50%',
                                      mt: 0.5,
                                      p: 0.5,
                                      borderRadius: 1
                                    }}
                                  >
                                    {items.TotalVolume && (
                                      <Grid item xs={4}>
                                        <Box
                                          sx={{
                                            backgroundColor: '#e3f2fd',
                                            px: 1,
                                            py: 0.5,
                                            borderRadius: 1,
                                            textAlign: 'center'
                                          }}
                                        >
                                          <Typography
                                            variant='caption'
                                            sx={{
                                              fontSize: '11px',
                                              color: '#1976d2'
                                            }}
                                          >
                                            <strong>Total Volume:</strong>{' '}
                                            {items.TotalVolume} ft³
                                          </Typography>
                                        </Box>
                                      </Grid>
                                    )}

                                    {items.density && (
                                      <Grid item xs={4}>
                                        <Box
                                          sx={{
                                            backgroundColor: '#fff3e0',
                                            px: 1,
                                            py: 0.5,
                                            borderRadius: 1,
                                            textAlign: 'center'
                                          }}
                                        >
                                          <Typography
                                            variant='caption'
                                            sx={{
                                              fontSize: '11px',
                                              color: '#f57c00'
                                            }}
                                          >
                                            <strong>Density:</strong>{' '}
                                            {items.density} lbs/ft³
                                          </Typography>
                                        </Box>
                                      </Grid>
                                    )}

                                    {items.estimatedFreightClass && (
                                      <Grid item xs={4}>
                                        <Box
                                          sx={{
                                            backgroundColor: '#e8f5e9',
                                            px: 1,
                                            py: 0.5,
                                            borderRadius: 1,
                                            textAlign: 'center'
                                          }}
                                        >
                                          <Typography
                                            variant='caption'
                                            sx={{
                                              fontSize: '11px',
                                              color: '#2e7d32'
                                            }}
                                          >
                                            <strong>
                                              Estimated Freight Class :
                                            </strong>{' '}
                                            {items.estimatedFreightClass}
                                          </Typography>
                                        </Box>
                                      </Grid>
                                    )}
                                  </Grid>
                                )}
                                <Typography
                                  style={{
                                    minWidth: items.density ? '50%' : '100%',
                                    fontSize: 12,
                                    fontWeight: 'bold',
                                    color: '#1976d2',
                                    display: 'flex',
                                    justifyContent: 'flex-end'
                                    // margin: '8 0 10 -60'
                                  }}
                                >
                                  <u>
                                    {index + 1 === arr.length && (
                                      <span>
                                        Total Shipment Weight{' '}
                                        {totalDimensionsWeightSum > 0 &&
                                          formatNumberWithCommas(
                                            totalDimensionsWeightSum
                                          )}{' '}
                                        (lbs)
                                      </span>
                                    )}
                                  </u>
                                </Typography>
                              </Grid>
                            </>
                          ) : (
                            <>
                              <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                                <Label
                                  style={{
                                    margin: '10px 0px 6px 0px',
                                    fontWeight: 700,
                                    fontSize: 12,
                                    whiteSpace: 'nowrap'
                                  }}
                                >
                                  Gross Weight (lbs)
                                </Label>
                                <TextField
                                  fullWidth
                                  className={classes.inputRoot}
                                  // inputRef={enterWeight}
                                  // error={Boolean(
                                  //   validationErrors['newAddedDimensionsRow']
                                  // )}
                                  // helperText={
                                  //   validationErrors['newAddedDimensionsRow']
                                  // }
                                  FormHelperTextProps={{
                                    style: {
                                      whiteSpace: 'nowrap',
                                      margin: '0 0 0 0'
                                    }
                                  }}
                                  // value={grossWeight}
                                  // onChange={e => setGrossWeight(e.target.value)}
                                  value={formatNumberWithCommas(
                                    items.GrossWeight
                                  )}
                                  onChange={e =>
                                    handleDimensionsInputChange(
                                      'GrossWeight',
                                      index,
                                      e
                                    )
                                  }
                                  size='small'
                                  // sx={{ ml: 0.5 }}
                                  // sx={
                                  //   shipTypeValue === 'LTL'
                                  //     ? { width: 100 }
                                  //     : { width: 190 }
                                  // }
                                  // id='outlined-password-input'
                                  type='text'
                                  // autoComplete='current-password'
                                  InputLabelProps={{
                                    style: { fontSize: 12 }
                                  }}
                                  InputProps={{
                                    // min: 0,
                                    style: {
                                      height: 32,
                                      fontSize: 12
                                    }
                                  }}
                                />
                              </Grid>

                              <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                <Label
                                  style={{
                                    margin: '10px 0px 6px 0px',
                                    fontWeight: 700,
                                    fontSize: 12
                                  }}
                                >
                                  {shipTypeValue === 'TL'
                                    ? 'Handling Units'
                                    : 'Packaging Type'}
                                </Label>
                                <Autocomplete
                                  // onHighlightChange={(event, option) => {
                                  //   setUnitTypeHoveredValue(option);
                                  // }}
                                  disableClearable
                                  fullWidth
                                  onBlur={() => {
                                    if (unitTypeHoveredValue) {
                                      handleDimensionsInputChange(
                                        'UnitType',
                                        index,
                                        unitTypeHoveredValue
                                      );
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <Box style={{ fontSize: 13 }} {...props}>
                                      {option}
                                    </Box>
                                  )}
                                  // sx={{ m: 1 }}
                                  size='small'
                                  options={
                                    shipTypeValue === 'Parcel'
                                      ? ParcelUnitTypeArr
                                      : LTLUnitTypeArr
                                  }
                                  value={
                                    // shipTypeValue === 'Parcel'
                                    //   ? ParcelUnitTypeArr[0]
                                    //   :
                                    items.UnitTypeValue
                                  }
                                  onChange={(event, newValue) => {
                                    handleDimensionsInputChange(
                                      'UnitType',
                                      index,
                                      newValue
                                    );
                                  }}
                                  onInputChange={(event, newValue) => {
                                    handleDimensionsInputChange(
                                      'UnitType',
                                      index,
                                      newValue
                                    );
                                  }}
                                  // sx={{ marginLeft: 1 }}
                                  renderInput={params => (
                                    <TextField
                                      fullWidth
                                      onKeyDown={e => {
                                        if (
                                          e.key === 'Tab' &&
                                          unitTypeHoveredValue
                                        ) {
                                          // e.preventDefault(); // prevent the default Tab behavior
                                          handleDimensionsInputChange(
                                            'UnitType',
                                            e,
                                            unitTypeHoveredValue
                                          );
                                        }
                                      }}
                                      // type='number'
                                      // sx={{ width: 120 }}
                                      // sx={
                                      //   shipTypeValue === 'LTL'
                                      //     ? { width: 120 }
                                      //     : { width: 190 }
                                      // }
                                      variant='outlined'
                                      {...params}
                                      InputProps={{
                                        style: { fontSize: 12, height: 32 },
                                        ...params.InputProps
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                <Label
                                  style={{
                                    margin: '10px 0px 6px 0px',
                                    fontWeight: 700,
                                    fontSize: 12
                                  }}
                                >
                                  # Handling Units
                                </Label>
                                <Grid
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                  }}
                                >
                                  <TextField
                                    fullWidth
                                    error={Boolean(
                                      validationErrors[`numberOfUnits${index}`]
                                    )}
                                    helperText={
                                      validationErrors[`numberOfUnits${index}`]
                                    }
                                    FormHelperTextProps={{
                                      style: {
                                        whiteSpace: 'nowrap',
                                        margin: '0 0 -15 0'
                                      }
                                    }}
                                    value={formatNumberWithCommas(
                                      items.NmbOfUnits
                                    )}
                                    onChange={e =>
                                      handleDimensionsInputChange(
                                        'NmbOfUnits',
                                        index,
                                        e
                                      )
                                    }
                                    size='small'
                                    sx={
                                      isMobile
                                        ? {
                                            '& input[type=number]::-webkit-outer-spin-button':
                                              {
                                                ...spinnerStyles
                                              },
                                            '& input[type=number]::-webkit-inner-spin-button':
                                              {
                                                ...spinnerStyles
                                              }
                                          }
                                        : {}
                                    }
                                    type='text'
                                    inputProps={{
                                      style: {
                                        height: 15,
                                        fontSize: 12
                                      },
                                      min: 0
                                    }}
                                  />
                                </Grid>
                              </Grid>
                              <Grid
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mt: 4
                                }}
                                item
                                xs={12}
                                sm={12}
                                md={2}
                                lg={2.5}
                                xl={2.5}
                              >
                                <Chip
                                  variant='outlined'
                                  sx={{
                                    width: '100%',
                                    borderRadius: '0.5'
                                    // mt: 4
                                  }}
                                  fullWidth
                                  label={
                                    <FormControlLabel
                                      fullWidth
                                      control={
                                        <Switch
                                          sx={{ ml: 2 }}
                                          checked={items.StackAble}
                                          value={items.StackAble}
                                          onChange={(e, c) =>
                                            // handlePickUpServicesChange('Stackable')
                                            handleDimensionsInputChange(
                                              'Stackable',
                                              index,
                                              c
                                            )
                                          }
                                          color='primary'
                                          name='Stackable'
                                        />
                                      }
                                      label={
                                        <Typography
                                          style={{
                                            fontSize: 12,
                                            fontWeight: 700
                                          }}
                                        >
                                          Stackable
                                        </Typography>
                                      }
                                    />
                                  }
                                />
                              </Grid>
                            </>
                          )}
                        </Grid>
                      ))
                    )}
                  </>
                </CardContent>
                <CardActions
                  sx={{
                    display: 'flex',
                    justifyContent: shipTypeValue !== 'TL' ? 'center' : 'end',
                    width: '100%',
                    padding: 0
                  }}
                >
                  <div
                    style={
                      shipTypeValue !== 'TL'
                        ? {
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center'
                          }
                        : {
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'end'
                          }
                    }
                  >
                    {shipTypeValue === 'TL' && isFormDirty() && (
                      <Button
                        style={
                          isMobile
                            ? { width: '100%', margin: 7 }
                            : { margin: 5 }
                        }
                        // size='sm'
                        // color='danger'
                        size='small'
                        variant='contained'
                        color='error'
                        onClick={() => handleClearForm()}
                      >
                        Clear Form
                      </Button>
                    )}
                    <Button
                      style={
                        isMobile ? { width: '100%', margin: 7 } : { margin: 5 }
                      }
                      // type='submit'
                      // size='small'
                      variant='contained'
                      disabled={ratesDisable}
                      onClick={e => handleGetRates(e)}
                      // variant='contained'
                      // color='Blue'
                      // size={isMobile ? 'sm' : ''}
                    >
                      {getRateLoading ? 'Loading ...' : 'Get Rates'}
                    </Button>
                  </div>
                </CardActions>
              </Card>
            </Paper>
          </Grid>
        </Grid>
        {/* )} */}
      </div>
    </div>
  );
}

export default QuickQuote;
